import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  GenericScalar: any,
  JSON: any,
  LoyaltyID: any,
  LoyaltyJSON: any,
}

export interface IAccount {
  readonly __typename?: 'Account',
  readonly accountIdentifier: Maybe<Scalars['String']>,
  readonly orbitalIdentifier: Maybe<Scalars['String']>,
  readonly fdAccountId: Maybe<Scalars['String']>,
  readonly chaseProfileId: Maybe<Scalars['String']>,
  readonly credit: Maybe<ICreditCard>,
  readonly prepaid: Maybe<IGiftCard>,
  readonly paypal: Maybe<Scalars['Boolean']>,
  readonly paypalIdentifier: Maybe<Scalars['String']>,
}

export interface IAccountListResponse {
  readonly __typename?: 'AccountListResponse',
  readonly count: Scalars['Int'],
  readonly accounts: Maybe<ReadonlyArray<Maybe<IAccount>>>,
  readonly defaultAccount: Maybe<IAccount>,
  readonly paymentProcessor: Maybe<PaymentProcessor>,
}

export interface IActivateAlohaRewardResponse {
  readonly __typename?: 'ActivateAlohaRewardResponse',
  readonly rewardSanityId: Scalars['String'],
  readonly rewardCategorySanityId: Scalars['String'],
  readonly rewardPointCost: Scalars['Int'],
  readonly alohaRewardBonusPlanId: Scalars['Int'],
  readonly userPointBalance: Scalars['Int'],
}

export interface IAddAccountInput {
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  readonly fdAccessToken: Scalars['String'],
  readonly fdNonce: Scalars['String'],
  readonly ccBin: Scalars['String'],
  readonly fullName?: Maybe<Scalars['String']>,
  readonly ccToken?: Maybe<Scalars['String']>,
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  readonly cvv?: Maybe<Scalars['String']>,
  readonly sessionId?: Maybe<Scalars['String']>,
  readonly makeDefault?: Maybe<Scalars['Boolean']>,
  readonly threeDSOptions?: Maybe<IThreeDsOptions>,
}

export interface IAddAdyenAccountInput {
  readonly encryptedPayload: IAdyenEncryptedInfo,
}

export interface IAddCreditAccountInput {
  readonly adyenInput?: Maybe<IAddAdyenAccountInput>,
  readonly billingAddress: IBillingAddressInput,
  readonly firstDataInput?: Maybe<IAddAccountInput>,
  readonly orbitalInput?: Maybe<IAddOrbitalAccountInput>,
  readonly fullName: Scalars['String'],
  readonly makeDefault?: Maybe<Scalars['Boolean']>,
}

export interface IAddGiftAccountInput {
  readonly fundValue: Scalars['Int'],
  readonly fdAccountId?: Maybe<Scalars['String']>,
  readonly applePayDetails?: Maybe<IApplePay>,
  readonly googlePayDetails?: Maybe<IGooglePay>,
  readonly kountSessionId?: Maybe<Scalars['String']>,
  readonly sessionId?: Maybe<Scalars['String']>,
}

export interface IAddOrbitalAccountInput {
  readonly encryptedCardNum: Scalars['String'],
  readonly encryptedCvv: Scalars['String'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly pieFormat: Scalars['String'],
  readonly pieMode: Scalars['String'],
  readonly piePhaseId: Scalars['String'],
  readonly pieIntegrityCheck: Scalars['String'],
  readonly pieSubscriberId: Scalars['String'],
  readonly pieKeyID: Scalars['String'],
  readonly cardBrand: Scalars['String'],
  readonly bin: Scalars['String'],
}

export interface IAddPaymentMethodInput {
  readonly currency?: Maybe<Scalars['String']>,
  readonly paymentMethods: Scalars['String'],
  readonly billingAddress: IPaymentBillingAddressInput,
}

export type IAddPaymentMethodPayload = IAddPaymentMethodSuccess | IThreeDsChallenge | IThreeDsFrictionless;

export interface IAddPaymentMethodSuccess {
  readonly __typename?: 'AddPaymentMethodSuccess',
  readonly storedPaymentMethod: IStoredPaymentMethod,
}

export interface IAdyenEncryptedInfo {
  readonly encryptedCN: Scalars['String'],
  readonly encryptedEM: Scalars['String'],
  readonly encryptedEY: Scalars['String'],
  readonly encryptedSC: Scalars['String'],
}

export interface IAdyenPayment {
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  readonly encryptedPayload?: Maybe<IAdyenEncryptedInfo>,
  readonly paymentType?: Maybe<AdyenPaymentType>,
  readonly savePaymentMethod?: Maybe<Scalars['Boolean']>,
}

export enum AdyenPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  TOKENIZED_CREDIT_CARD = 'TOKENIZED_CREDIT_CARD'
}

export interface IAlohaActiveReward {
  readonly __typename?: 'AlohaActiveReward',
  readonly pointCost: Scalars['Int'],
  readonly rewardsCount: Scalars['Int'],
  readonly sanityId: Scalars['String'],
}

export interface IApiMetadata {
  readonly __typename?: 'ApiMetadata',
  readonly ping: Scalars['String'],
}

export interface IApplePay {
  readonly signature: Scalars['String'],
  readonly applicationData: Scalars['String'],
  readonly country: CountryCode,
  readonly data: Scalars['String'],
  readonly decryptAlias: Scalars['String'],
  readonly ephemeralPublicKey: Scalars['String'],
  readonly formatted: Scalars['String'],
  readonly primary: Scalars['Boolean'],
  readonly publicKeyHash: Scalars['String'],
  readonly transactionId: Scalars['String'],
  readonly type: Scalars['String'],
  readonly version: Scalars['String'],
  readonly billingAddress: IBillingAddressInput,
  readonly paymentData?: Maybe<Scalars['String']>,
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>,
}

export interface IApplePayPaymentConfig {
  readonly __typename?: 'ApplePayPaymentConfig',
  readonly schemeMerchantId: Maybe<Scalars['String']>,
  readonly prepaidMerchantId: Maybe<Scalars['String']>,
}

export interface IAppliedOffer {
  readonly id?: Maybe<Scalars['ID']>,
  readonly cartId?: Maybe<Scalars['ID']>,
  readonly sanityId?: Maybe<Scalars['ID']>,
  readonly swap?: Maybe<ISwapInput>,
  readonly type?: Maybe<OfferType>,
}

export interface IAppliedReward {
  readonly cartId: Scalars['ID'],
  readonly rewardId: Scalars['ID'],
  readonly sanityId?: Maybe<Scalars['ID']>,
  readonly timesApplied: Scalars['Int'],
}

export interface IAssociateGuestUserResponse {
  readonly __typename?: 'AssociateGuestUserResponse',
  readonly guestBalance: Scalars['Int'],
  readonly activationDateTime: Scalars['String'],
  readonly linkingDateTime: Scalars['String'],
  readonly totalBalance: Scalars['Int'],
}

export interface IBalance {
  readonly __typename?: 'Balance',
  readonly alias: Scalars['String'],
  readonly beginBalance: Scalars['Int'],
  readonly currencyCode: Scalars['String'],
  readonly currentBalance: Scalars['Int'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly fdCorrelationId: Maybe<Scalars['String']>,
}

export interface IBaseIncentive {
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>,
  readonly id: Scalars['ID'],
  readonly maxRedemptionsDuration: Maybe<DurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<PaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<BirthdayDuration>,
  readonly userEnrollment: Maybe<IDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<DayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<ServiceMode>>>,
  readonly storeRestrictions: Maybe<IStoreRestrictions>,
  readonly errors: Maybe<ReadonlyArray<IRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IBenefit {
  readonly type: BenefitType,
}

export interface IBenefitReference  extends IBenefit {
  readonly __typename?: 'BenefitReference',
  readonly type: BenefitType,
  readonly value: Scalars['String'],
}

export interface IBenefitSwap  extends IBenefit {
  readonly __typename?: 'BenefitSwap',
  readonly type: BenefitType,
  readonly value: ISwap,
}

export enum BenefitType {
  REFERENCE = 'REFERENCE',
  SWAP = 'SWAP'
}

export interface IBillingAddress {
  readonly __typename?: 'BillingAddress',
  readonly locality: Scalars['String'],
  readonly postalCode: Scalars['String'],
  readonly region: Scalars['String'],
  readonly streetAddress: Scalars['String'],
  readonly unitNumber: Maybe<Scalars['String']>,
  readonly country: Maybe<Scalars['String']>,
}

export interface IBillingAddressInput {
  readonly locality?: Maybe<Scalars['String']>,
  readonly postalCode: Scalars['String'],
  readonly region?: Maybe<Scalars['String']>,
  readonly streetAddress?: Maybe<Scalars['String']>,
  readonly unitNumber?: Maybe<Scalars['String']>,
  readonly country?: Maybe<Scalars['String']>,
}

export enum BirthdayDuration {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH'
}

export enum Brand {
  BK = 'BK',
  LTW = 'LTW',
  PLK = 'PLK',
  TH = 'TH',
  FHS = 'FHS'
}

export interface IBrazeUserPhone {
  readonly __typename?: 'BrazeUserPhone',
  readonly phone: Maybe<Scalars['String']>,
}

export enum CacheControlScope {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export interface ICalories {
  readonly __typename?: 'Calories',
  readonly default: Maybe<Scalars['Int']>,
  readonly max: Maybe<Scalars['Int']>,
  readonly min: Maybe<Scalars['Int']>,
}

export enum CardBrand {
  VISA = 'VISA',
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  DINERS_CLUB = 'DINERS_CLUB',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD'
}

export interface ICart {
  readonly __typename?: 'Cart',
  readonly brand: Brand,
  readonly cartEntries: Maybe<ReadonlyArray<ICartEntries>>,
  readonly reorderCartEntries: Maybe<ReadonlyArray<ICartEntries>>,
  readonly cartVersion: Maybe<Scalars['Int']>,
  readonly customerLocale: Maybe<Scalars['String']>,
  readonly customerName: Scalars['String'],
  readonly deviceOS: Maybe<Scalars['String']>,
  readonly discounts: Maybe<ReadonlyArray<Maybe<IDiscount>>>,
  readonly donations: Maybe<ReadonlyArray<Maybe<IDonation>>>,
  readonly fees: Maybe<ReadonlyArray<Maybe<IFees>>>,
  readonly offersFeedback: Maybe<ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>>,
  readonly payment: Maybe<IPayment>,
  readonly platform: Maybe<Platform>,
  readonly posVendor: PosVendor,
  readonly processedAt: Maybe<Scalars['String']>,
  readonly appliedOffers: Maybe<ReadonlyArray<Maybe<ICartAppliedOffer>>>,
  readonly requestedAmountCents: Scalars['Int'],
  readonly rewardsApplied: Maybe<ReadonlyArray<Maybe<ICartAppliedReward>>>,
  readonly serviceMode: ServiceMode,
  readonly storeAddress: IStoreAddress,
  readonly storeDetails: Maybe<IStoreDetails>,
  readonly storeId: Scalars['String'],
  readonly storePosId: Maybe<Scalars['String']>,
  readonly swaps: Maybe<ReadonlyArray<Maybe<ICartSwap>>>,
  readonly subTotalCents: Maybe<Scalars['Int']>,
  readonly taxCents: Maybe<Scalars['Int']>,
  readonly ticketNumber: Maybe<Scalars['String']>,
  readonly totalCents: Maybe<Scalars['Int']>,
  readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<IUnavailableCartEntry>>>,
  readonly userDetails: Maybe<IUserDetails>,
  readonly userId: Maybe<Scalars['String']>,
  readonly wasLoyaltyEarned: Maybe<Scalars['Boolean']>,
  readonly vatNumber: Maybe<Scalars['String']>,
}

export interface ICartAppliedOffer {
  readonly __typename?: 'CartAppliedOffer',
  readonly id: Scalars['ID'],
  readonly cartId: Maybe<Scalars['ID']>,
  readonly sanityId: Maybe<Scalars['ID']>,
  readonly swap: Maybe<ICartSwap>,
  readonly type: OfferType,
}

export interface ICartAppliedReward {
  readonly __typename?: 'CartAppliedReward',
  readonly cartId: Scalars['ID'],
  readonly rewardId: Scalars['ID'],
  readonly sanityId: Maybe<Scalars['ID']>,
  readonly timesApplied: Scalars['Int'],
}

export interface ICartDiscount {
  readonly __typename?: 'CartDiscount',
  readonly type: CartDiscountType,
  readonly value: Scalars['Float'],
}

export interface ICartDiscountInput {
  readonly type: CartDiscountType,
  readonly value: Scalars['Float'],
}

export enum CartDiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export interface ICartEntries {
  readonly __typename?: 'CartEntries',
  readonly children: Maybe<ReadonlyArray<Maybe<ICartEntries>>>,
  readonly image: Maybe<Scalars['String']>,
  readonly lineId: Scalars['String'],
  readonly name: Maybe<Scalars['String']>,
  readonly offerVendorConfigs: Maybe<IVendorConfigs>,
  readonly pickerSelections: Maybe<Scalars['String']>,
  readonly plu: Maybe<IPlu>,
  readonly price: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly redeemable: Maybe<Scalars['Boolean']>,
  readonly isExtra: Maybe<Scalars['Boolean']>,
  readonly isInMenu: Maybe<Scalars['Boolean']>,
  readonly isDonation: Maybe<Scalars['Boolean']>,
  readonly sanityId: Scalars['String'],
  readonly type: CartEntryType,
  readonly url: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface ICartEntryInput {
  readonly children?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly image?: Maybe<Scalars['String']>,
  readonly lineId: Scalars['String'],
  readonly name?: Maybe<Scalars['String']>,
  readonly pickerSelections?: Maybe<Scalars['String']>,
  readonly price?: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly sanityId: Scalars['String'],
  readonly type: CartEntryType,
  readonly isExtra?: Maybe<Scalars['Boolean']>,
  readonly isDonation?: Maybe<Scalars['Boolean']>,
  readonly url?: Maybe<Scalars['String']>,
  readonly offerVendorConfigs?: Maybe<IVendorConfigsInput>,
  readonly plu?: Maybe<IPluInput>,
  readonly vendorConfigs?: Maybe<IVendorConfigsInput>,
  readonly productHierarchy?: Maybe<IProductHierarchyInput>,
  readonly markerItemPlu?: Maybe<Scalars['String']>,
}

export enum CartEntryType {
  COMBO = 'Combo',
  COMBOSLOT = 'ComboSlot',
  ITEM = 'Item',
  ITEMOPTION = 'ItemOption',
  ITEMOPTIONMODIFIER = 'ItemOptionModifier',
  OFFERCOMBO = 'OfferCombo',
  OFFERDISCOUNT = 'OfferDiscount',
  OFFERITEM = 'OfferItem'
}

export enum CartOfferState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  INACTIVE = 'INACTIVE'
}

export enum CartPaymentCardType {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERS = 'DINERS',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
  GIFT_CARD = 'GIFT_CARD',
  PAYPAL = 'PAYPAL'
}

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT'
}

export interface ICartRequirement {
  readonly __typename?: 'CartRequirement',
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
}

export interface ICartSwap {
  readonly __typename?: 'CartSwap',
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly cartId: Scalars['String'],
  readonly swapType: Scalars['String'],
}

export interface ICatering {
  readonly __typename?: 'Catering',
  readonly declineReason: Maybe<CateringDeclineReasons>,
  readonly notes: Maybe<Scalars['String']>,
  readonly pickupTime: Scalars['String'],
}

export enum CateringDecision {
  ACCEPT = 'Accept',
  DECLINE = 'Decline'
}

export enum CateringDeclineReasons {
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVENTORY = 'INVENTORY',
  STAFFING = 'STAFFING',
  TIMING = 'TIMING'
}

export interface ICateringInfoInput {
  readonly pickupTime: Scalars['String'],
}

export interface ICbaCouponResponse  extends ICouponResponse {
  readonly __typename?: 'CBACouponResponse',
  readonly code: Scalars['String'],
  readonly isValid: Scalars['Boolean'],
  readonly message: Scalars['String'],
  readonly reason: Maybe<Scalars['String']>,
  readonly isRedeemed: Maybe<Scalars['Boolean']>,
  readonly shouldRedeem: Maybe<Scalars['Boolean']>,
  readonly offerId: Maybe<Scalars['String']>,
}

export interface ICbaRedeemCouponResponse  extends IRedeemedCouponResponse {
  readonly __typename?: 'CBARedeemCouponResponse',
  readonly code: Scalars['String'],
  readonly isRedeemed: Scalars['Boolean'],
  readonly offerId: Maybe<Scalars['String']>,
  readonly message: Maybe<Scalars['String']>,
  readonly reason: Maybe<Scalars['String']>,
}

export enum Channel {
  WHITELABEL = 'whitelabel',
  GFO = 'gfo',
  CATERING = 'catering',
  WAITR = 'waitr',
  SKIP = 'skip',
  UBER = 'uber',
  BITENINJA = 'biteninja',
  DOORDASH = 'doordash',
  GRUBHUB = 'grubhub'
}

export interface ICognitoCredentials {
  readonly __typename?: 'CognitoCredentials',
  readonly sessionId: Scalars['String'],
  readonly challengeCode: Scalars['String'],
  readonly email: Maybe<Scalars['String']>,
}

export interface ICommitDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>,
  readonly pushNotification?: Maybe<Scalars['Boolean']>,
  readonly tipCents?: Maybe<Scalars['Int']>,
  readonly dropOff?: Maybe<IDeliveryWaypointInput>,
  readonly dropoff?: Maybe<IDeliveryWaypointInput>,
}

export interface ICommitOrderInput {
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  readonly ccBin?: Maybe<Scalars['String']>,
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  readonly ccLast4?: Maybe<Scalars['String']>,
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  readonly creditType?: Maybe<CartPaymentCardType>,
  readonly storeEmail?: Maybe<Scalars['String']>,
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  readonly fdNonce?: Maybe<Scalars['String']>,
  readonly fdAccountId?: Maybe<Scalars['String']>,
  readonly fireOrderIn?: Maybe<Scalars['Int']>,
  readonly fullName?: Maybe<Scalars['String']>,
  readonly payment?: Maybe<IPaymentInput>,
  readonly rbiOrderId: Scalars['ID'],
  readonly kountSessionId?: Maybe<Scalars['String']>,
  readonly sessionId?: Maybe<Scalars['String']>,
  readonly redeemedOn?: Maybe<Scalars['String']>,
  readonly applePayDetails?: Maybe<IApplePay>,
  readonly googlePayDetails?: Maybe<IGooglePay>,
  readonly threeDSDetails?: Maybe<IResumeThreeDSaleTransaction>,
}

export interface ICommunicationPreference {
  readonly __typename?: 'CommunicationPreference',
  readonly id: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['String']>,
}

export interface IConfirmCateringOrderInput {
  readonly cateringJwt: Scalars['String'],
  readonly decision: CateringDecision,
  readonly declineReason?: Maybe<CateringDeclineReasons>,
}

export interface IConnection {
  readonly edges: ReadonlyArray<IEdge>,
  readonly nodes: ReadonlyArray<INode>,
  readonly pageInfo: IPageInfo,
  readonly totalCount: Maybe<Scalars['Int']>,
}

export interface ICoordinates {
  readonly userLat?: Maybe<Scalars['Float']>,
  readonly userLng?: Maybe<Scalars['Float']>,
  readonly searchRadius?: Maybe<Scalars['Float']>,
}

export enum CountryCode {
  CA = 'CA',
  CH = 'CH',
  GB = 'GB',
  US = 'US',
  ZA = 'ZA'
}

export interface ICoupon {
  readonly __typename?: 'Coupon',
  readonly couponId: Scalars['ID'],
  readonly createdAt: Scalars['String'],
  readonly expiresOn: Maybe<Scalars['String']>,
  readonly pk: Scalars['String'],
  readonly redeemedOn: Maybe<Scalars['String']>,
  readonly revision: Scalars['Int'],
  readonly sk: Scalars['String'],
  readonly updatedAt: Scalars['String'],
  readonly userId: Scalars['ID'],
  readonly userSortKey: Scalars['String'],
}

export interface ICouponEvaluationFeedback {
  readonly __typename?: 'CouponEvaluationFeedback',
  readonly code: Scalars['String'],
  readonly condition: Scalars['Boolean'],
  readonly expiresOn: Maybe<Scalars['String']>,
  readonly message: Scalars['String'],
  readonly redeemableForSeconds: Maybe<Scalars['Int']>,
  readonly redeemableInSeconds: Maybe<Scalars['Int']>,
  readonly ruleSetIndex: Maybe<Scalars['Int']>,
  readonly ruleSetType: Scalars['String'],
  readonly sanityId: Maybe<Scalars['String']>,
}

export interface ICouponRedemptionEligibility {
  readonly __typename?: 'CouponRedemptionEligibility',
  readonly expiresOn: Maybe<Scalars['String']>,
  readonly evaluationFeedback: ReadonlyArray<Maybe<ICouponEvaluationFeedback>>,
  readonly isRedeemable: Scalars['Boolean'],
  readonly isValid: Scalars['Boolean'],
  readonly redeemedOn: Scalars['String'],
  readonly validationErrors: ReadonlyArray<Maybe<ICouponValidationError>>,
}

export interface ICouponResponse {
  readonly code: Scalars['String'],
  readonly isValid: Scalars['Boolean'],
  readonly message: Scalars['String'],
  readonly reason: Maybe<Scalars['String']>,
  readonly isRedeemed: Maybe<Scalars['Boolean']>,
  readonly shouldRedeem: Maybe<Scalars['Boolean']>,
}

export interface ICouponToken {
  readonly __typename?: 'CouponToken',
  readonly comments: Maybe<Scalars['String']>,
  readonly couponId: Scalars['ID'],
  readonly createdAt: Scalars['String'],
  readonly expiresOn: Maybe<Scalars['String']>,
  readonly reason: Maybe<Scalars['String']>,
  readonly pk: Scalars['String'],
  readonly supportCognitoId: Maybe<Scalars['String']>,
  readonly supportEmail: Maybe<Scalars['String']>,
  readonly tokenId: Scalars['ID'],
  readonly userId: Scalars['ID'],
}

export interface ICouponTokenListResponse {
  readonly __typename?: 'CouponTokenListResponse',
  readonly count: Scalars['Int'],
  readonly resumeAfter: Maybe<Scalars['String']>,
  readonly tokens: ReadonlyArray<Maybe<ICouponToken>>,
}

export interface ICouponUserOffersFeedback {
  readonly __typename?: 'CouponUserOffersFeedback',
  readonly offersFeedback: ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>,
}

export interface ICouponUserOffersFeedbackEntry {
  readonly __typename?: 'CouponUserOffersFeedbackEntry',
  readonly cartEntry: Maybe<ICartEntries>,
  readonly couponId: Scalars['String'],
  readonly isLoyalty: Maybe<Scalars['Boolean']>,
  readonly offerDetails: Maybe<Scalars['String']>,
  readonly offerState: Maybe<CartOfferState>,
  readonly offerVariables: Maybe<ReadonlyArray<Maybe<IOfferVariable>>>,
  readonly rank: Maybe<Scalars['Int']>,
  readonly redemptionEligibility: ICouponRedemptionEligibility,
  readonly tokenId: Maybe<Scalars['String']>,
}

export interface ICouponValidationError {
  readonly __typename?: 'CouponValidationError',
  readonly code: Scalars['String'],
  readonly message: Scalars['String'],
  readonly ruleSetType: Scalars['String'],
}

export interface ICreateOtp {
  readonly __typename?: 'CreateOTP',
  readonly maxLoginAttempts: Scalars['Int'],
  readonly maxValidateAttempts: Scalars['Int'],
  readonly ttl: Scalars['Int'],
  readonly redirectToUS: Maybe<Scalars['Boolean']>,
}

export interface ICreateOtpInput {
  readonly email?: Maybe<Scalars['String']>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly platform: Platform,
  readonly sessionId: Scalars['ID'],
}

export interface ICreateSmsOtp {
  readonly __typename?: 'CreateSmsOtp',
  readonly maxValidateAttempts: Scalars['Int'],
  readonly ttl: Scalars['Int'],
}

export interface ICreateSmsOtpInput {
  readonly phoneNumber: Scalars['String'],
  readonly platform: Platform,
  readonly sessionId: Scalars['ID'],
}

export interface ICreditCard {
  readonly __typename?: 'CreditCard',
  readonly alias: Scalars['String'],
  readonly billingAddress: Maybe<IBillingAddress>,
  readonly cardType: Scalars['String'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly fullName: Scalars['String'],
  readonly panToken: Maybe<Scalars['String']>,
}

export interface ICreditCardMetadataInput {
  readonly ccBin?: Maybe<Scalars['String']>,
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  readonly ccLast4?: Maybe<Scalars['String']>,
  readonly creditType?: Maybe<CartPaymentCardType>,
}

export interface ICurrencyCode {
  readonly __typename?: 'CurrencyCode',
  readonly code: Scalars['String'],
  readonly number: Scalars['Int'],
}

export interface IDateSpan {
  readonly __typename?: 'DateSpan',
  readonly endDate: Maybe<Scalars['String']>,
  readonly startDate: Maybe<Scalars['String']>,
}

export interface IDay {
  readonly __typename?: 'Day',
  readonly close: Maybe<Scalars['String']>,
  readonly open: Maybe<Scalars['String']>,
}

export enum DayOfTheWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export interface IDayPart {
  readonly __typename?: 'DayPart',
  readonly key: Maybe<Scalars['String']>,
  readonly displayName: Maybe<Scalars['String']>,
  readonly hours: Maybe<IOperatingHours>,
}

export interface IDeleteAccountInput {
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  readonly fdAccountId?: Maybe<Scalars['String']>,
}

export interface IDeletePaymentMethodInput {
  readonly storedPaymentMethodId: Scalars['String'],
}

export interface IDeletePaymentMethodPayload {
  readonly __typename?: 'DeletePaymentMethodPayload',
  readonly success: Scalars['Boolean'],
}

export interface IDelivery {
  readonly __typename?: 'Delivery',
  readonly assignedFleetName: Maybe<Scalars['String']>,
  readonly baseDeliveryFeeCents: Maybe<Scalars['Int']>,
  readonly cancellation: Maybe<IDeliveryCancellation>,
  readonly customerId: Maybe<Scalars['String']>,
  readonly driver: Maybe<IDeliveryDriver>,
  readonly dropoff: IDeliveryWaypoint,
  readonly estimateId: Maybe<Scalars['String']>,
  readonly expiration: Maybe<Scalars['String']>,
  readonly feeCents: Scalars['Int'],
  readonly feeDiscountCents: Maybe<Scalars['Int']>,
  readonly deliverySurchargeFeeCents: Maybe<Scalars['Int']>,
  readonly fleetId: Maybe<Scalars['String']>,
  readonly geographicalFeeCents: Maybe<Scalars['Int']>,
  readonly instructions: Maybe<Scalars['String']>,
  readonly pickup: IDeliveryWaypoint,
  readonly quoteId: Maybe<Scalars['String']>,
  readonly quotedFeeCents: Maybe<Scalars['Int']>,
  readonly serviceFeeCents: Maybe<Scalars['Int']>,
  readonly shareUuid: Maybe<Scalars['String']>,
  readonly smallCartFeeCents: Maybe<Scalars['Int']>,
  readonly status: DeliveryStatus,
  readonly task: Maybe<IDeliveryTaskDetails>,
  readonly tipCents: Maybe<Scalars['Int']>,
  readonly userId: Maybe<Scalars['String']>,
}

export interface IDeliveryAddress {
  readonly __typename?: 'DeliveryAddress',
  readonly addressLine1: Scalars['String'],
  readonly addressLine2: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly alias: Maybe<Scalars['String']>,
  readonly country: Maybe<IsoCountryCode>,
  readonly phoneNumber: Scalars['String'],
  readonly state: Maybe<Scalars['String']>,
  readonly zip: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly route: Maybe<Scalars['String']>,
  readonly streetNumber: Maybe<Scalars['String']>,
}

export interface IDeliveryAddressResponse {
  readonly __typename?: 'DeliveryAddressResponse',
  readonly deliveryAddresses: Maybe<ReadonlyArray<IDeliveryAddress>>,
}

export interface IDeliveryCancellation {
  readonly __typename?: 'DeliveryCancellation',
  readonly description: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['Int']>,
  readonly text: Maybe<Scalars['String']>,
}

export interface IDeliveryDriver {
  readonly __typename?: 'DeliveryDriver',
  readonly name: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly profileImageUrl: Maybe<Scalars['String']>,
}

export interface IDeliveryRestaurant {
  readonly __typename?: 'DeliveryRestaurant',
  readonly restaurant: Maybe<IRestaurantNode>,
  readonly storeStatus: DeliveryStoreStatus,
  readonly quote: Maybe<DeliveryStatus>,
  readonly nextEarliestOpen: Maybe<Scalars['String']>,
  readonly deliverySurchargeFeeCents: Maybe<Scalars['Int']>,
  readonly quoteId: Maybe<Scalars['String']>,
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStoreStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  NO_DELIVERY = 'NO_DELIVERY'
}

export interface IDeliveryTaskDetails {
  readonly __typename?: 'DeliveryTaskDetails',
  readonly createdAt: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
  readonly uuid: Maybe<Scalars['String']>,
}

export interface IDeliveryWaypoint {
  readonly __typename?: 'DeliveryWaypoint',
  readonly afterTime: Maybe<Scalars['String']>,
  readonly arrivalTime: Maybe<Scalars['String']>,
  readonly beforeTime: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly addressLine1: Scalars['String'],
  readonly addressLine2: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Maybe<Scalars['String']>,
  readonly phoneNumber: Scalars['String'],
  readonly state: Maybe<Scalars['String']>,
  readonly zip: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly shareUuid: Maybe<Scalars['String']>,
  readonly trackingUrl: Maybe<Scalars['String']>,
}

export interface IDeliveryWaypointInput {
  readonly addressLine1: Scalars['String'],
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country?: Maybe<Scalars['String']>,
  readonly phoneNumber: Scalars['String'],
  readonly route?: Maybe<Scalars['String']>,
  readonly shouldSave?: Maybe<Scalars['Boolean']>,
  readonly state?: Maybe<Scalars['String']>,
  readonly streetNumber?: Maybe<Scalars['String']>,
  readonly zip?: Maybe<Scalars['String']>,
  readonly latitude?: Maybe<Scalars['Float']>,
  readonly longitude?: Maybe<Scalars['Float']>,
}

export interface IDiscount {
  readonly __typename?: 'Discount',
  readonly name: Maybe<DiscountTypes>,
  readonly value: Maybe<Scalars['Int']>,
}

export enum DiscountTypes {
  ALL_DISCOUNTS = 'ALL_DISCOUNTS',
  COMBO_AND_OFFER_DISCOUNTS = 'COMBO_AND_OFFER_DISCOUNTS',
  REWARDS_DISCOUNTS = 'REWARDS_DISCOUNTS'
}

export interface IDonation {
  readonly __typename?: 'Donation',
  readonly id: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly totalCents: Maybe<Scalars['Int']>,
}

export enum DurationPeriod {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export interface IEdge {
  readonly node: INode,
  readonly cursor: Scalars['String'],
}

export interface IEncryptionDetails {
  readonly __typename?: 'EncryptionDetails',
  readonly fdPublicKey: Scalars['String'],
  readonly fdAccessToken: Scalars['String'],
  readonly fdPublicKeyExpiresInSeconds: Scalars['Int'],
  readonly fdPublicKeyIssuesOn: Scalars['String'],
  readonly fdApiKey: Scalars['String'],
  readonly algorithm: Maybe<Scalars['String']>,
  readonly fdCustomerId: Maybe<Scalars['String']>,
}

export interface IEntity {
  readonly __typename?: 'Entity',
  readonly id: Scalars['String'],
  readonly isAvailable: Maybe<Scalars['Boolean']>,
  readonly calories: Maybe<ICalories>,
  readonly price: Maybe<IPrice>,
  readonly options: Maybe<ReadonlyArray<IOption>>,
}

export interface IEvaluatedIncentives {
  readonly __typename?: 'EvaluatedIncentives',
  readonly invalidOffers: ReadonlyArray<IInvalidIncentives>,
  readonly invalidRewards: ReadonlyArray<IInvalidIncentives>,
}

export interface IEvaluateIncentivesInput {
  readonly appliedIncentives: ReadonlyArray<IPromotionInput>,
  readonly cartEntries?: Maybe<ReadonlyArray<IRbiCartEntryInput>>,
  readonly paymentMethod?: Maybe<PaymentMethod>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export interface IExchangeOtpCodeForCredentialsInput {
  readonly code: Scalars['String'],
  readonly email?: Maybe<Scalars['String']>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly sessionId: Scalars['ID'],
}

export interface IExternalIdentifier {
  readonly __typename?: 'ExternalIdentifier',
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}

export interface IExternalIdentifiers {
  readonly __typename?: 'ExternalIdentifiers',
  readonly source: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}

export interface IFavorite {
  readonly __typename?: 'Favorite',
  readonly entries: Maybe<ReadonlyArray<Maybe<ICartEntries>>>,
  readonly favoriteId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly ref: Maybe<Scalars['String']>,
  readonly createdAt: Maybe<Scalars['String']>,
  readonly updatedAt: Maybe<Scalars['String']>,
}

export interface IFavoriteInput {
  readonly ref?: Maybe<Scalars['String']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly entries?: Maybe<ReadonlyArray<Maybe<ICartEntryInput>>>,
}

export interface IFavoriteList {
  readonly __typename?: 'FavoriteList',
  readonly count: Maybe<Scalars['Int']>,
  readonly favorites: Maybe<ReadonlyArray<Maybe<IFavorite>>>,
  readonly resumeAfter: Maybe<Scalars['String']>,
}

export interface IFavoriteStore {
  readonly __typename?: 'FavoriteStore',
  readonly storeId: Maybe<Scalars['String']>,
  readonly storeNumber: Maybe<Scalars['String']>,
}

export interface IFavoriteStoreInput {
  readonly storeId?: Maybe<Scalars['String']>,
  readonly storeNumber: Scalars['String'],
}

export interface IFees {
  readonly __typename?: 'Fees',
  readonly name: Maybe<Scalars['String']>,
  readonly priceCents: Maybe<Scalars['Int']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly totalCents: Maybe<Scalars['Int']>,
}

export enum FilterRestaurantType {
  NEARBY = 'NEARBY',
  RECENT = 'RECENT',
  FAVORITE = 'FAVORITE'
}

export interface IFirstDataPayment {
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  readonly fdNonce?: Maybe<Scalars['String']>,
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>,
}

export interface IFirstpayPayment {
  readonly pspReference?: Maybe<Scalars['String']>,
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>,
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>,
  readonly merchantAccount?: Maybe<Scalars['String']>,
}

export enum FrontendIntegration {
  CHASE_TH_DIGITAL = 'CHASE_TH_DIGITAL',
  CHASE_ORBITAL = 'CHASE_ORBITAL',
  ADYEN = 'ADYEN',
  FIRSTDATA = 'FIRSTDATA',
  VRPAYMENT = 'VRPAYMENT',
  WORLDPAY = 'WORLDPAY'
}

export interface IFulfillmentDetails {
  readonly __typename?: 'FulfillmentDetails',
  readonly pickupType: Maybe<FulfillmentPickupType>,
  readonly pickupReady: Maybe<Scalars['Boolean']>,
  readonly pickupPin: Maybe<Scalars['String']>,
}

export enum FulfillmentPickupType {
  BEEPER = 'BEEPER',
  LOCKER = 'LOCKER'
}

export interface IFutureServiceHours {
  readonly __typename?: 'FutureServiceHours',
  readonly serviceMode: Maybe<ServiceMode>,
  readonly timeSlots: Maybe<ReadonlyArray<Maybe<IRestaurantTimeSlot>>>,
}


export interface IGiftAccount {
  readonly __typename?: 'GiftAccount',
  readonly fdAccountId: Scalars['String'],
  readonly prepaid: IGiftCard,
}

export interface IGiftCard {
  readonly __typename?: 'GiftCard',
  readonly alias: Scalars['String'],
  readonly currentBalance: Maybe<Scalars['Int']>,
  readonly cardNumber: Scalars['String'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly feFormattedCurrentBalance: Maybe<Scalars['Int']>,
  readonly shuffledCardNumber: Scalars['String'],
}

export interface IGooglePay {
  readonly signature: Scalars['String'],
  readonly country: CountryCode,
  readonly data: Scalars['String'],
  readonly formatted: Scalars['String'],
  readonly primary: Scalars['Boolean'],
  readonly version: Scalars['String'],
  readonly type: Scalars['String'],
  readonly billingAddress: IBillingAddressInput,
  readonly paymentData?: Maybe<Scalars['String']>,
  readonly PaymentMethodData?: Maybe<IPaymentMethodData>,
}

export interface IGooglePayPaymentConfig {
  readonly __typename?: 'GooglePayPaymentConfig',
  readonly schemeMerchantId: Maybe<Scalars['String']>,
  readonly prepaidMerchantId: Maybe<Scalars['String']>,
}

export interface IInRestaurantIncentive {
  readonly __typename?: 'InRestaurantIncentive',
  readonly id: Scalars['ID'],
  readonly type: InRestaurantIncentiveType,
}

export interface IInRestaurantIncentiveInput {
  readonly description?: Maybe<Scalars['String']>,
  readonly discount?: Maybe<ICartDiscountInput>,
  readonly id: Scalars['ID'],
  readonly name?: Maybe<Scalars['String']>,
  readonly offerCode?: Maybe<Scalars['String']>,
  readonly incentiveVendorConfigs?: Maybe<ReadonlyArray<IRbiVendorConfigsInput>>,
  readonly type: InRestaurantIncentiveType,
}

export enum InRestaurantIncentiveType {
  REWARD = 'REWARD',
  OFFER = 'OFFER',
  LEGACY_OFFER = 'LEGACY_OFFER'
}

export interface IInRestaurantOrderLineItem {
  readonly incentive?: Maybe<IInRestaurantIncentiveInput>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['ID'],
  readonly incentivePlu?: Maybe<Scalars['String']>,
  readonly vendorConfigs: IRbiVendorConfigsInput,
  readonly productId?: Maybe<Scalars['String']>,
}

export interface IInRestaurantOrderLineItemType {
  readonly __typename?: 'InRestaurantOrderLineItemType',
  readonly incentive: Maybe<IInRestaurantIncentive>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['ID'],
  readonly vendorConfigs: IRbiVendorConfigs,
}

export interface IInvalidIncentives {
  readonly __typename?: 'InvalidIncentives',
  readonly errors: ReadonlyArray<IRuleConditionEvaluation>,
  readonly id: Scalars['ID'],
}

export enum IsoCountryCode {
  ATA = 'ATA',
  CAN = 'CAN',
  CHE = 'CHE',
  DEU = 'DEU',
  GBR = 'GBR',
  NZL = 'NZL',
  USA = 'USA',
  ZAF = 'ZAF',
  KOR = 'KOR'
}


export enum Language {
  EN = 'EN',
  ES = 'ES',
  FR = 'FR'
}

export enum Locale {
  EN = 'en',
  FR = 'fr',
  IT = 'it',
  DE = 'de'
}

export interface ILoyaltyActivateAlohaRewardResponse {
  readonly __typename?: 'LoyaltyActivateAlohaRewardResponse',
  readonly rewardSanityId: Scalars['String'],
  readonly rewardCategorySanityId: Scalars['String'],
  readonly rewardPointCost: Scalars['Int'],
  readonly alohaRewardBonusPlanId: Scalars['Int'],
  readonly userPointBalance: Scalars['Int'],
}

export interface ILoyaltyAlohaActiveReward {
  readonly __typename?: 'LoyaltyAlohaActiveReward',
  readonly pointCost: Scalars['Int'],
  readonly rewardsCount: Scalars['Int'],
  readonly sanityId: Scalars['String'],
}

export interface ILoyaltyAssociateGuestUserResponse {
  readonly __typename?: 'LoyaltyAssociateGuestUserResponse',
  readonly guestBalance: Scalars['Int'],
  readonly activationDateTime: Scalars['String'],
  readonly linkingDateTime: Scalars['String'],
  readonly totalBalance: Scalars['Int'],
}

export interface ILoyaltyBaseIncentive {
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>,
  readonly id: Scalars['LoyaltyID'],
  readonly maxRedemptionsDuration: Maybe<LoyaltyDurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<LoyaltyPaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<LoyaltyBirthdayDuration>,
  readonly userEnrollment: Maybe<ILoyaltyDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>,
  readonly storeRestrictions: Maybe<ILoyaltyStoreRestrictions>,
  readonly errors: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface ILoyaltyBenefit {
  readonly type: LoyaltyBenefitType,
}

export interface ILoyaltyBenefitReference  extends ILoyaltyBenefit {
  readonly __typename?: 'LoyaltyBenefitReference',
  readonly type: LoyaltyBenefitType,
  readonly value: Scalars['String'],
}

export interface ILoyaltyBenefitSwap  extends ILoyaltyBenefit {
  readonly __typename?: 'LoyaltyBenefitSwap',
  readonly type: LoyaltyBenefitType,
  readonly value: ILoyaltySwap,
}

export enum LoyaltyBenefitType {
  REFERENCE = 'REFERENCE',
  SWAP = 'SWAP'
}

export enum LoyaltyBirthdayDuration {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH'
}

export interface ILoyaltyCardTransaction {
  readonly __typename?: 'LoyaltyCardTransaction',
  readonly basketTaxes: Maybe<Scalars['Int']>,
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly basketTotal: Maybe<Scalars['Int']>,
  readonly city: Maybe<Scalars['String']>,
  readonly discountAmount: Maybe<Scalars['Int']>,
  readonly expiredPoints: Maybe<ILoyaltyExpiredPoints>,
  readonly isCustomerServiceVisit: Maybe<Scalars['Boolean']>,
  readonly isVisit: Maybe<Scalars['Boolean']>,
  readonly offerId: Maybe<Scalars['Int']>,
  readonly pointsEarned: Maybe<Scalars['Int']>,
  readonly pointsUsed: Maybe<Scalars['Int']>,
  readonly rewardEarned: Maybe<Scalars['Boolean']>,
  readonly rewardRedeemed: Maybe<Scalars['Boolean']>,
  readonly stateOrProvince: Maybe<Scalars['String']>,
  readonly storeId: Maybe<Scalars['String']>,
  readonly tag: Maybe<Scalars['String']>,
  readonly timestamp: Maybe<Scalars['String']>,
  readonly transactionId: Maybe<Scalars['String']>,
  readonly visitType: Maybe<Scalars['String']>,
  readonly wasDiscountActive: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyCartDiscount {
  readonly __typename?: 'LoyaltyCartDiscount',
  readonly type: LoyaltyCartDiscountType,
  readonly value: Scalars['Float'],
}

export interface ILoyaltyCartDiscountInput {
  readonly type: LoyaltyCartDiscountType,
  readonly value: Scalars['Float'],
}

export enum LoyaltyCartDiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export interface ILoyaltyCartRequirement {
  readonly __typename?: 'LoyaltyCartRequirement',
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
}

export interface ILoyaltyCouponResponse  extends ICouponResponse {
  readonly __typename?: 'LoyaltyCouponResponse',
  readonly code: Scalars['String'],
  readonly isValid: Scalars['Boolean'],
  readonly message: Scalars['String'],
  readonly reason: Maybe<Scalars['String']>,
  readonly isRedeemed: Maybe<Scalars['Boolean']>,
  readonly shouldRedeem: Maybe<Scalars['Boolean']>,
  readonly personalizedOfferId: Maybe<Scalars['String']>,
  readonly configId: Maybe<Scalars['String']>,
}

export interface ILoyaltyCreateOrderSelectionInput {
  readonly loyaltyId: Scalars['String'],
  readonly selectedIncentives: ReadonlyArray<ILoyaltyOrderSelectionIncentiveInput>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly type: LoyaltyOrderSelectionType,
}

export interface ILoyaltyCreateOrderSelectionResponse {
  readonly __typename?: 'LoyaltyCreateOrderSelectionResponse',
  readonly key: Scalars['String'],
  readonly orderSelection: ILoyaltyOrderSelection,
}

export interface ILoyaltyDateSpan {
  readonly __typename?: 'LoyaltyDateSpan',
  readonly endDate: Maybe<Scalars['String']>,
  readonly startDate: Maybe<Scalars['String']>,
}

export enum LoyaltyDayOfTheWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export interface ILoyaltyDeleteOrderSelectionInput {
  readonly key: Scalars['String'],
  readonly loyaltyId: Scalars['String'],
  readonly type: LoyaltyOrderSelectionType,
}

export enum LoyaltyDurationPeriod {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export interface ILoyaltyEvaluatedIncentives {
  readonly __typename?: 'LoyaltyEvaluatedIncentives',
  readonly invalidOffers: ReadonlyArray<ILoyaltyInvalidIncentives>,
  readonly invalidRewards: ReadonlyArray<ILoyaltyInvalidIncentives>,
}

export interface ILoyaltyEvaluateIncentivesInput {
  readonly appliedIncentives: ReadonlyArray<ILoyaltyPromotionInput>,
  readonly cartEntries?: Maybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>,
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>,
  readonly serviceMode?: Maybe<LoyaltyServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export interface ILoyaltyExpiredPoints {
  readonly __typename?: 'LoyaltyExpiredPoints',
  readonly barcode: Maybe<Scalars['String']>,
  readonly expirationDate: Maybe<Scalars['String']>,
  readonly points: Maybe<Scalars['Int']>,
  readonly ttl: Maybe<Scalars['String']>,
}

export interface ILoyaltyExternalIdentifier {
  readonly __typename?: 'LoyaltyExternalIdentifier',
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}

export interface ILoyaltyExternalIdentifiers {
  readonly __typename?: 'LoyaltyExternalIdentifiers',
  readonly source: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}


export interface ILoyaltyInRestaurantIncentive {
  readonly __typename?: 'LoyaltyInRestaurantIncentive',
  readonly id: Scalars['LoyaltyID'],
  readonly type: LoyaltyInRestaurantIncentiveType,
}

export interface ILoyaltyInRestaurantIncentiveInput {
  readonly description?: Maybe<Scalars['String']>,
  readonly discount?: Maybe<ILoyaltyCartDiscountInput>,
  readonly id: Scalars['LoyaltyID'],
  readonly name?: Maybe<Scalars['String']>,
  readonly offerCode?: Maybe<Scalars['String']>,
  readonly incentiveVendorConfigs?: Maybe<ReadonlyArray<ILoyaltyRbiVendorConfigsInput>>,
  readonly type: LoyaltyInRestaurantIncentiveType,
}

export enum LoyaltyInRestaurantIncentiveType {
  REWARD = 'REWARD',
  OFFER = 'OFFER',
  LEGACY_OFFER = 'LEGACY_OFFER'
}

export interface ILoyaltyInRestaurantOrderLineItem {
  readonly incentive?: Maybe<ILoyaltyInRestaurantIncentiveInput>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['LoyaltyID'],
  readonly incentivePlu?: Maybe<Scalars['String']>,
  readonly vendorConfigs: ILoyaltyRbiVendorConfigsInput,
  readonly productId?: Maybe<Scalars['String']>,
}

export interface ILoyaltyInRestaurantOrderLineItemType {
  readonly __typename?: 'LoyaltyInRestaurantOrderLineItemType',
  readonly incentive: Maybe<ILoyaltyInRestaurantIncentive>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['LoyaltyID'],
  readonly vendorConfigs: ILoyaltyRbiVendorConfigs,
}

export interface ILoyaltyInvalidIncentives {
  readonly __typename?: 'LoyaltyInvalidIncentives',
  readonly errors: ReadonlyArray<ILoyaltyRuleConditionEvaluation>,
  readonly id: Scalars['LoyaltyID'],
}


export enum LoyaltyLanguage {
  EN = 'EN',
  ES = 'ES',
  FR = 'FR'
}

export interface ILoyaltyObjectType {
  readonly __typename?: 'LoyaltyObjectType',
  readonly key: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['LoyaltyJSON']>,
}

export interface ILoyaltyOffer  extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltyOffer',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>,
  readonly id: Scalars['LoyaltyID'],
  readonly maxRedemptionsDuration: Maybe<LoyaltyDurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>,
  readonly paymentMethod: Maybe<LoyaltyPaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<LoyaltyBirthdayDuration>,
  readonly userEnrollment: Maybe<ILoyaltyDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>,
  readonly storeRestrictions: Maybe<ILoyaltyStoreRestrictions>,
  readonly benefits: Maybe<ReadonlyArray<ILoyaltyBenefit>>,
  readonly errors: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>,
  readonly isStackable: Maybe<Scalars['Boolean']>,
  readonly loyaltyId: Maybe<Scalars['LoyaltyID']>,
  readonly redemptionType: Maybe<LoyaltyOfferRedemptionType>,
  readonly type: LoyaltyOfferType,
  readonly configId: Maybe<Scalars['LoyaltyID']>,
  readonly templateId: Maybe<Scalars['LoyaltyID']>,
  readonly questId: Maybe<Scalars['String']>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface ILoyaltyOfferChallengeStatus {
  readonly __typename?: 'LoyaltyOfferChallengeStatus',
  readonly goals: Maybe<ILoyaltyOfferGoalType>,
  readonly goalId: Scalars['String'],
  readonly reward: Maybe<ILoyaltyOfferRewardType>,
  readonly status: Scalars['String'],
}

export interface ILoyaltyOfferGoalType {
  readonly __typename?: 'LoyaltyOfferGoalType',
  readonly category: Maybe<Scalars['String']>,
  readonly daypart: Maybe<Scalars['String']>,
  readonly foodType: Maybe<Scalars['String']>,
  readonly minSpend: Maybe<Scalars['Int']>,
}

export interface ILoyaltyOfferRedemptionAvailability {
  readonly __typename?: 'LoyaltyOfferRedemptionAvailability',
  readonly availableAfter: Maybe<Scalars['String']>,
  readonly transactionId: Maybe<Scalars['String']>,
}

export enum LoyaltyOfferRedemptionType {
  PROMO_CODE = 'PROMO_CODE',
  STANDARD = 'STANDARD',
  SURPRISE = 'SURPRISE',
  SWAP = 'SWAP'
}

export interface ILoyaltyOfferRewardType {
  readonly __typename?: 'LoyaltyOfferRewardType',
  readonly points: Maybe<Scalars['Int']>,
}

export interface ILoyaltyOffersInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<ILoyaltyPromotionInput>>,
  readonly appliedPromotions?: Maybe<ReadonlyArray<ILoyaltyPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>,
  readonly configId?: Maybe<Scalars['LoyaltyID']>,
  readonly global?: Maybe<Scalars['Boolean']>,
  readonly ids?: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  readonly ignoreRules?: Maybe<Scalars['Boolean']>,
  readonly isTransactionCreation?: Maybe<Scalars['Boolean']>,
  readonly limit?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>,
  readonly redemptionTypes?: Maybe<ReadonlyArray<LoyaltyOfferRedemptionType>>,
  readonly serviceMode?: Maybe<LoyaltyServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export enum LoyaltyOfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface ILoyaltyOrderlessIncentiveInput {
  readonly id: Scalars['String'],
  readonly type: LoyaltyPromotionType,
  readonly metadata?: Maybe<Scalars['LoyaltyJSON']>,
}

export interface ILoyaltyOrderlessTransactionInput {
  readonly cognitoId?: Maybe<Scalars['String']>,
  readonly loyaltyId?: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly storeId?: Maybe<Scalars['String']>,
  readonly incentives: ReadonlyArray<ILoyaltyOrderlessIncentiveInput>,
}

export interface ILoyaltyOrderSelection {
  readonly __typename?: 'LoyaltyOrderSelection',
  readonly createdAt: Scalars['String'],
  readonly expiry: Maybe<Scalars['Int']>,
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly otp: Maybe<Scalars['String']>,
  readonly selectedIncentives: ReadonlyArray<ILoyaltyOrderSelectionIncentive>,
  readonly status: LoyaltyOrderSelectionStatus,
  readonly storeId: Maybe<Scalars['String']>,
  readonly transactionId: Maybe<Scalars['String']>,
}

export interface ILoyaltyOrderSelectionIncentive {
  readonly __typename?: 'LoyaltyOrderSelectionIncentive',
  readonly benefits: ReadonlyArray<ILoyaltyOrderSelectionIncentiveBenefit>,
  readonly description: Maybe<Scalars['String']>,
  readonly cartDiscount: Maybe<ICartDiscount>,
  readonly id: Scalars['String'],
  readonly lineId: Scalars['String'],
  readonly name: Scalars['String'],
  readonly productId: Scalars['String'],
  readonly quantity: Scalars['Int'],
  readonly type: LoyaltyOrderSelectionIncentiveType,
}

export interface ILoyaltyOrderSelectionIncentiveBenefit {
  readonly __typename?: 'LoyaltyOrderSelectionIncentiveBenefit',
  readonly description: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly productId: Scalars['String'],
}

export interface ILoyaltyOrderSelectionIncentiveBenefitInput {
  readonly description?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly productId: Scalars['String'],
  readonly vendorConfigs: ILoyaltyVendorConfigsInput,
}

export interface ILoyaltyOrderSelectionIncentiveInput {
  readonly benefits: ReadonlyArray<ILoyaltyOrderSelectionIncentiveBenefitInput>,
  readonly description?: Maybe<Scalars['String']>,
  readonly cartDiscount?: Maybe<ICartDiscountInput>,
  readonly id: Scalars['String'],
  readonly lineId: Scalars['String'],
  readonly name: Scalars['String'],
  readonly productId: Scalars['String'],
  readonly quantity: Scalars['Int'],
  readonly shortCode?: Maybe<Scalars['String']>,
  readonly type: LoyaltyOrderSelectionIncentiveType,
  readonly vendorConfigs: IRbiVendorConfigsInput,
}

export enum LoyaltyOrderSelectionIncentiveType {
  REWARD = 'REWARD',
  OFFER = 'OFFER'
}

export enum LoyaltyOrderSelectionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING'
}

export interface ILoyaltyOrderSelectionTransfer {
  readonly __typename?: 'LoyaltyOrderSelectionTransfer',
  readonly createdAt: Scalars['String'],
  readonly expiry: Maybe<Scalars['Int']>,
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly order: ReadonlyArray<ILoyaltyInRestaurantOrderLineItemType>,
  readonly otp: Maybe<Scalars['String']>,
  readonly restaurantId: Maybe<Scalars['String']>,
  readonly updatedAt: Maybe<Scalars['String']>,
  readonly status: Maybe<OrderSelectionStatus>,
  readonly transactionId: Maybe<Scalars['String']>,
}

export enum LoyaltyOrderSelectionType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface ILoyaltyOstCreationPayload {
  readonly __typename?: 'LoyaltyOstCreationPayload',
  readonly expirationTime: Scalars['String'],
  readonly key: Scalars['String'],
}

export enum LoyaltyOstType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface ILoyaltyOtp {
  readonly __typename?: 'LoyaltyOtp',
  readonly expirationTime: Scalars['String'],
  readonly password: Scalars['String'],
}

export interface ILoyaltyParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface ILoyaltyPaymentExpiration {
  readonly __typename?: 'LoyaltyPaymentExpiration',
  readonly month: Maybe<Scalars['Int']>,
  readonly year: Maybe<Scalars['Int']>,
}

export enum LoyaltyPaymentMethod {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERSCLUB = 'DINERSCLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA'
}

export interface ILoyaltyPerson {
  readonly __typename?: 'LoyaltyPerson',
  readonly externalIds: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifier>>>,
  readonly phone: Maybe<Scalars['String']>,
  readonly email: Maybe<Scalars['String']>,
}

export interface ILoyaltyPickupContact {
  readonly __typename?: 'LoyaltyPickupContact',
  readonly name: Maybe<Scalars['String']>,
  readonly phone: Maybe<Scalars['String']>,
  readonly hasArrived: Scalars['Boolean'],
  readonly vehicle: Maybe<ILoyaltyPickupContactVehicle>,
}

export interface ILoyaltyPickupContactVehicle {
  readonly __typename?: 'LoyaltyPickupContactVehicle',
  readonly make: Maybe<Scalars['String']>,
  readonly model: Maybe<Scalars['String']>,
  readonly color: Maybe<Scalars['String']>,
  readonly licensePlate: Maybe<Scalars['String']>,
}

export interface ILoyaltyPointExpiry {
  readonly __typename?: 'LoyaltyPointExpiry',
  readonly points: Scalars['Int'],
  readonly expirationDate: Scalars['String'],
}

export interface ILoyaltyProcessSmgCodeResponse {
  readonly __typename?: 'LoyaltyProcessSmgCodeResponse',
  readonly pointsEarned: Scalars['Int'],
  readonly status: LoyaltySmgCodeStatus,
}

export interface ILoyaltyPromotion {
  readonly __typename?: 'LoyaltyPromotion',
  readonly id: Scalars['String'],
  readonly lineId: Maybe<Scalars['String']>,
  readonly type: LoyaltyPromotionType,
}

export interface ILoyaltyPromotionInput {
  readonly id: Scalars['String'],
  readonly lineId?: Maybe<Scalars['String']>,
  readonly swap?: Maybe<ILoyaltyPromotionSwapInput>,
  readonly type: LoyaltyPromotionType,
}

export interface ILoyaltyPromotionsInput {
  readonly serviceMode?: Maybe<LoyaltyServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyPromotionSwapInput {
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly type: LoyaltySwapType,
  readonly lineId: Scalars['String'],
}

export enum LoyaltyPromotionType {
  OFFER = 'OFFER',
  REWARD = 'REWARD',
  SYSTEMWIDE_PROMOTION = 'SYSTEMWIDE_PROMOTION'
}

export interface ILoyaltyQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface ILoyaltyQuest {
  readonly __typename?: 'LoyaltyQuest',
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly completions: Maybe<ReadonlyArray<Maybe<ILoyaltyQuestCompletion>>>,
  readonly configId: Maybe<Scalars['LoyaltyID']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>,
  readonly id: Scalars['LoyaltyID'],
  readonly incentiveType: LoyaltyQuestIncentiveType,
  readonly incentiveId: Maybe<Scalars['LoyaltyID']>,
  readonly incentiveRedeemed: Scalars['Boolean'],
  readonly lastCompletion: Maybe<ILoyaltyQuestCompletion>,
  readonly sanityId: Maybe<Scalars['String']>,
  readonly startDate: Scalars['String'],
  readonly status: LoyaltyQuestStatus,
  readonly steps: Maybe<ReadonlyArray<ILoyaltyQuestStep>>,
}

export interface ILoyaltyQuestCompletion {
  readonly __typename?: 'LoyaltyQuestCompletion',
  readonly benefitId: Scalars['String'],
  readonly completedAt: Scalars['String'],
  readonly redeemed: Scalars['Boolean'],
}

export enum LoyaltyQuestIncentiveType {
  BONUS_POINTS = 'BONUS_POINTS',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export enum LoyaltyQuestStatus {
  NOT_ENROLLED = 'NOT_ENROLLED',
  ACTIVATED = 'ACTIVATED',
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export interface ILoyaltyQuestStep {
  readonly __typename?: 'LoyaltyQuestStep',
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>,
  readonly completedAt: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly status: LoyaltyQuestStepStatus,
}

export enum LoyaltyQuestStepStatus {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export interface ILoyaltyRbiCartEntryInput {
  readonly lineId?: Maybe<Scalars['String']>,
  readonly sanityId: Scalars['String'],
  readonly price?: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly children?: Maybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>,
}

export enum LoyaltyRbiChannel {
  APP = 'APP',
  ORDERLESS = 'ORDERLESS',
  RECEIPT = 'RECEIPT',
  REMEDIATION = 'REMEDIATION',
  RESTAURANT = 'RESTAURANT',
  WEB = 'WEB'
}

export interface ILoyaltyRbiParentChildPlu {
  readonly __typename?: 'LoyaltyRbiParentChildPlu',
  readonly plu: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiQuantityPlu {
  readonly __typename?: 'LoyaltyRbiQuantityPlu',
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiSizeBasedPlu {
  readonly __typename?: 'LoyaltyRbiSizeBasedPlu',
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiSizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

export interface ILoyaltyRbiVendorConfig {
  readonly __typename?: 'LoyaltyRbiVendorConfig',
  readonly pluType: Maybe<Scalars['String']>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Int']>,
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly discountPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPlu>>>,
  readonly parentChildPlu: Maybe<ILoyaltyRbiParentChildPlu>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPlu>>>,
  readonly sizeBasedPlu: Maybe<ILoyaltyRbiSizeBasedPlu>,
}

export interface ILoyaltyRbiVendorConfigInput {
  readonly pluType?: Maybe<Scalars['String']>,
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly discountPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<ILoyaltyRbiParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<ILoyaltyRbiSizeBasedPluInput>,
}

export interface ILoyaltyRbiVendorConfigs {
  readonly __typename?: 'LoyaltyRbiVendorConfigs',
  readonly brink: Maybe<ILoyaltyRbiVendorConfig>,
  readonly brinkDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly carrols: Maybe<ILoyaltyRbiVendorConfig>,
  readonly carrolsDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly hdx: Maybe<ILoyaltyRbiVendorConfig>,
  readonly ncr: Maybe<ILoyaltyRbiVendorConfig>,
  readonly ncrDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly productNumber: Maybe<ILoyaltyRbiVendorConfig>,
  readonly productNumberDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly qdi: Maybe<ILoyaltyRbiVendorConfig>,
  readonly qdiDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly oheics: Maybe<ILoyaltyRbiVendorConfig>,
  readonly oheicsDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly partner: Maybe<ILoyaltyRbiVendorConfig>,
  readonly partnerDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly qst: Maybe<ILoyaltyRbiVendorConfig>,
  readonly rpos: Maybe<ILoyaltyRbiVendorConfig>,
  readonly rposDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly sicom: Maybe<ILoyaltyRbiVendorConfig>,
  readonly sicomDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly tablet: Maybe<ILoyaltyRbiVendorConfig>,
  readonly tabletDelivery: Maybe<ILoyaltyRbiVendorConfig>,
  readonly xenial: Maybe<ILoyaltyRbiVendorConfig>,
  readonly xenialDelivery: Maybe<ILoyaltyRbiVendorConfig>,
}

export interface ILoyaltyRbiVendorConfigsInput {
  readonly brink?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly brinkDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly carrols?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly carrolsDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly hdx?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly ncr?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly ncrDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly productNumber?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly productNumberDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly qdi?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly qdiDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly oheics?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly oheicsDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly partner?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly partnerDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly qst?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly rpos?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly rposDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly sicom?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly sicomDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly tablet?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly tabletDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly xenial?: Maybe<ILoyaltyRbiVendorConfigInput>,
  readonly xenialDelivery?: Maybe<ILoyaltyRbiVendorConfigInput>,
}

export interface ILoyaltyRedeemCouponResponse  extends IRedeemedCouponResponse {
  readonly __typename?: 'LoyaltyRedeemCouponResponse',
  readonly code: Scalars['String'],
  readonly isRedeemed: Scalars['Boolean'],
  readonly configId: Maybe<Scalars['String']>,
  readonly message: Maybe<Scalars['String']>,
  readonly reason: Maybe<Scalars['String']>,
}

export interface ILoyaltyRedeemPromoCodeInput {
  readonly code: Scalars['String'],
  readonly loyaltyId: Scalars['String'],
  readonly personalizedOfferId: Scalars['String'],
}

export interface ILoyaltyReward  extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltyReward',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>,
  readonly id: Scalars['LoyaltyID'],
  readonly maxRedemptionsDuration: Maybe<LoyaltyDurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<LoyaltyPaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<LoyaltyBirthdayDuration>,
  readonly userEnrollment: Maybe<ILoyaltyDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>,
  readonly storeRestrictions: Maybe<ILoyaltyStoreRestrictions>,
  readonly rewardBenefitId: Scalars['String'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>,
  readonly pointCost: Scalars['Int'],
  readonly limitPerOrder: Maybe<Scalars['Int']>,
  readonly locked: Maybe<Scalars['Boolean']>,
  readonly redemptionPercentage: Maybe<Scalars['Int']>,
  readonly remainingPointsNeededForRedemption: Maybe<Scalars['Int']>,
  readonly errors: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly type: LoyaltyRewardType,
}

export interface ILoyaltyRewardsInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<ILoyaltyPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>,
  readonly ignorePointBalance?: Maybe<Scalars['Boolean']>,
  readonly incentiveIds?: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  readonly isTransactionCreation?: Maybe<Scalars['Boolean']>,
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>,
  readonly rewardIds?: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  readonly serviceMode?: Maybe<LoyaltyServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
  readonly ignoreRules?: Maybe<Scalars['Boolean']>,
  readonly configId?: Maybe<Scalars['LoyaltyID']>,
}

export enum LoyaltyRewardType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface ILoyaltyRuleConditionEvaluation {
  readonly __typename?: 'LoyaltyRuleConditionEvaluation',
  readonly code: Scalars['String'],
  readonly currentValue: Maybe<Scalars['LoyaltyJSON']>,
  readonly message: Maybe<Scalars['String']>,
  readonly ruleId: Scalars['String'],
  readonly targetValue: Maybe<Scalars['LoyaltyJSON']>,
}

export interface ILoyaltySecondaryIdentifier {
  readonly __typename?: 'LoyaltySecondaryIdentifier',
  readonly identifier: Scalars['String'],
  readonly identifierType: LoyaltySecondaryIdentifierType,
  readonly loyaltyId: Maybe<Scalars['LoyaltyID']>,
  readonly createdAt: Maybe<Scalars['String']>,
  readonly verified: Maybe<Scalars['Boolean']>,
}

export enum LoyaltySecondaryIdentifierType {
  LOYALTY12DIGITSWIPECARD = 'LOYALTY12DIGITSWIPECARD',
  LOYALTYSWIPECARD = 'LOYALTYSWIPECARD',
  PHONENUMBER = 'PHONENUMBER',
  PANTOKEN = 'PANTOKEN'
}

export enum LoyaltyServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TABLE_SERVICE = 'TABLE_SERVICE',
  TAKEOUT = 'TAKEOUT'
}

export interface ILoyaltySizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

export enum LoyaltySmgCodeStatus {
  ACCEPTED = 'ACCEPTED',
  CODE_EXISTS = 'CODE_EXISTS',
  EXPIRED = 'EXPIRED',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_RESTAURANT = 'INVALID_RESTAURANT',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  RETRY_REQUESTED = 'RETRY_REQUESTED',
  THROTTLING_ERROR = 'THROTTLING_ERROR',
  TRANSACTION_CLAIMED = 'TRANSACTION_CLAIMED'
}

export interface ILoyaltyStoreRestrictions {
  readonly __typename?: 'LoyaltyStoreRestrictions',
  readonly ids: ReadonlyArray<Maybe<Scalars['String']>>,
  readonly inclusive: Scalars['Boolean'],
}

export interface ILoyaltySwap {
  readonly __typename?: 'LoyaltySwap',
  readonly type: LoyaltySwapType,
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
}

export enum LoyaltySwapType {
  UPSIZE = 'UPSIZE'
}

export interface ILoyaltySystemWidePromotion  extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltySystemWidePromotion',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>,
  readonly id: Scalars['LoyaltyID'],
  readonly maxRedemptionsDuration: Maybe<LoyaltyDurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<LoyaltyPaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<LoyaltyBirthdayDuration>,
  readonly userEnrollment: Maybe<ILoyaltyDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>,
  readonly storeRestrictions: Maybe<ILoyaltyStoreRestrictions>,
  readonly pointMultiplier: Maybe<Scalars['Int']>,
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly metadata: Maybe<Scalars['LoyaltyJSON']>,
  readonly errors: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface ILoyaltyTransaction {
  readonly __typename?: 'LoyaltyTransaction',
  readonly id: Scalars['String'],
  readonly pointsEarned: Scalars['Int'],
  readonly bonusPointsEarned: Scalars['Int'],
  readonly pointsUsed: Scalars['Int'],
  readonly pointsBalance: Scalars['Int'],
  readonly rewardsUsed: Scalars['Int'],
}

export interface ILoyaltyTransactionAdditionalReferenceId {
  readonly __typename?: 'LoyaltyTransactionAdditionalReferenceId',
  readonly id: Scalars['String'],
  readonly type: Scalars['String'],
  readonly description: Maybe<Scalars['String']>,
}

export interface ILoyaltyTransactionDetails {
  readonly __typename?: 'LoyaltyTransactionDetails',
  readonly person: Maybe<ILoyaltyPerson>,
  readonly posVendor: Maybe<ILoyaltyTransactionPosVendor>,
  readonly currency: Scalars['String'],
  readonly payments: ReadonlyArray<ILoyaltyTransactionPayment>,
  readonly fulfillment: ILoyaltyTransactionFulfillment,
  readonly pickupContact: Maybe<ILoyaltyPickupContact>,
  readonly orders: ReadonlyArray<ILoyaltyTransactionOrder>,
  readonly language: Maybe<LoyaltyLanguage>,
  readonly promotions: Maybe<ReadonlyArray<ILoyaltyPromotion>>,
}

export interface ILoyaltyTransactionFulfillment {
  readonly __typename?: 'LoyaltyTransactionFulfillment',
  readonly type: Scalars['String'],
  readonly autoRelease: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyTransactionOrder {
  readonly __typename?: 'LoyaltyTransactionOrder',
  readonly productId: Maybe<Scalars['String']>,
  readonly quantity: Scalars['Int'],
  readonly price: Scalars['Int'],
  readonly parentReferenceId: Maybe<Scalars['String']>,
}

export interface ILoyaltyTransactionPayment {
  readonly __typename?: 'LoyaltyTransactionPayment',
  readonly amount: Scalars['Int'],
  readonly description: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly token: Maybe<Scalars['String']>,
  readonly expiration: Maybe<ILoyaltyPaymentExpiration>,
}

export interface ILoyaltyTransactionPosVendor {
  readonly __typename?: 'LoyaltyTransactionPosVendor',
  readonly id: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly transactionId: Scalars['String'],
}

export interface ILoyaltyTransactionsInput {
  readonly ids?: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  readonly statuses?: Maybe<ReadonlyArray<LoyaltyTransactionStatus>>,
  readonly excludedChannels?: Maybe<ReadonlyArray<LoyaltyRbiChannel>>,
}

export enum LoyaltyTransactionStatus {
  VOID = 'VOID',
  CLAIMED = 'CLAIMED',
  UNCLAIMED = 'UNCLAIMED',
  PENDING = 'PENDING'
}

export interface ILoyaltyTransactionV2 {
  readonly __typename?: 'LoyaltyTransactionV2',
  readonly id: Scalars['LoyaltyID'],
  readonly shortId: Scalars['String'],
  readonly status: LoyaltyTransactionStatus,
  readonly createdAt: Scalars['String'],
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly transactionDetails: Maybe<ILoyaltyTransactionDetails>,
  readonly dateUpdated: Maybe<Scalars['String']>,
  readonly additionalReferenceIds: Maybe<ReadonlyArray<ILoyaltyTransactionAdditionalReferenceId>>,
  readonly pointsDeducted: Maybe<Scalars['Int']>,
  readonly pointsEarned: Scalars['Int'],
  readonly bonusPointsEarned: Scalars['Int'],
  readonly pointsUsed: Scalars['Int'],
  readonly maxTransactionLimitReached: Scalars['Boolean'],
  readonly hasRewards: Scalars['Boolean'],
}

export interface ILoyaltyUser {
  readonly __typename?: 'LoyaltyUser',
  readonly id: Scalars['LoyaltyID'],
  readonly name: Maybe<Scalars['String']>,
  readonly email: Scalars['String'],
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly dateOfBirth: Maybe<Scalars['String']>,
  readonly points: Scalars['Int'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>,
  readonly secondaryIdentifiers: Maybe<ReadonlyArray<Maybe<ILoyaltySecondaryIdentifier>>>,
  readonly createdAt: Scalars['String'],
  readonly transactions: Maybe<ReadonlyArray<ILoyaltyTransactionV2>>,
  readonly rewards: Maybe<ReadonlyArray<ILoyaltyReward>>,
  readonly bestPromotion: Maybe<ILoyaltySystemWidePromotion>,
  readonly promotions: Maybe<ReadonlyArray<ILoyaltySystemWidePromotion>>,
  readonly offers: Maybe<ReadonlyArray<ILoyaltyOffer>>,
  readonly quests: Maybe<ReadonlyArray<ILoyaltyQuest>>,
  readonly alohaActiveRewards: ReadonlyArray<ILoyaltyAlohaActiveReward>,
  readonly pointsExpiryDateKey: Maybe<Scalars['String']>,
  readonly offerRedemptionAvailability: Maybe<ILoyaltyOfferRedemptionAvailability>,
  readonly offerRedemptionAvailableAfter: Maybe<Scalars['String']>,
  readonly evaluatedIncentives: ILoyaltyEvaluatedIncentives,
}


export interface ILoyaltyUserTransactionsArgs {
  where: Maybe<ILoyaltyTransactionsInput>
}


export interface ILoyaltyUserRewardsArgs {
  where: Maybe<ILoyaltyRewardsInput>
}


export interface ILoyaltyUserBestPromotionArgs {
  where: Maybe<ILoyaltyPromotionsInput>
}


export interface ILoyaltyUserPromotionsArgs {
  where: Maybe<ILoyaltyPromotionsInput>
}


export interface ILoyaltyUserOffersArgs {
  where: Maybe<ILoyaltyOffersInput>
}


export interface ILoyaltyUserEvaluatedIncentivesArgs {
  where: ILoyaltyEvaluateIncentivesInput
}

export interface ILoyaltyValidatePromoCodeInput {
  readonly code: Scalars['String'],
  readonly loyaltyId: Scalars['String'],
  readonly shouldRedeem?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyVendorConfigInput {
  readonly pluType?: Maybe<Scalars['String']>,
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly discountPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<ILoyaltyQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<ILoyaltyParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<ILoyaltyQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<ILoyaltySizeBasedPluInput>,
}

export interface ILoyaltyVendorConfigsInput {
  readonly carrols?: Maybe<ILoyaltyVendorConfigInput>,
  readonly ncr?: Maybe<ILoyaltyVendorConfigInput>,
  readonly qdi?: Maybe<ILoyaltyVendorConfigInput>,
  readonly partner?: Maybe<ILoyaltyVendorConfigInput>,
  readonly rpos?: Maybe<ILoyaltyVendorConfigInput>,
  readonly sicom?: Maybe<ILoyaltyVendorConfigInput>,
  readonly tablet?: Maybe<ILoyaltyVendorConfigInput>,
}

export interface IMenuEntityWithHours {
  readonly __typename?: 'MenuEntityWithHours',
  readonly id: Scalars['String'],
  readonly isAvailable: Maybe<Scalars['Boolean']>,
  readonly calories: Maybe<ICalories>,
  readonly price: Maybe<IPrice>,
  readonly options: Maybe<ReadonlyArray<IOption>>,
  readonly hours: ReadonlyArray<IMenuItemHours>,
}

export interface IMenuItem {
  readonly __typename?: 'MenuItem',
  readonly plu: Scalars['String'],
  readonly price: Scalars['String'],
}

export interface IMenuItemHours {
  readonly __typename?: 'MenuItemHours',
  readonly start: Scalars['String'],
  readonly end: Scalars['String'],
}

export interface IMerge {
  readonly __typename?: 'Merge',
  readonly beginBalance: Scalars['Int'],
  readonly currencyCode: Scalars['String'],
  readonly currentBalance: Scalars['Int'],
  readonly destinationCardNumber: Maybe<Scalars['String']>,
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly sourceCardNumber: Maybe<Scalars['String']>,
  readonly transactionId: Scalars['String'],
  readonly fdAccountId: Maybe<Scalars['String']>,
}

export interface IMergePrepaidInput {
  readonly sourceCardNumber: Scalars['String'],
  readonly sourcePin?: Maybe<Scalars['String']>,
}

export interface IMergePrepaidPayload {
  readonly __typename?: 'MergePrepaidPayload',
  readonly storedPaymentMethodId: Scalars['String'],
  readonly prepaidDetails: IPrepaidDetails,
}

export interface IMissingItem {
  readonly lineId: Scalars['String'],
  readonly refundQuantity: Scalars['Int'],
  readonly totalQuantity?: Maybe<Scalars['Int']>,
}

export interface IMissingOrderRefundDetails {
  readonly __typename?: 'MissingOrderRefundDetails',
  readonly approvedAmount: Scalars['Int'],
  readonly transactionDateTime: Scalars['String'],
}

export interface IMissingOrderResolution {
  readonly __typename?: 'MissingOrderResolution',
  readonly refund: Maybe<IMissingOrderRefundDetails>,
  readonly ticket: Maybe<Scalars['String']>,
}

export interface IModifier {
  readonly __typename?: 'Modifier',
  readonly id: Scalars['String'],
  readonly isAvailable: Maybe<Scalars['Boolean']>,
  readonly price: Maybe<Scalars['Int']>,
}

export interface IMutation {
  readonly __typename?: 'Mutation',
  readonly redeemCoupon: ICoupon,
  readonly createFavorite: IFavorite,
  readonly updateFavorite: IFavorite,
  readonly deleteFavorite: IFavorite,
  readonly commitOrder: IOrder,
  readonly priceOrder: IOrder,
  readonly updateOrder: IOrder,
  readonly _empty: Maybe<Scalars['String']>,
  readonly loyaltyCreateOrderSelection: ILoyaltyCreateOrderSelectionResponse,
  readonly loyaltyDeleteOrderSelection: Scalars['Boolean'],
  readonly generateOtp: IOtp,
  readonly createOrderSelectionByType: IOstCreationPayload,
  readonly deleteOrderSelection: Maybe<Scalars['Boolean']>,
  readonly deleteOrderSelectionByType: Maybe<Scalars['Boolean']>,
  readonly activateQuest: Maybe<IQuest>,
  readonly activateAlohaReward: IActivateAlohaRewardResponse,
  readonly processSmgCode: IProcessSmgCodeResponse,
  readonly createOrderlessTransaction: ITransaction,
  readonly associateGuestUser: Maybe<IAssociateGuestUserResponse>,
  readonly associateSecondaryId: Maybe<ISecondaryIdentifier>,
  readonly removeSecondaryIdAssociation: Maybe<Scalars['Boolean']>,
  readonly _loyaltyEmpty: Maybe<Scalars['String']>,
  readonly loyaltyGenerateOtp: ILoyaltyOtp,
  readonly loyaltyCreateOrderSelectionByType: ILoyaltyOstCreationPayload,
  readonly loyaltyDeleteOrderSelectionByType: Maybe<Scalars['Boolean']>,
  readonly loyaltyActivateQuest: Maybe<ILoyaltyQuest>,
  readonly loyaltyActivateAlohaReward: ILoyaltyActivateAlohaRewardResponse,
  readonly loyaltyProcessSmgCode: ILoyaltyProcessSmgCodeResponse,
  readonly loyaltyCreateOrderlessTransaction: ILoyaltyTransactionV2,
  readonly loyaltyAssociateGuestUser: Maybe<ILoyaltyAssociateGuestUserResponse>,
  readonly loyaltyAssociateSecondaryId: Maybe<ILoyaltySecondaryIdentifier>,
  readonly loyaltyRemoveSecondaryIdAssociation: Maybe<Scalars['Boolean']>,
  readonly addCreditAccount: IAccount,
  readonly addPaymentMethod: IAddPaymentMethodPayload,
  readonly resumeAddPaymentMethod: IAddPaymentMethodPayload,
  readonly updateDefaultPaymentMethod: IUpdateDefaultPaymentMethodPayload,
  readonly deletePaymentMethod: IDeletePaymentMethodPayload,
  readonly prepaidsMerge: IMerge,
  readonly prepaidsReload: IReload,
  readonly mergePrepaid: IMergePrepaidPayload,
  readonly purchasePrepaid: IPurchasePrepaidPayload,
  readonly reloadPrepaid: IReloadPrepaidPayload,
  readonly deleteAccount: Scalars['Boolean'],
  readonly prepaidsBalance: IBalance,
  readonly encryptionDetails: IEncryptionDetails,
  readonly addGiftAccount: IGiftAccount,
  readonly redeemPromoCode: Maybe<ICbaRedeemCouponResponse>,
  readonly validatePromoCode: Maybe<ICbaCouponResponse>,
  readonly loyaltyRedeemPromoCode: Maybe<ILoyaltyRedeemCouponResponse>,
  readonly loyaltyValidatePromoCode: Maybe<ILoyaltyCouponResponse>,
  readonly createLoginForVendor: Maybe<Scalars['String']>,
  readonly createOTP: ICreateOtp,
  readonly createLoginOTP: ICreateOtp,
  readonly createSmsOtp: ICreateOtp,
  readonly exchangeOTPCodeForCognitoCredentials: ICognitoCredentials,
  readonly resendCurrentLoginOTP: ICreateOtp,
  readonly resendVerificationEmail: Maybe<Scalars['Boolean']>,
  readonly signInJWT: Maybe<Scalars['Boolean']>,
  readonly signUpSmsOtp: Scalars['String'],
  readonly validateAuthJwt: ICognitoCredentials,
  readonly signUp: Maybe<Scalars['String']>,
  readonly sendPhoneVerification: Maybe<Scalars['Boolean']>,
  readonly verifyPhoneNumber: Maybe<Scalars['Boolean']>,
  readonly deleteMe: Maybe<Scalars['Boolean']>,
  readonly requestMyInfo: Maybe<Scalars['Boolean']>,
  readonly createSupportCase: Maybe<ISupportCase>,
  readonly saveDeliveryAddress: IDeliveryAddressResponse,
  readonly removeDeliveryAddress: IDeliveryAddressResponse,
}


export interface IMutationRedeemCouponArgs {
  couponId: Scalars['ID']
}


export interface IMutationCreateFavoriteArgs {
  input: IFavoriteInput
}


export interface IMutationUpdateFavoriteArgs {
  favoriteId: Scalars['String'],
  input: IFavoriteInput
}


export interface IMutationDeleteFavoriteArgs {
  favoriteId: Scalars['String']
}


export interface IMutationCommitOrderArgs {
  input: ICommitOrderInput,
  delivery: Maybe<ICommitDeliveryInput>,
  skipCoolingPeriod: Maybe<Scalars['Boolean']>
}


export interface IMutationPriceOrderArgs {
  input: IPriceOrderInput,
  delivery: Maybe<IPriceDeliveryInput>
}


export interface IMutationUpdateOrderArgs {
  input: IUpdateOrderInput
}


export interface IMutationLoyaltyCreateOrderSelectionArgs {
  input: ILoyaltyCreateOrderSelectionInput
}


export interface IMutationLoyaltyDeleteOrderSelectionArgs {
  input: ILoyaltyDeleteOrderSelectionInput
}


export interface IMutationGenerateOtpArgs {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>,
  loyaltyId: Scalars['ID'],
  restaurantId: Maybe<Scalars['ID']>
}


export interface IMutationCreateOrderSelectionByTypeArgs {
  ostType: OstType,
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>,
  loyaltyId: Scalars['ID'],
  restaurantId: Maybe<Scalars['ID']>
}


export interface IMutationDeleteOrderSelectionArgs {
  otp: Scalars['String'],
  loyaltyId: Maybe<Scalars['ID']>
}


export interface IMutationDeleteOrderSelectionByTypeArgs {
  key: Scalars['String'],
  ostType: OstType,
  loyaltyId: Maybe<Scalars['ID']>
}


export interface IMutationActivateQuestArgs {
  questId: Scalars['ID'],
  loyaltyId: Scalars['ID']
}


export interface IMutationActivateAlohaRewardArgs {
  loyaltyId: Scalars['ID'],
  rewardSanityId: Scalars['String']
}


export interface IMutationProcessSmgCodeArgs {
  loyaltyId: Scalars['ID'],
  smgCode: Scalars['String'],
  transactionDate: Maybe<Scalars['String']>
}


export interface IMutationCreateOrderlessTransactionArgs {
  input: IOrderlessTransactionInput
}


export interface IMutationAssociateGuestUserArgs {
  identifier: Scalars['String'],
  loyaltyId: Scalars['ID']
}


export interface IMutationAssociateSecondaryIdArgs {
  identifier: Scalars['String'],
  loyaltyId: Scalars['ID']
}


export interface IMutationRemoveSecondaryIdAssociationArgs {
  identifier: Scalars['String'],
  identifierType: SecondaryIdentifierType
}


export interface IMutationLoyaltyGenerateOtpArgs {
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>,
  loyaltyId: Scalars['LoyaltyID'],
  restaurantId: Maybe<Scalars['LoyaltyID']>
}


export interface IMutationLoyaltyCreateOrderSelectionByTypeArgs {
  ostType: LoyaltyOstType,
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>,
  loyaltyId: Scalars['LoyaltyID'],
  restaurantId: Maybe<Scalars['LoyaltyID']>
}


export interface IMutationLoyaltyDeleteOrderSelectionByTypeArgs {
  key: Scalars['String'],
  ostType: LoyaltyOstType,
  loyaltyId: Maybe<Scalars['LoyaltyID']>
}


export interface IMutationLoyaltyActivateQuestArgs {
  questId: Scalars['LoyaltyID'],
  loyaltyId: Scalars['LoyaltyID']
}


export interface IMutationLoyaltyActivateAlohaRewardArgs {
  loyaltyId: Scalars['LoyaltyID'],
  rewardSanityId: Scalars['String']
}


export interface IMutationLoyaltyProcessSmgCodeArgs {
  loyaltyId: Scalars['LoyaltyID'],
  smgCode: Scalars['String'],
  transactionDate: Maybe<Scalars['String']>
}


export interface IMutationLoyaltyCreateOrderlessTransactionArgs {
  input: ILoyaltyOrderlessTransactionInput
}


export interface IMutationLoyaltyAssociateGuestUserArgs {
  identifier: Scalars['String'],
  loyaltyId: Scalars['LoyaltyID']
}


export interface IMutationLoyaltyAssociateSecondaryIdArgs {
  identifier: Scalars['String'],
  loyaltyId: Scalars['LoyaltyID']
}


export interface IMutationLoyaltyRemoveSecondaryIdAssociationArgs {
  identifier: Scalars['String'],
  identifierType: LoyaltySecondaryIdentifierType
}


export interface IMutationAddCreditAccountArgs {
  input: IAddCreditAccountInput
}


export interface IMutationAddPaymentMethodArgs {
  input: IAddPaymentMethodInput
}


export interface IMutationResumeAddPaymentMethodArgs {
  input: IResumeAddPaymentMethodInput
}


export interface IMutationUpdateDefaultPaymentMethodArgs {
  input: IUpdateDefaultPaymentMethodInput
}


export interface IMutationDeletePaymentMethodArgs {
  input: IDeletePaymentMethodInput
}


export interface IMutationPrepaidsMergeArgs {
  input: IPrepaidsMergeInput
}


export interface IMutationPrepaidsReloadArgs {
  input: IPrepaidsReloadInput
}


export interface IMutationMergePrepaidArgs {
  input: IMergePrepaidInput
}


export interface IMutationPurchasePrepaidArgs {
  input: IPurchasePrepaidInput
}


export interface IMutationReloadPrepaidArgs {
  input: IReloadPrepaidInput
}


export interface IMutationDeleteAccountArgs {
  input: IDeleteAccountInput
}


export interface IMutationPrepaidsBalanceArgs {
  cardNumber: Scalars['String'],
  feCountryCode: Maybe<IsoCountryCode>
}


export interface IMutationAddGiftAccountArgs {
  input: IAddGiftAccountInput
}


export interface IMutationRedeemPromoCodeArgs {
  code: Scalars['String'],
  cognitoId: Scalars['String']
}


export interface IMutationValidatePromoCodeArgs {
  code: Scalars['String'],
  cognitoId: Scalars['String'],
  shouldRedeem: Maybe<Scalars['Boolean']>,
  offers: ReadonlyArray<Scalars['String']>
}


export interface IMutationLoyaltyRedeemPromoCodeArgs {
  input: Maybe<ILoyaltyRedeemPromoCodeInput>
}


export interface IMutationLoyaltyValidatePromoCodeArgs {
  input: Maybe<ILoyaltyValidatePromoCodeInput>
}


export interface IMutationCreateLoginForVendorArgs {
  vendor: Scalars['String']
}


export interface IMutationCreateOtpArgs {
  input: ICreateOtpInput
}


export interface IMutationCreateLoginOtpArgs {
  input: ICreateOtpInput
}


export interface IMutationCreateSmsOtpArgs {
  input: ICreateSmsOtpInput
}


export interface IMutationExchangeOtpCodeForCognitoCredentialsArgs {
  input: IExchangeOtpCodeForCredentialsInput
}


export interface IMutationResendCurrentLoginOtpArgs {
  input: IResendOtpInput
}


export interface IMutationResendVerificationEmailArgs {
  input: IResendVerificationEmailInput
}


export interface IMutationSignInJwtArgs {
  userInfo: ISignInUserInput
}


export interface IMutationSignUpSmsOtpArgs {
  input: ISignUpSmsOtpInput
}


export interface IMutationValidateAuthJwtArgs {
  authInput: IValidateAuthJwtInput
}


export interface IMutationSignUpArgs {
  userInfo: ISignUpUserInput
}


export interface IMutationSendPhoneVerificationArgs {
  input: IResendPhoneVerificationInput
}


export interface IMutationVerifyPhoneNumberArgs {
  input: IVerifyPhoneNumberInput
}


export interface IMutationCreateSupportCaseArgs {
  caseInfo: ISupportCaseInput
}


export interface IMutationSaveDeliveryAddressArgs {
  input: ISaveDeliveryAddressInput
}


export interface IMutationRemoveDeliveryAddressArgs {
  input: IRemoveDeliveryAddressInput
}

export interface INode {
  readonly id: Maybe<Scalars['ID']>,
}

export interface IObjectType {
  readonly __typename?: 'ObjectType',
  readonly key: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['JSON']>,
}

export interface IOffer  extends IBaseIncentive {
  readonly __typename?: 'Offer',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>,
  readonly id: Scalars['ID'],
  readonly maxRedemptionsDuration: Maybe<DurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<IObjectType>>>,
  readonly paymentMethod: Maybe<PaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<BirthdayDuration>,
  readonly userEnrollment: Maybe<IDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<DayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<ServiceMode>>>,
  readonly storeRestrictions: Maybe<IStoreRestrictions>,
  readonly benefits: Maybe<ReadonlyArray<IBenefit>>,
  readonly errors: Maybe<ReadonlyArray<IRuleConditionEvaluation>>,
  readonly isStackable: Maybe<Scalars['Boolean']>,
  readonly loyaltyId: Maybe<Scalars['ID']>,
  readonly redemptionType: Maybe<OfferRedemptionType>,
  readonly type: OfferType,
  readonly configId: Maybe<Scalars['ID']>,
  readonly templateId: Maybe<Scalars['ID']>,
  readonly questId: Maybe<Scalars['String']>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IOfferRedemptionAvailability {
  readonly __typename?: 'OfferRedemptionAvailability',
  readonly availableAfter: Maybe<Scalars['String']>,
  readonly transactionId: Maybe<Scalars['String']>,
}

export enum OfferRedemptionType {
  PROMO_CODE = 'PROMO_CODE',
  STANDARD = 'STANDARD',
  SURPRISE = 'SURPRISE',
  SWAP = 'SWAP'
}

export interface IOffersInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly appliedPromotions?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<IRbiCartEntryInput>>,
  readonly configId?: Maybe<Scalars['ID']>,
  readonly global?: Maybe<Scalars['Boolean']>,
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly ignoreRules?: Maybe<Scalars['Boolean']>,
  readonly isTransactionCreation?: Maybe<Scalars['Boolean']>,
  readonly limit?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
  readonly paymentMethod?: Maybe<PaymentMethod>,
  readonly redemptionTypes?: Maybe<ReadonlyArray<OfferRedemptionType>>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IOfferVariable {
  readonly __typename?: 'OfferVariable',
  readonly key: Scalars['String'],
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}

export interface IOperatingHours {
  readonly __typename?: 'OperatingHours',
  readonly monOpen: Maybe<Scalars['String']>,
  readonly monClose: Maybe<Scalars['String']>,
  readonly tueOpen: Maybe<Scalars['String']>,
  readonly tueClose: Maybe<Scalars['String']>,
  readonly wedOpen: Maybe<Scalars['String']>,
  readonly wedClose: Maybe<Scalars['String']>,
  readonly thrOpen: Maybe<Scalars['String']>,
  readonly thrClose: Maybe<Scalars['String']>,
  readonly friOpen: Maybe<Scalars['String']>,
  readonly friClose: Maybe<Scalars['String']>,
  readonly satOpen: Maybe<Scalars['String']>,
  readonly satClose: Maybe<Scalars['String']>,
  readonly sunOpen: Maybe<Scalars['String']>,
  readonly sunClose: Maybe<Scalars['String']>,
}

export enum OperationalStatus {
  CLOSED = 'CLOSED',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPEN = 'OPEN',
  PROJECTED = 'PROJECTED'
}

export interface IOption {
  readonly __typename?: 'Option',
  readonly id: Scalars['String'],
  readonly options: Maybe<ReadonlyArray<IModifier>>,
}

export interface IOrbitalPayment {
  readonly accountIdentifier?: Maybe<Scalars['String']>,
  readonly savePaymentMethod?: Maybe<Scalars['Boolean']>,
  readonly encryptedPayload?: Maybe<IAddOrbitalAccountInput>,
}

export interface IOrder {
  readonly __typename?: 'Order',
  readonly cart: ICart,
  readonly catering: Maybe<ICatering>,
  readonly createdAt: Scalars['String'],
  readonly delivery: Maybe<IDelivery>,
  readonly earliestPickupTimeInSeconds: Maybe<Scalars['Int']>,
  readonly fireOrderIn: Maybe<Scalars['Int']>,
  readonly fulfillmentDetails: Maybe<IFulfillmentDetails>,
  readonly id: Maybe<Scalars['String']>,
  readonly order: Maybe<IRbiOrder>,
  readonly orderNumberFormatted: Maybe<Scalars['String']>,
  readonly pk: Scalars['String'],
  readonly posOrderId: Maybe<Scalars['String']>,
  readonly posVendor: PosVendor,
  readonly rbiOrderId: Scalars['String'],
  readonly revision: Scalars['Int'],
  readonly sk: Scalars['String'],
  readonly status: RbiOrderStatus,
  readonly updatedAt: Scalars['String'],
  readonly userId: Maybe<Scalars['String']>,
  readonly userSortKey: Scalars['String'],
  readonly loyaltyTransaction: Maybe<ILoyaltyTransaction>,
}

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
  TEMPORARY_UNAVAILABLE = 'temporary_unavailable',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable'
}

export interface IOrderlessIncentiveInput {
  readonly id: Scalars['String'],
  readonly type: PromotionType,
  readonly metadata?: Maybe<Scalars['JSON']>,
}

export interface IOrderlessTransactionInput {
  readonly cognitoId?: Maybe<Scalars['String']>,
  readonly loyaltyId?: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly storeId?: Maybe<Scalars['String']>,
  readonly incentives: ReadonlyArray<IOrderlessIncentiveInput>,
}

export interface IOrderListResponse {
  readonly __typename?: 'OrderListResponse',
  readonly count: Scalars['Int'],
  readonly orders: Maybe<ReadonlyArray<Maybe<IOrder>>>,
  readonly resumeAfter: Maybe<Scalars['String']>,
}

export enum OrderSelectionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING'
}

export interface IOrderSelectionTransfer {
  readonly __typename?: 'OrderSelectionTransfer',
  readonly createdAt: Scalars['String'],
  readonly expiry: Maybe<Scalars['Int']>,
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly order: ReadonlyArray<IInRestaurantOrderLineItemType>,
  readonly otp: Maybe<Scalars['String']>,
  readonly restaurantId: Maybe<Scalars['String']>,
  readonly updatedAt: Maybe<Scalars['String']>,
  readonly status: Maybe<OrderSelectionStatus>,
  readonly transactionId: Maybe<Scalars['String']>,
}

export interface IOstCreationPayload {
  readonly __typename?: 'OstCreationPayload',
  readonly expirationTime: Scalars['String'],
  readonly key: Scalars['String'],
}

export enum OstType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface IOtp {
  readonly __typename?: 'Otp',
  readonly expirationTime: Scalars['String'],
  readonly password: Scalars['String'],
}

export interface IOverride {
  readonly __typename?: 'Override',
  readonly key: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly price: Maybe<Scalars['Int']>,
}

export interface IPageInfo {
  readonly __typename?: 'PageInfo',
  readonly hasNextPage: Scalars['Boolean'],
  readonly hasPreviousPage: Scalars['Boolean'],
  readonly startCursor: Maybe<Scalars['String']>,
  readonly endCursor: Maybe<Scalars['String']>,
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu',
  readonly plu: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
}

export interface IParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface IPaycometPayment {
  readonly pspReference?: Maybe<Scalars['String']>,
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>,
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>,
}

export interface IPayMarkPayment {
  readonly pspReference?: Maybe<Scalars['String']>,
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>,
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>,
  readonly merchantAccount?: Maybe<Scalars['String']>,
}

export interface IPayment {
  readonly __typename?: 'Payment',
  readonly approvalNumber: Maybe<Scalars['String']>,
  readonly cardType: Maybe<Scalars['String']>,
  readonly ccLast4: Maybe<Scalars['String']>,
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly fdSaleId: Scalars['String'],
  readonly panToken: Maybe<Scalars['String']>,
  readonly paymentType: Maybe<CartPaymentType>,
}

export interface IPaymentBillingAddressInput {
  readonly streetNumber?: Maybe<Scalars['String']>,
  readonly route?: Maybe<Scalars['String']>,
  readonly locality?: Maybe<Scalars['String']>,
  readonly administrativeArea?: Maybe<Scalars['String']>,
  readonly postalCode?: Maybe<Scalars['String']>,
  readonly regionCode: Scalars['String'],
}

export interface IPaymentConfig {
  readonly __typename?: 'PaymentConfig',
  readonly allowedPaymentMethods: ReadonlyArray<PaymentMethodType>,
  readonly frontendIntegration: FrontendIntegration,
  readonly applePay: Maybe<IApplePayPaymentConfig>,
  readonly googlePay: Maybe<IGooglePayPaymentConfig>,
}

export interface IPaymentExpiration {
  readonly __typename?: 'PaymentExpiration',
  readonly month: Maybe<Scalars['Int']>,
  readonly year: Maybe<Scalars['Int']>,
}

export interface IPaymentInput {
  readonly adyenInput?: Maybe<IAdyenPayment>,
  readonly applePayDetails?: Maybe<IApplePay>,
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  readonly cashPayment?: Maybe<Scalars['Boolean']>,
  readonly ccMetadata?: Maybe<ICreditCardMetadataInput>,
  readonly chaseProfileId?: Maybe<Scalars['String']>,
  readonly firstDataInput?: Maybe<IFirstDataPayment>,
  readonly fullName: Scalars['String'],
  readonly googlePayDetails?: Maybe<IGooglePay>,
  readonly kountSessionId?: Maybe<Scalars['String']>,
  readonly vrPaymentInput?: Maybe<IVrPayment>,
  readonly payMarkInput?: Maybe<IPayMarkPayment>,
  readonly firstPayInput?: Maybe<IFirstpayPayment>,
  readonly paycometInput?: Maybe<IPaycometPayment>,
  readonly orbitalInput?: Maybe<IOrbitalPayment>,
  readonly worldpayInput?: Maybe<IWorldpayPayment>,
}

export enum PaymentMethod {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERSCLUB = 'DINERSCLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA'
}

export interface IPaymentMethodData {
  readonly displayName?: Maybe<Scalars['String']>,
  readonly paymentType?: Maybe<Scalars['String']>,
  readonly paymentMethodType?: Maybe<Scalars['String']>,
}

export enum PaymentMethodType {
  SCHEME = 'SCHEME',
  PREPAID = 'PREPAID',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL_FAST = 'PAYPAL_FAST'
}

export interface IPaymentPreferences {
  readonly __typename?: 'PaymentPreferences',
  readonly storedPaymentMethodId: Maybe<Scalars['String']>,
  readonly scanAndPayStoredPaymentMethodId: Maybe<Scalars['String']>,
  readonly reloadAmount: Maybe<Scalars['Int']>,
  readonly autoReload: Scalars['Boolean'],
  readonly autoReloadThreshold: Maybe<Scalars['Int']>,
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  CHASE = 'CHASE',
  FIRSTDATA = 'FIRSTDATA',
  VRPAYMENT = 'VRPAYMENT',
  ORBITAL = 'ORBITAL',
  PAYMARK = 'PAYMARK',
  FIRSTPAY = 'FIRSTPAY',
  PAYCOMET = 'PAYCOMET'
}

export interface IPayPalFastStoredPaymentMethod  extends IStoredPaymentMethod {
  readonly __typename?: 'PayPalFastStoredPaymentMethod',
  readonly id: Scalars['ID'],
  readonly type: PaymentMethodType,
  readonly billingAgreementId: Scalars['String'],
}

export interface IPerson {
  readonly __typename?: 'Person',
  readonly externalIds: Maybe<ReadonlyArray<Maybe<IExternalIdentifier>>>,
  readonly phone: Maybe<Scalars['String']>,
  readonly email: Maybe<Scalars['String']>,
}

export interface IPhysicalAddress {
  readonly __typename?: 'PhysicalAddress',
  readonly address1: Maybe<Scalars['String']>,
  readonly address2: Maybe<Scalars['String']>,
  readonly city: Maybe<Scalars['String']>,
  readonly country: Maybe<Scalars['String']>,
  readonly postalCode: Maybe<Scalars['String']>,
  readonly stateProvince: Maybe<Scalars['String']>,
  readonly stateProvinceShort: Maybe<Scalars['String']>,
}

export interface IPickupContact {
  readonly __typename?: 'PickupContact',
  readonly name: Maybe<Scalars['String']>,
  readonly phone: Maybe<Scalars['String']>,
  readonly hasArrived: Scalars['Boolean'],
  readonly vehicle: Maybe<IPickupContactVehicle>,
}

export interface IPickupContactVehicle {
  readonly __typename?: 'PickupContactVehicle',
  readonly make: Maybe<Scalars['String']>,
  readonly model: Maybe<Scalars['String']>,
  readonly color: Maybe<Scalars['String']>,
  readonly licensePlate: Maybe<Scalars['String']>,
}

export interface IPlaceCateringOrderInput {
  readonly billingAddress?: Maybe<IBillingAddressInput>,
  readonly cateringInfo: ICateringInfoInput,
  readonly ccBin?: Maybe<Scalars['String']>,
  readonly ccExpiryMonth?: Maybe<Scalars['String']>,
  readonly ccExpiryYear?: Maybe<Scalars['String']>,
  readonly ccLast4?: Maybe<Scalars['String']>,
  readonly creditType?: Maybe<CartPaymentCardType>,
  readonly storeEmail?: Maybe<Scalars['String']>,
  readonly fdAccessToken?: Maybe<Scalars['String']>,
  readonly fdNonce?: Maybe<Scalars['String']>,
  readonly fdAccountId?: Maybe<Scalars['String']>,
  readonly fullName?: Maybe<Scalars['String']>,
  readonly rbiOrderId: Scalars['ID'],
  readonly kountSessionId?: Maybe<Scalars['String']>,
  readonly sessionId?: Maybe<Scalars['String']>,
  readonly redeemedOn?: Maybe<Scalars['String']>,
  readonly threeDSDetails?: Maybe<IResumeThreeDSaleTransaction>,
}

export enum Platform {
  APP = 'app',
  KIOSK = 'kiosk',
  WEB = 'web'
}

export interface IPlu {
  readonly __typename?: 'Plu',
  readonly connector: Maybe<Scalars['String']>,
  readonly ncr: Maybe<Scalars['String']>,
  readonly ncrDelivery: Maybe<Scalars['String']>,
  readonly oheics: Maybe<Scalars['String']>,
  readonly oheicsDelivery: Maybe<Scalars['String']>,
  readonly partner: Maybe<Scalars['String']>,
  readonly partnerDelivery: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['String']>,
  readonly productNumberDelivery: Maybe<Scalars['String']>,
  readonly qst: Maybe<Scalars['String']>,
  readonly qstDelivery: Maybe<Scalars['String']>,
  readonly sicom: Maybe<Scalars['String']>,
  readonly sicomDelivery: Maybe<Scalars['String']>,
  readonly simplyDelivery: Maybe<Scalars['String']>,
  readonly simplyDeliveryDelivery: Maybe<Scalars['String']>,
}

export interface IPluInput {
  readonly connector?: Maybe<Scalars['String']>,
  readonly ncr?: Maybe<Scalars['String']>,
  readonly ncrDelivery?: Maybe<Scalars['String']>,
  readonly oheics?: Maybe<Scalars['String']>,
  readonly oheicsDelivery?: Maybe<Scalars['String']>,
  readonly partner?: Maybe<Scalars['String']>,
  readonly partnerDelivery?: Maybe<Scalars['String']>,
  readonly productNumber?: Maybe<Scalars['String']>,
  readonly qst?: Maybe<Scalars['String']>,
  readonly qstDelivery?: Maybe<Scalars['String']>,
  readonly rpos?: Maybe<Scalars['String']>,
  readonly rposDelivery?: Maybe<Scalars['String']>,
  readonly sicom?: Maybe<Scalars['String']>,
  readonly sicomDelivery?: Maybe<Scalars['String']>,
  readonly simplyDelivery?: Maybe<Scalars['String']>,
  readonly simplyDeliveryDelivery?: Maybe<Scalars['String']>,
}

export interface IPluPrice {
  readonly __typename?: 'PluPrice',
  readonly plu: Scalars['String'],
  readonly price: Scalars['Int'],
}

export enum PosDataServiceMode {
  DELIVERY = 'delivery',
  PICKUP = 'pickup'
}

export enum PosVendor {
  CARROLS = 'CARROLS',
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  OHEICS = 'OHEICS',
  PARTNER = 'PARTNER',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  QST = 'QST',
  RPOS = 'RPOS',
  SICOM = 'SICOM',
  SIMPLY_DELIVERY = 'SIMPLY_DELIVERY',
  TABLET = 'TABLET'
}

export interface IPrepaidDetails {
  readonly __typename?: 'PrepaidDetails',
  readonly last4: Scalars['String'],
  readonly cardNumber: Scalars['String'],
  readonly expiryMonth: Scalars['String'],
  readonly expiryYear: Scalars['String'],
  readonly balance: Scalars['Int'],
  readonly currency: Scalars['String'],
}

export interface IPrepaidsMergeInput {
  readonly destinationFdAccountId?: Maybe<Scalars['String']>,
  readonly sourceCardNumber: Scalars['String'],
  readonly sourcePin?: Maybe<Scalars['String']>,
}

export interface IPrepaidsReloadInput {
  readonly countryCode?: Maybe<CountryCode>,
  readonly fdAccountId?: Maybe<Scalars['String']>,
  readonly fundValue: Scalars['Int'],
  readonly prepaidFdAccountId: Scalars['String'],
  readonly applePayDetails?: Maybe<IApplePay>,
  readonly googlePayDetails?: Maybe<IGooglePay>,
  readonly kountSessionId?: Maybe<Scalars['String']>,
  readonly sessionId?: Maybe<Scalars['String']>,
}

export interface IPrepaidStoredPaymentMethod  extends IStoredPaymentMethod {
  readonly __typename?: 'PrepaidStoredPaymentMethod',
  readonly id: Scalars['ID'],
  readonly type: PaymentMethodType,
  readonly last4: Scalars['String'],
  readonly balance: Scalars['Int'],
  readonly currency: Scalars['String'],
  readonly shuffledCardNumber: Scalars['String'],
}

export interface IPrepaidTransaction {
  readonly __typename?: 'PrepaidTransaction',
  readonly amount: Scalars['Int'],
  readonly currencyCode: ICurrencyCode,
  readonly info: Scalars['String'],
  readonly transactionTime: Scalars['String'],
}

export interface IPrepaidTransactions {
  readonly __typename?: 'PrepaidTransactions',
  readonly amount: Scalars['Int'],
  readonly currency: Scalars['String'],
  readonly info: Scalars['String'],
  readonly timestamp: Scalars['String'],
}

export interface IPrice {
  readonly __typename?: 'Price',
  readonly default: Maybe<Scalars['Int']>,
  readonly max: Maybe<Scalars['Int']>,
  readonly min: Maybe<Scalars['Int']>,
  readonly overrides: Maybe<ReadonlyArray<IOverride>>,
}

export interface IPriceDeliveryInput {
  readonly instructions?: Maybe<Scalars['String']>,
  readonly dropoff: IDeliveryWaypointInput,
  readonly tipCents?: Maybe<Scalars['Int']>,
  readonly quoteId?: Maybe<Scalars['String']>,
}

export interface IPriceOrderInput {
  readonly paymentMethod?: Maybe<CartPaymentCardType>,
  readonly storeAddress: IStoreAddressInput,
  readonly storeId: Scalars['String'],
  readonly storePosId?: Maybe<Scalars['String']>,
  readonly brand: Brand,
  readonly platform?: Maybe<Platform>,
  readonly posVendor: PosVendor,
  readonly customerLocale?: Maybe<Scalars['String']>,
  readonly customerName?: Maybe<Scalars['String']>,
  readonly serviceMode: ServiceMode,
  readonly requestedAmountCents: Scalars['Int'],
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly cartVersion?: Maybe<Scalars['Int']>,
  readonly loyaltyBarcode?: Maybe<Scalars['String']>,
  readonly quotedId?: Maybe<Scalars['String']>,
  readonly redeemReward?: Maybe<Scalars['Boolean']>,
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<IAppliedOffer>>>,
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<IAppliedReward>>>,
  readonly redeemedOn?: Maybe<Scalars['String']>,
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ISwapInput>>>,
  readonly vatNumber?: Maybe<Scalars['String']>,
}

export interface IProcessSmgCodeResponse {
  readonly __typename?: 'ProcessSmgCodeResponse',
  readonly pointsEarned: Scalars['Int'],
  readonly status: SmgCodeStatus,
}

export interface IProductHierarchyInput {
  readonly L1?: Maybe<Scalars['String']>,
  readonly L2?: Maybe<Scalars['String']>,
  readonly L3?: Maybe<Scalars['String']>,
  readonly L4?: Maybe<Scalars['String']>,
  readonly L5?: Maybe<Scalars['String']>,
}

export interface IPromotion {
  readonly __typename?: 'Promotion',
  readonly id: Scalars['String'],
  readonly lineId: Maybe<Scalars['String']>,
  readonly type: PromotionType,
}

export interface IPromotionInput {
  readonly id: Scalars['String'],
  readonly lineId?: Maybe<Scalars['String']>,
  readonly swap?: Maybe<IPromotionSwapInput>,
  readonly type: PromotionType,
}

export interface IPromotionsInput {
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
}

export interface IPromotionSwapInput {
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly type: SwapType,
  readonly lineId: Scalars['String'],
}

export enum PromotionType {
  OFFER = 'OFFER',
  REWARD = 'REWARD',
  SYSTEMWIDE_PROMOTION = 'SYSTEMWIDE_PROMOTION'
}

export interface IPurchasePrepaidAuthorized {
  readonly __typename?: 'PurchasePrepaidAuthorized',
  readonly prepaidDetails: IPrepaidDetails,
}

export interface IPurchasePrepaidInput {
  readonly paymentMethod: Scalars['String'],
  readonly currency: Scalars['String'],
  readonly amount: Scalars['Int'],
  readonly riskData: Scalars['String'],
  readonly billingAddress?: Maybe<IPaymentBillingAddressInput>,
  readonly platform?: Maybe<Platform>,
}

export type IPurchasePrepaidPayload = IPurchasePrepaidAuthorized | IPurchasePrepaidRefused;

export enum PurchasePrepaidRefusalCode {
  BANK_DECLINED = 'BANK_DECLINED'
}

export interface IPurchasePrepaidRefused {
  readonly __typename?: 'PurchasePrepaidRefused',
  readonly code: PurchasePrepaidRefusalCode,
}

export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu',
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface IQuery {
  readonly __typename?: 'Query',
  readonly getSanityMenu: Maybe<Scalars['GenericScalar']>,
  readonly upsellRecommendations: IRecommendations,
  readonly evaluateAllUserOffers: ICouponUserOffersFeedback,
  readonly evaluateUserOffers: ICouponUserOffersFeedback,
  readonly listUserCouponTokens: ICouponTokenListResponse,
  readonly deliveryRestaurant: IDeliveryRestaurant,
  readonly userFavorite: IFavorite,
  readonly userFavorites: IFavoriteList,
  readonly order: Maybe<IOrder>,
  readonly uniqueStores: IOrderListResponse,
  readonly userOrders: IOrderListResponse,
  readonly _empty: Maybe<Scalars['String']>,
  readonly loyaltyOffers: Maybe<ReadonlyArray<IOffer>>,
  readonly loyaltyGetOrderSelection: Maybe<ILoyaltyOrderSelection>,
  readonly orderSelection: Maybe<IOrderSelectionTransfer>,
  readonly orderSelectionByType: Maybe<IOrderSelectionTransfer>,
  readonly loyaltyQuests: Maybe<ReadonlyArray<IQuest>>,
  readonly loyaltyRewards: Maybe<ReadonlyArray<IReward>>,
  readonly loyaltyUser: Maybe<IUser>,
  readonly _loyaltyEmpty: Maybe<Scalars['String']>,
  readonly loyaltyOffersV2: Maybe<ReadonlyArray<ILoyaltyOffer>>,
  readonly loyaltyOrderSelection: Maybe<ILoyaltyOrderSelectionTransfer>,
  readonly loyaltyOrderSelectionByType: Maybe<ILoyaltyOrderSelectionTransfer>,
  readonly loyaltyQuestsV2: Maybe<ReadonlyArray<ILoyaltyQuest>>,
  readonly loyaltyRewardsV2: Maybe<ReadonlyArray<ILoyaltyReward>>,
  readonly loyaltyUserV2: Maybe<ILoyaltyUser>,
  readonly plus: Maybe<ReadonlyArray<IMenuItem>>,
  readonly plusV2: Maybe<ReadonlyArray<IPluPrice>>,
  readonly storeMenu: Maybe<ReadonlyArray<IEntity>>,
  readonly storeMenuWithConnectorHours: Maybe<ReadonlyArray<IMenuEntityWithHours>>,
  readonly userAccounts: Maybe<IAccountListResponse>,
  readonly storedPaymentMethods: ReadonlyArray<IStoredPaymentMethod>,
  readonly paymentConfig: IPaymentConfig,
  readonly paymentPreferences: IPaymentPreferences,
  readonly prepaidByNumber: IPrepaidDetails,
  readonly prepaidTransactionsByNumber: ReadonlyArray<Maybe<IPrepaidTransactions>>,
  readonly prepaidTransactionsById: ReadonlyArray<IPrepaidTransactions>,
  readonly prepaidsTransactions: Maybe<ITransactionListResponse>,
  readonly restaurant: IRestaurant,
  readonly restaurants: Maybe<IRestaurantsConnection>,
  readonly signUpComplete: Maybe<Scalars['Boolean']>,
  readonly userPhoneFromBraze: Maybe<IBrazeUserPhone>,
  readonly userGeo: IUserGeo,
}


export interface IQueryUpsellRecommendationsArgs {
  type: RecommendationType,
  limit?: Maybe<Scalars['Int']>,
  products: Maybe<ReadonlyArray<Maybe<IRecommendationProducts>>>,
  storeId: Maybe<Scalars['String']>,
  serviceMode: Maybe<Scalars['String']>
}


export interface IQueryEvaluateAllUserOffersArgs {
  locale: Maybe<Locale>,
  platform: Maybe<Platform>,
  redeemedOn: Scalars['String'],
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryEvaluateUserOffersArgs {
  cart: Maybe<IPriceOrderInput>,
  couponIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>,
  evaluateAllCouponIds: Maybe<Scalars['Boolean']>,
  locale: Maybe<Locale>,
  platform: Maybe<Platform>,
  rbiOrderId: Maybe<Scalars['ID']>,
  redeemedOn: Scalars['String'],
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryListUserCouponTokensArgs {
  couponId: Maybe<Scalars['ID']>,
  expiresAfter: Maybe<Scalars['String']>,
  expiresBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>
}


export interface IQueryDeliveryRestaurantArgs {
  dropoff: IDeliveryWaypointInput,
  searchRadius: Scalars['Float'],
  platform: Maybe<Platform>
}


export interface IQueryUserFavoriteArgs {
  favoriteId: Scalars['String']
}


export interface IQueryUserFavoritesArgs {
  limit: Maybe<Scalars['Int']>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryOrderArgs {
  rbiOrderId: Scalars['ID']
}


export interface IQueryUniqueStoresArgs {
  createdAfter: Maybe<Scalars['String']>,
  createdBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>
}


export interface IQueryUserOrdersArgs {
  createdAfter: Maybe<Scalars['String']>,
  createdBefore: Maybe<Scalars['String']>,
  limit: Maybe<Scalars['Int']>,
  orderStatuses: Maybe<ReadonlyArray<RbiOrderStatus>>,
  resumeAfter: Maybe<Scalars['String']>,
  sortAscending: Maybe<Scalars['Boolean']>,
  userId: Maybe<Scalars['ID']>,
  shouldFilterByRegion: Maybe<Scalars['Boolean']>
}


export interface IQueryLoyaltyOffersArgs {
  ids: Maybe<ReadonlyArray<Scalars['ID']>>,
  isTransactionCreation: Maybe<Scalars['Boolean']>,
  configId: Maybe<Scalars['ID']>,
  omitInvalids: Maybe<Scalars['Boolean']>,
  redemptionTypes: Maybe<ReadonlyArray<OfferRedemptionType>>,
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>,
  loyaltyId: Maybe<Scalars['ID']>,
  where: Maybe<IOffersInput>
}


export interface IQueryLoyaltyGetOrderSelectionArgs {
  key: Scalars['String'],
  type: LoyaltyOrderSelectionType
}


export interface IQueryOrderSelectionArgs {
  otp: Scalars['String']
}


export interface IQueryOrderSelectionByTypeArgs {
  key: Scalars['String'],
  ostType: OstType
}


export interface IQueryLoyaltyQuestsArgs {
  loyaltyId: Maybe<Scalars['ID']>
}


export interface IQueryLoyaltyRewardsArgs {
  ids: Maybe<ReadonlyArray<Scalars['ID']>>,
  isTransactionCreation: Maybe<Scalars['Boolean']>,
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>,
  omitInvalids: Maybe<Scalars['Boolean']>,
  loyaltyId: Maybe<Scalars['ID']>,
  where: Maybe<IRewardsInput>
}


export interface IQueryLoyaltyUserArgs {
  loyaltyId: Scalars['ID']
}


export interface IQueryLoyaltyOffersV2Args {
  ids: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  isTransactionCreation: Maybe<Scalars['Boolean']>,
  configId: Maybe<Scalars['LoyaltyID']>,
  omitInvalids: Maybe<Scalars['Boolean']>,
  redemptionTypes: Maybe<ReadonlyArray<LoyaltyOfferRedemptionType>>,
  serviceMode: Maybe<LoyaltyServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>,
  loyaltyId: Maybe<Scalars['LoyaltyID']>,
  where: Maybe<ILoyaltyOffersInput>
}


export interface IQueryLoyaltyOrderSelectionArgs {
  otp: Scalars['String']
}


export interface IQueryLoyaltyOrderSelectionByTypeArgs {
  key: Scalars['String'],
  ostType: LoyaltyOstType
}


export interface IQueryLoyaltyQuestsV2Args {
  loyaltyId: Maybe<Scalars['LoyaltyID']>
}


export interface IQueryLoyaltyRewardsV2Args {
  ids: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  isTransactionCreation: Maybe<Scalars['Boolean']>,
  serviceMode: Maybe<LoyaltyServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>,
  omitInvalids: Maybe<Scalars['Boolean']>,
  loyaltyId: Maybe<Scalars['LoyaltyID']>,
  where: Maybe<ILoyaltyRewardsInput>
}


export interface IQueryLoyaltyUserV2Args {
  loyaltyId: Scalars['LoyaltyID']
}


export interface IQueryPlusArgs {
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
}


export interface IQueryPlusV2Args {
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
}


export interface IQueryStoreMenuArgs {
  region: Scalars['String'],
  channel: Channel,
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
}


export interface IQueryStoreMenuWithConnectorHoursArgs {
  region: Scalars['String'],
  channel: Channel,
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
}


export interface IQueryUserAccountsArgs {
  feCountryCode: Maybe<Scalars['String']>
}


export interface IQueryPrepaidByNumberArgs {
  cardNumber: Scalars['String']
}


export interface IQueryPrepaidTransactionsByNumberArgs {
  cardNumber: Scalars['String']
}


export interface IQueryPrepaidTransactionsByIdArgs {
  storedPaymentMethodId: Scalars['String']
}


export interface IQueryPrepaidsTransactionsArgs {
  fdAccountId: Maybe<Scalars['String']>,
  cardNumber: Maybe<Scalars['String']>
}


export interface IQueryRestaurantArgs {
  storeId: Maybe<Scalars['String']>,
  storeNumber: Maybe<Scalars['String']>,
  localDateTime: Maybe<Scalars['String']>
}


export interface IQueryRestaurantsArgs {
  input: Maybe<IRestaurantsInput>
}


export interface IQuerySignUpCompleteArgs {
  jwt: Scalars['String']
}


export interface IQueryUserPhoneFromBrazeArgs {
  brazeId: Maybe<Scalars['String']>
}

export interface IQuest {
  readonly __typename?: 'Quest',
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly completions: Maybe<ReadonlyArray<Maybe<IQuestCompletion>>>,
  readonly configId: Maybe<Scalars['ID']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>,
  readonly id: Scalars['ID'],
  readonly incentiveType: QuestIncentiveType,
  readonly incentiveId: Maybe<Scalars['ID']>,
  readonly incentiveRedeemed: Scalars['Boolean'],
  readonly lastCompletion: Maybe<IQuestCompletion>,
  readonly sanityId: Maybe<Scalars['String']>,
  readonly startDate: Scalars['String'],
  readonly status: QuestStatus,
  readonly steps: Maybe<ReadonlyArray<IQuestStep>>,
}

export interface IQuestCompletion {
  readonly __typename?: 'QuestCompletion',
  readonly benefitId: Scalars['String'],
  readonly completedAt: Scalars['String'],
  readonly redeemed: Scalars['Boolean'],
}

export enum QuestIncentiveType {
  BONUS_POINTS = 'BONUS_POINTS',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export enum QuestStatus {
  NOT_ENROLLED = 'NOT_ENROLLED',
  ACTIVATED = 'ACTIVATED',
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export interface IQuestStep {
  readonly __typename?: 'QuestStep',
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>,
  readonly completedAt: Maybe<Scalars['String']>,
  readonly id: Scalars['String'],
  readonly status: QuestStepStatus,
}

export enum QuestStepStatus {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export interface IRbiCartEntryInput {
  readonly lineId?: Maybe<Scalars['String']>,
  readonly sanityId: Scalars['String'],
  readonly price?: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly children?: Maybe<ReadonlyArray<IRbiCartEntryInput>>,
}

export enum RbiChannel {
  APP = 'APP',
  ORDERLESS = 'ORDERLESS',
  RECEIPT = 'RECEIPT',
  REMEDIATION = 'REMEDIATION',
  RESTAURANT = 'RESTAURANT',
  WEB = 'WEB'
}

export interface IRbiOrder {
  readonly __typename?: 'RbiOrder',
  readonly refund: Maybe<IRefund>,
}

export enum RbiOrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface IRbiParentChildPlu {
  readonly __typename?: 'RbiParentChildPlu',
  readonly plu: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
}

export interface IRbiParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface IRbiQuantityPlu {
  readonly __typename?: 'RbiQuantityPlu',
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IRbiQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface IRbiSizeBasedPlu {
  readonly __typename?: 'RbiSizeBasedPlu',
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface IRbiSizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

export interface IRbiVendorConfig {
  readonly __typename?: 'RbiVendorConfig',
  readonly pluType: Maybe<Scalars['String']>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Int']>,
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly discountPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IRbiQuantityPlu>>>,
  readonly parentChildPlu: Maybe<IRbiParentChildPlu>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IRbiQuantityPlu>>>,
  readonly sizeBasedPlu: Maybe<IRbiSizeBasedPlu>,
}

export interface IRbiVendorConfigInput {
  readonly pluType?: Maybe<Scalars['String']>,
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly discountPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IRbiQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<IRbiParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IRbiQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<IRbiSizeBasedPluInput>,
}

export interface IRbiVendorConfigs {
  readonly __typename?: 'RbiVendorConfigs',
  readonly brink: Maybe<IRbiVendorConfig>,
  readonly brinkDelivery: Maybe<IRbiVendorConfig>,
  readonly carrols: Maybe<IRbiVendorConfig>,
  readonly carrolsDelivery: Maybe<IRbiVendorConfig>,
  readonly hdx: Maybe<IRbiVendorConfig>,
  readonly ncr: Maybe<IRbiVendorConfig>,
  readonly ncrDelivery: Maybe<IRbiVendorConfig>,
  readonly productNumber: Maybe<IRbiVendorConfig>,
  readonly productNumberDelivery: Maybe<IRbiVendorConfig>,
  readonly qdi: Maybe<IRbiVendorConfig>,
  readonly qdiDelivery: Maybe<IRbiVendorConfig>,
  readonly oheics: Maybe<IRbiVendorConfig>,
  readonly oheicsDelivery: Maybe<IRbiVendorConfig>,
  readonly partner: Maybe<IRbiVendorConfig>,
  readonly partnerDelivery: Maybe<IRbiVendorConfig>,
  readonly qst: Maybe<IRbiVendorConfig>,
  readonly rpos: Maybe<IRbiVendorConfig>,
  readonly rposDelivery: Maybe<IRbiVendorConfig>,
  readonly sicom: Maybe<IRbiVendorConfig>,
  readonly sicomDelivery: Maybe<IRbiVendorConfig>,
  readonly tablet: Maybe<IRbiVendorConfig>,
  readonly tabletDelivery: Maybe<IRbiVendorConfig>,
  readonly xenial: Maybe<IRbiVendorConfig>,
  readonly xenialDelivery: Maybe<IRbiVendorConfig>,
}

export interface IRbiVendorConfigsInput {
  readonly brink?: Maybe<IRbiVendorConfigInput>,
  readonly brinkDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly carrols?: Maybe<IRbiVendorConfigInput>,
  readonly carrolsDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly hdx?: Maybe<IRbiVendorConfigInput>,
  readonly ncr?: Maybe<IRbiVendorConfigInput>,
  readonly ncrDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly productNumber?: Maybe<IRbiVendorConfigInput>,
  readonly productNumberDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly qdi?: Maybe<IRbiVendorConfigInput>,
  readonly qdiDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly oheics?: Maybe<IRbiVendorConfigInput>,
  readonly oheicsDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly partner?: Maybe<IRbiVendorConfigInput>,
  readonly partnerDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly qst?: Maybe<IRbiVendorConfigInput>,
  readonly rpos?: Maybe<IRbiVendorConfigInput>,
  readonly rposDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly sicom?: Maybe<IRbiVendorConfigInput>,
  readonly sicomDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly tablet?: Maybe<IRbiVendorConfigInput>,
  readonly tabletDelivery?: Maybe<IRbiVendorConfigInput>,
  readonly xenial?: Maybe<IRbiVendorConfigInput>,
  readonly xenialDelivery?: Maybe<IRbiVendorConfigInput>,
}

export interface IRecommendationItem {
  readonly __typename?: 'RecommendationItem',
  readonly id: Scalars['String'],
}

export interface IRecommendationProductInput {
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
}

export interface IRecommendationProducts {
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
  readonly sublevelItems?: Maybe<ReadonlyArray<IRecommendationProductInput>>,
}

export interface IRecommendations {
  readonly __typename?: 'Recommendations',
  readonly recommender: Scalars['String'],
  readonly recommendationToken: Scalars['String'],
  readonly results: ReadonlyArray<IRecommendationItem>,
}

export enum RecommendationType {
  CART = 'CART',
  MENU = 'MENU',
  OTHER = 'OTHER'
}

export interface IRedeemedCouponResponse {
  readonly code: Scalars['String'],
  readonly isRedeemed: Scalars['Boolean'],
  readonly message: Maybe<Scalars['String']>,
  readonly reason: Maybe<Scalars['String']>,
}

export interface IRefund {
  readonly __typename?: 'Refund',
  readonly primaryReason: RefundReason,
  readonly refundedItems: Maybe<ReadonlyArray<Maybe<IRefundedItem>>>,
  readonly secondaryReason: Maybe<Scalars['String']>,
  readonly subtotal: Scalars['String'],
  readonly tax: Scalars['String'],
  readonly transactionDateTime: Scalars['String'],
}

export interface IRefundedItem {
  readonly __typename?: 'RefundedItem',
  readonly name: Maybe<Scalars['String']>,
  readonly plu: Maybe<Scalars['String']>,
  readonly refundAmount: Maybe<Scalars['String']>,
  readonly refundQuantity: Maybe<Scalars['String']>,
  readonly sanityId: Maybe<Scalars['String']>,
  readonly type: Maybe<CartEntryType>,
}

export interface IRefundEligibilityResponse {
  readonly __typename?: 'RefundEligibilityResponse',
  readonly eligible: Scalars['Boolean'],
  readonly ineligibilityReason: Maybe<RefundIneligibilityReason>,
}

export enum RefundIneligibilityReason {
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED = 'DISABLED',
  INVALID_ORDER_STATUS = 'INVALID_ORDER_STATUS',
  INVALID_PAYMENT_TYPE = 'INVALID_PAYMENT_TYPE',
  INVALID_USER_ID = 'INVALID_USER_ID',
  ORDER_BEING_DELIVERED = 'ORDER_BEING_DELIVERED',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  OVER_ALLOWED_REFUND_AMOUNT = 'OVER_ALLOWED_REFUND_AMOUNT',
  REFUNDED_MAX_TIMES = 'REFUNDED_MAX_TIMES'
}

export enum RefundReason {
  CATERING_ORDER_DECLINED = 'CATERING_ORDER_DECLINED',
  CATERING_ORDER_ERROR = 'CATERING_ORDER_ERROR',
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  CUSTOMER_OVERCHARGED = 'CUSTOMER_OVERCHARGED',
  CUSTOMER_REQUESTED_CANCEL_ORDER = 'CUSTOMER_REQUESTED_CANCEL_ORDER',
  FOOD_QUALITY_ISSUE = 'FOOD_QUALITY_ISSUE',
  INCORRECT_CUSTOMIZATION = 'INCORRECT_CUSTOMIZATION',
  ITEMS_OUT_OF_STOCK = 'ITEMS_OUT_OF_STOCK',
  MISSING_OR_INCORRECT_ITEM = 'MISSING_OR_INCORRECT_ITEM',
  MOBILE_ORDERING_TECHNICAL_ISSUE = 'MOBILE_ORDERING_TECHNICAL_ISSUE',
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_COMMIT_ERROR = 'ORDER_COMMIT_ERROR',
  ORDER_NEVER_ARRIVED = 'ORDER_NEVER_ARRIVED',
  ORDER_WAS_DAMAGED = 'ORDER_WAS_DAMAGED',
  OTHER_ADD_COMMENT = 'OTHER_ADD_COMMENT',
  RECEIVED_INCORRECT_ORDER = 'RECEIVED_INCORRECT_ORDER',
  RESTAURANT_CLOSED = 'RESTAURANT_CLOSED',
  RESTAURANT_COULDNT_FIND_ORDER = 'RESTAURANT_COULDNT_FIND_ORDER'
}

export interface IRefundRequestResponse {
  readonly __typename?: 'RefundRequestResponse',
  readonly refundRequestAmountCents: Scalars['Int'],
  readonly requestDateTime: Maybe<Scalars['String']>,
}

export interface IReload {
  readonly __typename?: 'Reload',
  readonly beginBalance: Scalars['Int'],
  readonly currencyCode: Scalars['String'],
  readonly currentBalance: Scalars['Int'],
  readonly fdAccountId: Scalars['String'],
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly transactionId: Scalars['String'],
}

export interface IReloadPrepaidAuthorized {
  readonly __typename?: 'ReloadPrepaidAuthorized',
  readonly prepaidDetails: IPrepaidDetails,
}

export interface IReloadPrepaidInput {
  readonly destinationPaymentMethodId: Scalars['String'],
  readonly currency: Scalars['String'],
  readonly paymentMethod: Scalars['String'],
  readonly amount: Scalars['Int'],
  readonly riskData: Scalars['String'],
  readonly billingAddress?: Maybe<IPaymentBillingAddressInput>,
  readonly platform?: Maybe<Platform>,
}

export type IReloadPrepaidPayload = IReloadPrepaidAuthorized | IReloadPrepaidRefused;

export interface IReloadPrepaidRefused {
  readonly __typename?: 'ReloadPrepaidRefused',
  readonly code: PurchasePrepaidRefusalCode,
}

export interface IRemoveDeliveryAddressInput {
  readonly addressLine1?: Maybe<Scalars['String']>,
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly alias?: Maybe<Scalars['String']>,
  readonly city?: Maybe<Scalars['String']>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
}

export interface IResendOtpInput {
  readonly email?: Maybe<Scalars['String']>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly platform: Platform,
}

export interface IResendPhoneVerificationInput {
  readonly platform: Platform,
  readonly stage: Stage,
  readonly sessionId?: Maybe<Scalars['ID']>,
}

export interface IResendVerificationEmailInput {
  readonly platform: Platform,
  readonly stage: Stage,
}

export interface IRestaurant {
  readonly __typename?: 'Restaurant',
  readonly storeId: Maybe<Scalars['String']>,
  readonly available: Scalars['Boolean'],
  readonly lastHeartbeatTimestamp: Maybe<Scalars['String']>,
  readonly posVendor: Maybe<Scalars['String']>,
  readonly cateringHours: Maybe<IOperatingHours>,
  readonly curbsideHours: Maybe<IOperatingHours>,
  readonly deliveryHours: Maybe<IOperatingHours>,
  readonly diningRoomHours: Maybe<IOperatingHours>,
  readonly driveThruHours: Maybe<IOperatingHours>,
  readonly vatNumber: Maybe<Scalars['String']>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly futureServiceHours: ReadonlyArray<IFutureServiceHours>,
}

export interface IRestaurantEdge  extends IEdge {
  readonly __typename?: 'RestaurantEdge',
  readonly cursor: Scalars['String'],
  readonly node: IRestaurantNode,
}

export interface IRestaurantNode  extends INode {
  readonly __typename?: 'RestaurantNode',
  readonly id: Maybe<Scalars['ID']>,
  readonly _id: Maybe<Scalars['String']>,
  readonly storeId: Maybe<Scalars['String']>,
  readonly isAvailable: Scalars['Boolean'],
  readonly posVendor: Maybe<Scalars['String']>,
  readonly chaseMerchantId: Maybe<Scalars['String']>,
  readonly curbsideHours: Maybe<IOperatingHours>,
  readonly deliveryHours: Maybe<IOperatingHours>,
  readonly diningRoomHours: Maybe<IOperatingHours>,
  readonly distanceInMiles: Maybe<Scalars['Int']>,
  readonly drinkStationType: Maybe<Scalars['String']>,
  readonly driveThruHours: Maybe<IOperatingHours>,
  readonly driveThruLaneType: Maybe<Scalars['String']>,
  readonly email: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment: Maybe<RestaurantStatus>,
  readonly franchiseGroupId: Maybe<Scalars['Int']>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly frontCounterClosed: Maybe<Scalars['Boolean']>,
  readonly hasBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasCurbside: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDineIn: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasTableService: Maybe<Scalars['Boolean']>,
  readonly hasLateNightMenu: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  readonly hasParking: Maybe<Scalars['Boolean']>,
  readonly hasPlayground: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut: Maybe<Scalars['Boolean']>,
  readonly hasWifi: Maybe<Scalars['Boolean']>,
  readonly hasLoyalty: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen: Maybe<Scalars['Boolean']>,
  readonly isFavorite: Scalars['Boolean'],
  readonly isHalal: Maybe<Scalars['Boolean']>,
  readonly isRecent: Scalars['Boolean'],
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<OrderingStatus>,
  readonly name: Maybe<Scalars['String']>,
  readonly number: Maybe<Scalars['String']>,
  readonly parkingType: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly physicalAddress: Maybe<IPhysicalAddress>,
  readonly playgroundType: Maybe<Scalars['String']>,
  readonly pos: Maybe<IRestaurantPos>,
  readonly posRestaurantId: Maybe<Scalars['String']>,
  readonly restaurantImage: Maybe<ISanityImage>,
  readonly status: Maybe<Scalars['String']>,
  readonly restaurantPosData: Maybe<IRestaurantPosData>,
  readonly vatNumber: Maybe<Scalars['String']>,
  readonly cateringHours: Maybe<IOperatingHours>,
}

export interface IRestaurantPos {
  readonly __typename?: 'RestaurantPos',
  readonly vendor: Maybe<Scalars['String']>,
}

export interface IRestaurantPosData {
  readonly __typename?: 'RestaurantPosData',
  readonly _id: Maybe<Scalars['String']>,
}

export interface IRestaurantsConnection  extends IConnection {
  readonly __typename?: 'RestaurantsConnection',
  readonly edges: ReadonlyArray<IRestaurantEdge>,
  readonly nodes: ReadonlyArray<IRestaurantNode>,
  readonly totalCount: Maybe<Scalars['Int']>,
  readonly pageInfo: IPageInfo,
}

export interface IRestaurantsInput {
  readonly first?: Maybe<Scalars['Int']>,
  readonly last?: Maybe<Scalars['Int']>,
  readonly after?: Maybe<Scalars['String']>,
  readonly before?: Maybe<Scalars['String']>,
  readonly coordinates?: Maybe<ICoordinates>,
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly filter?: Maybe<FilterRestaurantType>,
  readonly serviceModes?: Maybe<ReadonlyArray<ServiceMode>>,
  readonly status?: Maybe<OperationalStatus>,
  readonly radiusStrictMode?: Maybe<Scalars['Boolean']>,
}

export enum RestaurantStatus {
  DEV = 'DEV',
  PROD = 'PROD'
}

export interface IRestaurantTimeSlot {
  readonly __typename?: 'RestaurantTimeSlot',
  readonly closes: Scalars['String'],
  readonly date: Scalars['String'],
  readonly isClosed: Maybe<Scalars['Boolean']>,
  readonly opens: Scalars['String'],
}

export interface IResumeAddPaymentMethodInput {
  readonly transactionId: Scalars['String'],
  readonly challengeResponse: Scalars['String'],
}

export interface IResumeThreeDSaleTransaction {
  readonly saleId: Scalars['String'],
  readonly threeDSOptions: IThreeDsOptions,
}

export interface IReward  extends IBaseIncentive {
  readonly __typename?: 'Reward',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>,
  readonly id: Scalars['ID'],
  readonly maxRedemptionsDuration: Maybe<DurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<PaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<BirthdayDuration>,
  readonly userEnrollment: Maybe<IDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<DayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<ServiceMode>>>,
  readonly storeRestrictions: Maybe<IStoreRestrictions>,
  readonly rewardBenefitId: Scalars['String'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<IObjectType>>>,
  readonly pointCost: Scalars['Int'],
  readonly limitPerOrder: Maybe<Scalars['Int']>,
  readonly locked: Maybe<Scalars['Boolean']>,
  readonly redemptionPercentage: Maybe<Scalars['Int']>,
  readonly remainingPointsNeededForRedemption: Maybe<Scalars['Int']>,
  readonly errors: Maybe<ReadonlyArray<IRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly type: RewardType,
}

export interface IRewardsInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<IRbiCartEntryInput>>,
  readonly ignorePointBalance?: Maybe<Scalars['Boolean']>,
  readonly incentiveIds?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly isTransactionCreation?: Maybe<Scalars['Boolean']>,
  readonly paymentMethod?: Maybe<PaymentMethod>,
  readonly rewardIds?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
  readonly omitInvalids?: Maybe<Scalars['Boolean']>,
  readonly ignoreRules?: Maybe<Scalars['Boolean']>,
  readonly configId?: Maybe<Scalars['ID']>,
}

export enum RewardType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IRuleConditionEvaluation {
  readonly __typename?: 'RuleConditionEvaluation',
  readonly code: Scalars['String'],
  readonly currentValue: Maybe<Scalars['JSON']>,
  readonly message: Maybe<Scalars['String']>,
  readonly ruleId: Scalars['String'],
  readonly targetValue: Maybe<Scalars['JSON']>,
}

export interface ISanityImage {
  readonly __typename?: 'SanityImage',
  readonly asset: Maybe<ISanityImageAsset>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export interface ISanityImageAsset {
  readonly __typename?: 'SanityImageAsset',
  readonly _id: Maybe<Scalars['String']>,
  readonly metadata: Maybe<ISanityImageMetaData>,
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop',
  readonly top: Maybe<Scalars['Float']>,
  readonly bottom: Maybe<Scalars['Float']>,
  readonly left: Maybe<Scalars['Float']>,
  readonly right: Maybe<Scalars['Float']>,
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot',
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
  readonly x: Maybe<Scalars['Float']>,
  readonly y: Maybe<Scalars['Float']>,
}

export interface ISanityImageMetaData {
  readonly __typename?: 'SanityImageMetaData',
  readonly lqip: Maybe<Scalars['String']>,
  readonly palette: Maybe<ISanityImagePalette>,
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette',
  readonly dominant: Maybe<ISanityImagePaletteSwatch>,
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch',
  readonly background: Maybe<Scalars['String']>,
  readonly foreground: Maybe<Scalars['String']>,
}

export interface ISaveDeliveryAddressInput {
  readonly addressLine1: Scalars['String'],
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly alias?: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country?: Maybe<IsoCountryCode>,
  readonly phoneNumber: Scalars['String'],
  readonly state?: Maybe<Scalars['String']>,
  readonly zip?: Maybe<Scalars['String']>,
  readonly latitude?: Maybe<Scalars['Float']>,
  readonly longitude?: Maybe<Scalars['Float']>,
  readonly route?: Maybe<Scalars['String']>,
  readonly streetNumber?: Maybe<Scalars['String']>,
}

export interface ISchemeStoredPaymentMethod  extends IStoredPaymentMethod {
  readonly __typename?: 'SchemeStoredPaymentMethod',
  readonly id: Scalars['ID'],
  readonly last4: Scalars['String'],
  readonly panToken: Maybe<Scalars['String']>,
  readonly type: PaymentMethodType,
  readonly brand: CardBrand,
  readonly expiryYear: Scalars['String'],
  readonly expiryMonth: Scalars['String'],
}

export interface ISecondaryIdentifier {
  readonly __typename?: 'SecondaryIdentifier',
  readonly identifier: Scalars['String'],
  readonly identifierType: SecondaryIdentifierType,
  readonly loyaltyId: Maybe<Scalars['ID']>,
  readonly createdAt: Maybe<Scalars['String']>,
  readonly verified: Maybe<Scalars['Boolean']>,
}

export enum SecondaryIdentifierType {
  LOYALTY12DIGITSWIPECARD = 'LOYALTY12DIGITSWIPECARD',
  LOYALTYSWIPECARD = 'LOYALTYSWIPECARD',
  PHONENUMBER = 'PHONENUMBER',
  PANTOKEN = 'PANTOKEN'
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TAKEOUT = 'TAKEOUT',
  TABLE_SERVICE = 'TABLE_SERVICE'
}

export interface ISignInUserInput {
  readonly email: Scalars['String'],
  readonly platform: Platform,
  readonly stage: Stage,
}

export interface ISignUpSmsOtpInput {
  readonly code: Scalars['String'],
  readonly country: IsoCountryCode,
  readonly dob?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly phoneNumber: Scalars['String'],
  readonly sessionId: Scalars['ID'],
  readonly platform: Platform,
  readonly stage: Stage,
  readonly userName: Scalars['String'],
  readonly wantsPromotionalEmails: Scalars['Boolean'],
  readonly zipcode?: Maybe<Scalars['String']>,
  readonly favoriteStores?: Maybe<ReadonlyArray<IFavoriteStoreInput>>,
}

export interface ISignUpUserInput {
  readonly country: IsoCountryCode,
  readonly dob?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly platform: Platform,
  readonly stage: Stage,
  readonly userName: Scalars['String'],
  readonly wantsPromotionalEmails: Scalars['Boolean'],
  readonly zipcode?: Maybe<Scalars['String']>,
  readonly favoriteStores?: Maybe<ReadonlyArray<IFavoriteStoreInput>>,
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu',
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

export enum SmgCodeStatus {
  ACCEPTED = 'ACCEPTED',
  CODE_EXISTS = 'CODE_EXISTS',
  EXPIRED = 'EXPIRED',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_RESTAURANT = 'INVALID_RESTAURANT',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  RETRY_REQUESTED = 'RETRY_REQUESTED',
  THROTTLING_ERROR = 'THROTTLING_ERROR',
  TRANSACTION_CLAIMED = 'TRANSACTION_CLAIMED'
}

export enum Stage {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LOCALDEV = 'localdev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test'
}

export interface IStoreAddress {
  readonly __typename?: 'StoreAddress',
  readonly addressLine1: Scalars['String'],
  readonly addressLine2: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Scalars['String'],
  readonly phoneNumber: Scalars['String'],
  readonly state: Scalars['String'],
  readonly zip: Scalars['String'],
}

export interface IStoreAddressInput {
  readonly addressLine1: Scalars['String'],
  readonly addressLine2?: Maybe<Scalars['String']>,
  readonly city: Scalars['String'],
  readonly country: Scalars['String'],
  readonly phoneNumber: Scalars['String'],
  readonly state: Scalars['String'],
  readonly zip: Scalars['String'],
}

export interface IStoreDetails {
  readonly __typename?: 'StoreDetails',
  readonly deliveryHours: Maybe<IStoreHours>,
  readonly diningRoomHours: Maybe<IStoreHours>,
  readonly driveThruHours: Maybe<IStoreHours>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly franchiseGroupId: Maybe<Scalars['Int']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  readonly lastActiveDateTime: Maybe<Scalars['String']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly posVendor: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
  readonly storeNumber: Maybe<Scalars['String']>,
}

export interface IStoredPaymentMethod {
  readonly id: Scalars['ID'],
  readonly type: PaymentMethodType,
}

export interface IStoreHours {
  readonly __typename?: 'StoreHours',
  readonly monday: Maybe<IDay>,
  readonly tuesday: Maybe<IDay>,
  readonly wednesday: Maybe<IDay>,
  readonly thursday: Maybe<IDay>,
  readonly friday: Maybe<IDay>,
  readonly saturday: Maybe<IDay>,
  readonly sunday: Maybe<IDay>,
}

export interface IStoreRestrictions {
  readonly __typename?: 'StoreRestrictions',
  readonly ids: ReadonlyArray<Maybe<Scalars['String']>>,
  readonly inclusive: Scalars['Boolean'],
}

export interface ISupportCase {
  readonly __typename?: 'SupportCase',
  readonly caseId: Maybe<Scalars['String']>,
}

export interface ISupportCaseInput {
  readonly comments: Scalars['String'],
  readonly email: Scalars['String'],
  readonly issueId: Scalars['String'],
  readonly issueSubCategory?: Maybe<Scalars['String']>,
  readonly name: Scalars['String'],
  readonly orderDateTime?: Maybe<Scalars['String']>,
  readonly localStoreOrderTime?: Maybe<Scalars['String']>,
  readonly rbiOrderId?: Maybe<Scalars['String']>,
  readonly serviceMode?: Maybe<Scalars['String']>,
  readonly storeAddress?: Maybe<Scalars['String']>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly userRegion?: Maybe<Scalars['String']>,
  readonly userAccountRegion?: Maybe<Scalars['String']>,
}

export interface ISwap {
  readonly __typename?: 'Swap',
  readonly type: SwapType,
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
}

export interface ISwapInput {
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly cartId: Scalars['String'],
  readonly swapType: Scalars['String'],
}

export enum SwapType {
  UPSIZE = 'UPSIZE'
}

export interface ISystemWidePromotion  extends IBaseIncentive {
  readonly __typename?: 'SystemWidePromotion',
  readonly sanityId: Maybe<Scalars['String']>,
  readonly cartRequirements: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>,
  readonly coolDown: Maybe<Scalars['Int']>,
  readonly createdAt: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly endTime: Maybe<Scalars['String']>,
  readonly externalIdentifiers: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>,
  readonly id: Scalars['ID'],
  readonly maxRedemptionsDuration: Maybe<DurationPeriod>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly name: Scalars['String'],
  readonly paymentMethod: Maybe<PaymentMethod>,
  readonly startDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly updatedAt: Scalars['String'],
  readonly userBirthdayDuration: Maybe<BirthdayDuration>,
  readonly userEnrollment: Maybe<IDateSpan>,
  readonly validDaysOfTheWeek: Maybe<ReadonlyArray<DayOfTheWeek>>,
  readonly firstOrder: Maybe<Scalars['Boolean']>,
  readonly serviceModes: Maybe<ReadonlyArray<Maybe<ServiceMode>>>,
  readonly storeRestrictions: Maybe<IStoreRestrictions>,
  readonly pointMultiplier: Maybe<Scalars['Int']>,
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly metadata: Maybe<Scalars['JSON']>,
  readonly errors: Maybe<ReadonlyArray<IRuleConditionEvaluation>>,
  readonly restaurantGroups: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IThreeDsChallenge {
  readonly __typename?: 'ThreeDsChallenge',
  readonly acsUrl: Scalars['String'],
  readonly challengeRequestToken: Scalars['String'],
  readonly transactionId: Scalars['String'],
}

export interface IThreeDsFrictionless {
  readonly __typename?: 'ThreeDsFrictionless',
  readonly transactionId: Scalars['String'],
  readonly iFrameContent: Scalars['String'],
}

export interface IThreeDsOptions {
  readonly challengeResponse?: Maybe<Scalars['String']>,
  readonly transactionId: Scalars['String'],
}

export interface ITransaction {
  readonly __typename?: 'Transaction',
  readonly id: Scalars['ID'],
  readonly shortId: Scalars['String'],
  readonly status: TransactionStatus,
  readonly createdAt: Scalars['String'],
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly transactionDetails: Maybe<ITransactionDetails>,
  readonly dateUpdated: Maybe<Scalars['String']>,
  readonly additionalReferenceIds: Maybe<ReadonlyArray<ITransactionAdditionalReferenceId>>,
  readonly pointsDeducted: Maybe<Scalars['Int']>,
  readonly pointsEarned: Scalars['Int'],
  readonly bonusPointsEarned: Scalars['Int'],
  readonly pointsUsed: Scalars['Int'],
  readonly maxTransactionLimitReached: Scalars['Boolean'],
  readonly hasRewards: Scalars['Boolean'],
}

export interface ITransactionAdditionalReferenceId {
  readonly __typename?: 'TransactionAdditionalReferenceId',
  readonly id: Scalars['String'],
  readonly type: Scalars['String'],
  readonly description: Maybe<Scalars['String']>,
}

export interface ITransactionDetails {
  readonly __typename?: 'TransactionDetails',
  readonly person: Maybe<IPerson>,
  readonly posVendor: Maybe<ITransactionPosVendor>,
  readonly currency: Scalars['String'],
  readonly payments: ReadonlyArray<ITransactionPayment>,
  readonly fulfillment: ITransactionFulfillment,
  readonly pickupContact: Maybe<IPickupContact>,
  readonly orders: ReadonlyArray<ITransactionOrder>,
  readonly language: Maybe<Language>,
  readonly promotions: Maybe<ReadonlyArray<IPromotion>>,
}

export interface ITransactionFulfillment {
  readonly __typename?: 'TransactionFulfillment',
  readonly type: Scalars['String'],
  readonly autoRelease: Maybe<Scalars['Boolean']>,
}

export interface ITransactionListResponse {
  readonly __typename?: 'TransactionListResponse',
  readonly fdCorrelationId: Maybe<Scalars['String']>,
  readonly transactions: Maybe<ReadonlyArray<Maybe<IPrepaidTransaction>>>,
}

export interface ITransactionOrder {
  readonly __typename?: 'TransactionOrder',
  readonly productId: Maybe<Scalars['String']>,
  readonly quantity: Scalars['Int'],
  readonly price: Scalars['Int'],
  readonly parentReferenceId: Maybe<Scalars['String']>,
}

export interface ITransactionPayment {
  readonly __typename?: 'TransactionPayment',
  readonly amount: Scalars['Int'],
  readonly description: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly token: Maybe<Scalars['String']>,
  readonly expiration: Maybe<IPaymentExpiration>,
}

export interface ITransactionPosVendor {
  readonly __typename?: 'TransactionPosVendor',
  readonly id: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly transactionId: Scalars['String'],
}

export interface ITransactionsInput {
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly statuses?: Maybe<ReadonlyArray<TransactionStatus>>,
  readonly excludedChannels?: Maybe<ReadonlyArray<RbiChannel>>,
}

export enum TransactionStatus {
  VOID = 'VOID',
  CLAIMED = 'CLAIMED',
  UNCLAIMED = 'UNCLAIMED',
  PENDING = 'PENDING'
}

export interface IUnavailableCartEntry {
  readonly __typename?: 'UnavailableCartEntry',
  readonly lineId: Maybe<Scalars['String']>,
  readonly sanityId: Scalars['String'],
}

export interface IUpdateDefaultPaymentMethodInput {
  readonly storedPaymentMethodId: Scalars['String'],
}

export interface IUpdateDefaultPaymentMethodPayload {
  readonly __typename?: 'UpdateDefaultPaymentMethodPayload',
  readonly defaultPaymentMethodId: Scalars['String'],
}

export interface IUpdateOrderInput {
  readonly fireOrderIn: Scalars['Int'],
  readonly rbiOrderId: Scalars['ID'],
}

export interface IUser {
  readonly __typename?: 'User',
  readonly id: Scalars['ID'],
  readonly name: Maybe<Scalars['String']>,
  readonly email: Scalars['String'],
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly dateOfBirth: Maybe<Scalars['String']>,
  readonly points: Scalars['Int'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<IObjectType>>>,
  readonly secondaryIdentifiers: Maybe<ReadonlyArray<Maybe<ISecondaryIdentifier>>>,
  readonly createdAt: Scalars['String'],
  readonly transactions: Maybe<ReadonlyArray<ITransaction>>,
  readonly rewards: Maybe<ReadonlyArray<IReward>>,
  readonly bestPromotion: Maybe<ISystemWidePromotion>,
  readonly promotions: Maybe<ReadonlyArray<ISystemWidePromotion>>,
  readonly offers: Maybe<ReadonlyArray<IOffer>>,
  readonly quests: Maybe<ReadonlyArray<IQuest>>,
  readonly alohaActiveRewards: ReadonlyArray<IAlohaActiveReward>,
  readonly pointsExpiryDateKey: Maybe<Scalars['String']>,
  readonly offerRedemptionAvailability: Maybe<IOfferRedemptionAvailability>,
  readonly offerRedemptionAvailableAfter: Maybe<Scalars['String']>,
  readonly evaluatedIncentives: IEvaluatedIncentives,
}


export interface IUserTransactionsArgs {
  where: Maybe<ITransactionsInput>
}


export interface IUserRewardsArgs {
  where: Maybe<IRewardsInput>
}


export interface IUserBestPromotionArgs {
  where: Maybe<IPromotionsInput>
}


export interface IUserPromotionsArgs {
  where: Maybe<IPromotionsInput>
}


export interface IUserOffersArgs {
  where: Maybe<IOffersInput>
}


export interface IUserEvaluatedIncentivesArgs {
  where: IEvaluateIncentivesInput
}

export interface IUserDetails {
  readonly __typename?: 'UserDetails',
  readonly deliveryAddresses: Maybe<ReadonlyArray<Maybe<IDeliveryAddress>>>,
  readonly autoReloadEnabled: Maybe<Scalars['Boolean']>,
  readonly autoReloadThreshold: Maybe<Scalars['Int']>,
  readonly communicationPreferences: Maybe<ReadonlyArray<Maybe<ICommunicationPreference>>>,
  readonly defaultAccountIdentifier: Maybe<Scalars['String']>,
  readonly defaultFdAccountId: Maybe<Scalars['String']>,
  readonly defaultPaymentAccountId: Maybe<Scalars['String']>,
  readonly defaultScanAndPayAccountIdentifier: Maybe<Scalars['String']>,
  readonly defaultReloadAmt: Maybe<Scalars['Int']>,
  readonly dob: Maybe<Scalars['String']>,
  readonly email: Maybe<Scalars['String']>,
  readonly emailVerified: Maybe<Scalars['Boolean']>,
  readonly favoriteStores: Maybe<ReadonlyArray<Maybe<IFavoriteStore>>>,
  readonly isoCountryCode: Maybe<IsoCountryCode>,
  readonly loyaltyTier: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly promotionalEmails: Maybe<Scalars['Boolean']>,
  readonly rutrFailedSkillsTestTimestamp: Maybe<Scalars['String']>,
  readonly rutrPassedSkillsTestTimestamp: Maybe<Scalars['String']>,
  readonly zipcode: Maybe<Scalars['String']>,
}

export interface IUserGeo {
  readonly __typename?: 'UserGeo',
  readonly country: Maybe<Scalars['String']>,
  readonly city: Maybe<Scalars['String']>,
  readonly state: Maybe<Scalars['String']>,
}

export interface IUserOrdersInput {
  readonly createdAfter?: Maybe<Scalars['String']>,
  readonly createdBefore?: Maybe<Scalars['String']>,
  readonly limit?: Maybe<Scalars['Int']>,
  readonly orderStatuses?: Maybe<ReadonlyArray<RbiOrderStatus>>,
  readonly resumeAfter?: Maybe<Scalars['String']>,
  readonly sortAscending?: Maybe<Scalars['Boolean']>,
  readonly userId?: Maybe<Scalars['ID']>,
  readonly shouldFilterByRegion?: Maybe<Scalars['Boolean']>,
}

export interface IUserReportsMissingOrderInput {
  readonly rbiOrderId: Scalars['String'],
  readonly issueId?: Maybe<Scalars['String']>,
  readonly issueSubCategory?: Maybe<Scalars['String']>,
  readonly missingItems?: Maybe<ReadonlyArray<Maybe<IMissingItem>>>,
  readonly userComment?: Maybe<Scalars['String']>,
}

export interface IUserRequestsRefundInput {
  readonly rbiOrderId: Scalars['String'],
  readonly issueId?: Maybe<Scalars['String']>,
  readonly issueSubCategory?: Maybe<Scalars['String']>,
  readonly missingItems?: Maybe<ReadonlyArray<Maybe<IMissingItem>>>,
  readonly userComment?: Maybe<Scalars['String']>,
}

export interface IValidateAuthJwtInput {
  readonly jwt: Scalars['String'],
}

export interface IValidateCommitOrderInput {
  readonly rbiOrderId: Scalars['String'],
  readonly fireOrderIn?: Maybe<Scalars['Int']>,
  readonly delivery?: Maybe<ICommitDeliveryInput>,
  readonly skipCoolingPeriod?: Maybe<Scalars['Boolean']>,
  readonly redeemedOn?: Maybe<Scalars['String']>,
}

export interface IValidateSmsOtpCognitoCredentials {
  readonly __typename?: 'ValidateSmsOtpCognitoCredentials',
  readonly sessionId: Scalars['String'],
  readonly challengeCode: Scalars['String'],
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig',
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly discountPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly pluType: Scalars['String'],
  readonly parentChildPlu: Maybe<IParentChildPlu>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Int']>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly sizeBasedPlu: Maybe<ISizeBasedPlu>,
}

export interface IVendorConfigInput {
  readonly pluType: Scalars['String'],
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly discountPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<IParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<ISizeBasedPluInput>,
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs',
  readonly carrols: Maybe<IVendorConfig>,
  readonly carrolsDelivery: Maybe<IVendorConfig>,
  readonly ncr: Maybe<IVendorConfig>,
  readonly ncrDelivery: Maybe<IVendorConfig>,
  readonly oheics: Maybe<IVendorConfig>,
  readonly oheicsDelivery: Maybe<IVendorConfig>,
  readonly partner: Maybe<IVendorConfig>,
  readonly partnerDelivery: Maybe<IVendorConfig>,
  readonly productNumber: Maybe<IVendorConfig>,
  readonly productNumberDelivery: Maybe<IVendorConfig>,
  readonly qdi: Maybe<IVendorConfig>,
  readonly qdiDelivery: Maybe<IVendorConfig>,
  readonly qst: Maybe<IVendorConfig>,
  readonly qstDelivery: Maybe<IVendorConfig>,
  readonly rpos: Maybe<IVendorConfig>,
  readonly rposDelivery: Maybe<IVendorConfig>,
  readonly sicom: Maybe<IVendorConfig>,
  readonly sicomDelivery: Maybe<IVendorConfig>,
  readonly simplyDelivery: Maybe<IVendorConfig>,
  readonly simplyDeliveryDelivery: Maybe<IVendorConfig>,
  readonly tablet: Maybe<IVendorConfig>,
  readonly tabletDelivery: Maybe<IVendorConfig>,
}

export interface IVendorConfigsInput {
  readonly carrols?: Maybe<IVendorConfigInput>,
  readonly carrolsDelivery?: Maybe<IVendorConfigInput>,
  readonly hdx?: Maybe<IVendorConfigInput>,
  readonly ncr?: Maybe<IVendorConfigInput>,
  readonly ncrDelivery?: Maybe<IVendorConfigInput>,
  readonly oheics?: Maybe<IVendorConfigInput>,
  readonly oheicsDelivery?: Maybe<IVendorConfigInput>,
  readonly partner?: Maybe<IVendorConfigInput>,
  readonly partnerDelivery?: Maybe<IVendorConfigInput>,
  readonly productNumber?: Maybe<IVendorConfigInput>,
  readonly productNumberDelivery?: Maybe<IVendorConfigInput>,
  readonly qdi?: Maybe<IVendorConfigInput>,
  readonly qdiDelivery?: Maybe<IVendorConfigInput>,
  readonly qst?: Maybe<IVendorConfigInput>,
  readonly qstDelivery?: Maybe<IVendorConfigInput>,
  readonly rpos?: Maybe<IVendorConfigInput>,
  readonly rposDelivery?: Maybe<IVendorConfigInput>,
  readonly sicom?: Maybe<IVendorConfigInput>,
  readonly sicomDelivery?: Maybe<IVendorConfigInput>,
  readonly simplyDelivery?: Maybe<IVendorConfigInput>,
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfigInput>,
  readonly tablet?: Maybe<IVendorConfigInput>,
  readonly tabletDelivery?: Maybe<IVendorConfigInput>,
}

export interface IVerifyPhoneNumberInput {
  readonly code: Scalars['String'],
  readonly sessionId: Scalars['ID'],
  readonly platform: Platform,
  readonly stage: Stage,
}

export interface IVrPayment {
  readonly billingAgreementId?: Maybe<Scalars['String']>,
  readonly deviceToken?: Maybe<Scalars['String']>,
  readonly pspReference: Scalars['String'],
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>,
  readonly storePaymentMethod: Scalars['Boolean'],
  readonly merchantAccount: Scalars['String'],
}

export interface IWorldpayPayment {
  readonly pspReference?: Maybe<Scalars['String']>,
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>,
  readonly storePaymentMethod?: Maybe<Scalars['Boolean']>,
  readonly lowValueToken?: Maybe<Scalars['String']>,
}

export type IDayFragment = { readonly __typename?: 'Day', readonly close: Maybe<string>, readonly open: Maybe<string> };

export type IStoreHoursFragment = { readonly __typename?: 'StoreHours', readonly monday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly tuesday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly wednesday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly thursday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly friday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly saturday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )>, readonly sunday: Maybe<(
    { readonly __typename?: 'Day' }
    & IDayFragment
  )> };

export type IUserOrderFragment = { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly createdAt: string, readonly updatedAt: string, readonly fireOrderIn: Maybe<number>, readonly status: RbiOrderStatus, readonly orderNumberFormatted: Maybe<string>, readonly _id: string, readonly delivery: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly tipCents: Maybe<number>, readonly feeDiscountCents: Maybe<number>, readonly status: DeliveryStatus, readonly serviceFeeCents: Maybe<number>, readonly smallCartFeeCents: Maybe<number>, readonly geographicalFeeCents: Maybe<number>, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly state: Maybe<string> } }>, readonly cart: { readonly __typename?: 'Cart', readonly ticketNumber: Maybe<string>, readonly storeId: string, readonly vatNumber: Maybe<string>, readonly serviceMode: ServiceMode, readonly posVendor: PosVendor, readonly cartVersion: Maybe<number>, readonly subTotalCents: Maybe<number>, readonly taxCents: Maybe<number>, readonly totalCents: Maybe<number>, readonly wasLoyaltyEarned: Maybe<boolean>, readonly discounts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Discount', readonly name: Maybe<DiscountTypes>, readonly value: Maybe<number> }>>>, readonly fees: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Fees', readonly name: Maybe<string>, readonly priceCents: Maybe<number>, readonly quantity: Maybe<number>, readonly totalCents: Maybe<number> }>>>, readonly donations: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Donation', readonly id: Maybe<string>, readonly name: Maybe<string>, readonly totalCents: Maybe<number> }>>>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails: Maybe<{ readonly __typename?: 'StoreDetails', readonly franchiseGroupName: Maybe<string>, readonly franchiseGroupId: Maybe<number>, readonly hasCatering: Maybe<boolean>, readonly hasDelivery: Maybe<boolean>, readonly hasDriveThru: Maybe<boolean>, readonly hasMobileOrdering: Maybe<boolean>, readonly lastActiveDateTime: Maybe<string>, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly mobileOrderingStatus: Maybe<string>, readonly phoneNumber: Maybe<string>, readonly posVendor: Maybe<string>, readonly status: Maybe<string>, readonly storeNumber: Maybe<string>, readonly deliveryHours: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )>, readonly diningRoomHours: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )>, readonly driveThruHours: Maybe<(
        { readonly __typename?: 'StoreHours' }
        & IStoreHoursFragment
      )> }>, readonly cartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly reorderCartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean>, readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean>, readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean>, readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean>, readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean>, readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries', readonly isInMenu: Maybe<boolean> }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId: Maybe<string>, readonly sanityId: string }>>> }, readonly fulfillmentDetails: Maybe<{ readonly __typename?: 'FulfillmentDetails', readonly pickupType: Maybe<FulfillmentPickupType>, readonly pickupPin: Maybe<string>, readonly pickupReady: Maybe<boolean> }>, readonly order: Maybe<{ readonly __typename?: 'RbiOrder', readonly refund: Maybe<{ readonly __typename?: 'Refund', readonly primaryReason: RefundReason, readonly secondaryReason: Maybe<string>, readonly subtotal: string, readonly tax: string, readonly transactionDateTime: string, readonly refundedItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RefundedItem', readonly refundAmount: Maybe<string>, readonly refundQuantity: Maybe<string>, readonly sanityId: Maybe<string>, readonly type: Maybe<CartEntryType>, readonly name: Maybe<string>, readonly plu: Maybe<string> }>>> }> }> };

export type IUpsellRecommendationsQueryVariables = {
  limit?: Maybe<Scalars['Int']>,
  products: ReadonlyArray<IRecommendationProducts>,
  storeId: Scalars['String'],
  serviceMode: Scalars['String'],
  type: RecommendationType
};


export type IUpsellRecommendationsQuery = { readonly __typename?: 'Query', readonly upsellRecommendations: { readonly __typename?: 'Recommendations', readonly recommender: string, readonly recommendationToken: string, readonly results: ReadonlyArray<{ readonly __typename?: 'RecommendationItem', readonly id: string }> } };

export type ITransactionFragment = { readonly __typename?: 'LoyaltyTransactionV2', readonly channel: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsDeducted: Maybe<number>, readonly hasRewards: boolean, readonly createdAt: string, readonly transactionDetails: Maybe<{ readonly __typename?: 'LoyaltyTransactionDetails', readonly payments: ReadonlyArray<{ readonly __typename?: 'LoyaltyTransactionPayment', readonly amount: number }> }>, readonly additionalReferenceIds: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltyTransactionAdditionalReferenceId', readonly id: string, readonly type: string }>> };

export type IRewardFragment = { readonly __typename?: 'LoyaltyReward', readonly id: any, readonly rewardBenefitId: string, readonly name: string, readonly pointCost: number, readonly sanityId: Maybe<string>, readonly locked: Maybe<boolean>, readonly redemptionPercentage: Maybe<number>, readonly limitPerOrder: Maybe<number>, readonly remainingPointsNeededForRedemption: Maybe<number> };

export type ILoyaltyUserFragment = { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly name: Maybe<string>, readonly points: number, readonly pointsExpiryDateKey: Maybe<string>, readonly metadata: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyObjectType', readonly key: Maybe<string>, readonly value: Maybe<any> }>>>, readonly bestPromotion: Maybe<{ readonly __typename?: 'LoyaltySystemWidePromotion', readonly sanityId: Maybe<string> }>, readonly offerRedemptionAvailability: Maybe<{ readonly __typename?: 'LoyaltyOfferRedemptionAvailability', readonly availableAfter: Maybe<string> }>, readonly secondaryIdentifiers: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltySecondaryIdentifier', readonly identifier: string, readonly identifierType: LoyaltySecondaryIdentifierType }>>> };

export type IOffersFragment = { readonly __typename?: 'LoyaltyOffer', readonly configId: Maybe<any>, readonly id: any, readonly isStackable: Maybe<boolean>, readonly loyaltyId: Maybe<any>, readonly redemptionType: Maybe<LoyaltyOfferRedemptionType>, readonly sanityId: Maybe<string>, readonly templateId: Maybe<any>, readonly type: LoyaltyOfferType, readonly benefits: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltyBenefitReference', readonly type: LoyaltyBenefitType, readonly reference: string } | { readonly __typename?: 'LoyaltyBenefitSwap', readonly type: LoyaltyBenefitType, readonly value: { readonly __typename?: 'LoyaltySwap', readonly type: LoyaltySwapType, readonly from: string, readonly to: string } }>>, readonly errors: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltyRuleConditionEvaluation', readonly code: string, readonly currentValue: Maybe<any>, readonly message: Maybe<string>, readonly ruleId: string, readonly targetValue: Maybe<any> }>>, readonly metadata: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoyaltyObjectType', readonly key: Maybe<string>, readonly value: Maybe<any> }>>> };

export type IInvalidIncentiveFragment = { readonly __typename?: 'LoyaltyInvalidIncentives', readonly id: any, readonly errors: ReadonlyArray<{ readonly __typename?: 'LoyaltyRuleConditionEvaluation', readonly code: string, readonly currentValue: Maybe<any>, readonly message: Maybe<string>, readonly ruleId: string, readonly targetValue: Maybe<any> }> };

export type ILoyaltyCouponFragment = { readonly __typename?: 'LoyaltyCouponResponse', readonly code: string, readonly isValid: boolean, readonly message: string, readonly reason: Maybe<string>, readonly isRedeemed: Maybe<boolean>, readonly shouldRedeem: Maybe<boolean>, readonly personalizedOfferId: Maybe<string>, readonly configId: Maybe<string> };

export type ICartEntryFragment = { readonly __typename?: 'CartEntries', readonly lineId: string, readonly image: Maybe<string>, readonly isDonation: Maybe<boolean>, readonly isExtra: Maybe<boolean>, readonly name: Maybe<string>, readonly pickerSelections: Maybe<string>, readonly price: Maybe<number>, readonly quantity: number, readonly sanityId: string, readonly type: CartEntryType, readonly url: Maybe<string>, readonly redeemable: Maybe<boolean>, readonly _id: string, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly carrols: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly carrolsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncr: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncrDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheics: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly oheicsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly partner: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly partnerDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumber: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumberDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicom: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicomDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdi: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdiDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qst: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qstDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rpos: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rposDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly simplyDeliveryDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tablet: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tabletDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )> };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType: string, readonly parentSanityId: Maybe<string>, readonly pullUpLevels: Maybe<number>, readonly constantPlu: Maybe<string>, readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuantityPlu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly parentChildPlu: Maybe<{ readonly __typename?: 'ParentChildPlu', readonly plu: Maybe<string>, readonly childPlu: Maybe<string> }>, readonly sizeBasedPlu: Maybe<{ readonly __typename?: 'SizeBasedPlu', readonly comboPlu: Maybe<string>, readonly comboSize: Maybe<string> }> };

export type IOrderFragment = { readonly __typename?: 'Order', readonly createdAt: string, readonly updatedAt: string, readonly posOrderId: Maybe<string>, readonly rbiOrderId: string, readonly status: RbiOrderStatus, readonly fireOrderIn: Maybe<number>, readonly orderNumberFormatted: Maybe<string>, readonly order: Maybe<{ readonly __typename?: 'RbiOrder', readonly refund: Maybe<{ readonly __typename?: 'Refund', readonly primaryReason: RefundReason, readonly secondaryReason: Maybe<string>, readonly subtotal: string, readonly tax: string, readonly transactionDateTime: string, readonly refundedItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RefundedItem', readonly refundAmount: Maybe<string>, readonly refundQuantity: Maybe<string>, readonly sanityId: Maybe<string>, readonly type: Maybe<CartEntryType>, readonly name: Maybe<string>, readonly plu: Maybe<string> }>>> }> }>, readonly loyaltyTransaction: Maybe<{ readonly __typename?: 'LoyaltyTransaction', readonly id: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsBalance: number, readonly rewardsUsed: number }>, readonly cart: { readonly __typename?: 'Cart', readonly customerName: string, readonly cartVersion: Maybe<number>, readonly posVendor: PosVendor, readonly serviceMode: ServiceMode, readonly subTotalCents: Maybe<number>, readonly taxCents: Maybe<number>, readonly ticketNumber: Maybe<string>, readonly totalCents: Maybe<number>, readonly wasLoyaltyEarned: Maybe<boolean>, readonly vatNumber: Maybe<string>, readonly cartEntries: Maybe<ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
            { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
              { readonly __typename?: 'CartEntries', readonly children: Maybe<ReadonlyArray<Maybe<(
                { readonly __typename?: 'CartEntries' }
                & ICartEntryFragment
              )>>> }
              & ICartEntryFragment
            )>>> }
            & ICartEntryFragment
          )>>> }
          & ICartEntryFragment
        )>>> }
        & ICartEntryFragment
      )>>> }
      & ICartEntryFragment
    )>>, readonly discounts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Discount', readonly name: Maybe<DiscountTypes>, readonly value: Maybe<number> }>>>, readonly donations: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Donation', readonly id: Maybe<string>, readonly name: Maybe<string>, readonly totalCents: Maybe<number> }>>>, readonly fees: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Fees', readonly name: Maybe<string>, readonly priceCents: Maybe<number>, readonly quantity: Maybe<number>, readonly totalCents: Maybe<number> }>>>, readonly offersFeedback: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CouponUserOffersFeedbackEntry', readonly couponId: string, readonly cartEntry: Maybe<{ readonly __typename?: 'CartEntries', readonly lineId: string }>, readonly redemptionEligibility: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly isValid: boolean, readonly evaluationFeedback: ReadonlyArray<Maybe<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly redeemableForSeconds: Maybe<number>, readonly redeemableInSeconds: Maybe<number>, readonly ruleSetType: string }>> } }>>>, readonly payment: Maybe<{ readonly __typename?: 'Payment', readonly cardType: Maybe<string>, readonly ccLast4: Maybe<string>, readonly panToken: Maybe<string>, readonly paymentType: Maybe<CartPaymentType> }>, readonly rewardsApplied: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'CartAppliedReward', readonly cartId: string, readonly rewardId: string, readonly timesApplied: number }>>>, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails: Maybe<{ readonly __typename?: 'StoreDetails', readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly storeNumber: Maybe<string> }>, readonly unavailableCartEntries: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId: Maybe<string>, readonly sanityId: string }>>> }, readonly delivery: Maybe<{ readonly __typename?: 'Delivery', readonly feeCents: number, readonly feeDiscountCents: Maybe<number>, readonly instructions: Maybe<string>, readonly status: DeliveryStatus, readonly tipCents: Maybe<number>, readonly serviceFeeCents: Maybe<number>, readonly smallCartFeeCents: Maybe<number>, readonly geographicalFeeCents: Maybe<number>, readonly quotedFeeCents: Maybe<number>, readonly baseDeliveryFeeCents: Maybe<number>, readonly deliverySurchargeFeeCents: Maybe<number>, readonly pickup: { readonly __typename?: 'DeliveryWaypoint', readonly latitude: Maybe<number>, readonly longitude: Maybe<number> }, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly arrivalTime: Maybe<string>, readonly beforeTime: Maybe<string>, readonly addressLine1: string, readonly addressLine2: Maybe<string>, readonly city: string, readonly state: Maybe<string>, readonly zip: Maybe<string>, readonly latitude: Maybe<number>, readonly longitude: Maybe<number>, readonly phoneNumber: string }, readonly driver: Maybe<{ readonly __typename?: 'DeliveryDriver', readonly name: Maybe<string>, readonly profileImageUrl: Maybe<string>, readonly phoneNumber: Maybe<string> }> }>, readonly catering: Maybe<{ readonly __typename?: 'Catering', readonly declineReason: Maybe<CateringDeclineReasons>, readonly notes: Maybe<string>, readonly pickupTime: string }> };

export type IPricingAndAvailabilityFragment = { readonly __typename?: 'Entity', readonly id: string, readonly isAvailable: Maybe<boolean>, readonly price: Maybe<{ readonly __typename?: 'Price', readonly default: Maybe<number>, readonly max: Maybe<number>, readonly min: Maybe<number>, readonly overrides: Maybe<ReadonlyArray<{ readonly __typename?: 'Override', readonly key: Maybe<ReadonlyArray<string>>, readonly price: Maybe<number> }>> }> };

export type ICaloriesFragment = { readonly __typename?: 'Entity', readonly calories: Maybe<{ readonly __typename?: 'Calories', readonly default: Maybe<number>, readonly min: Maybe<number>, readonly max: Maybe<number> }> };

export type IGetOrderQueryVariables = {
  rbiOrderId: Scalars['ID']
};


export type IGetOrderQuery = { readonly __typename?: 'Query', readonly order: Maybe<(
    { readonly __typename?: 'Order' }
    & IOrderFragment
  )> };

export type IGetUserOrdersQueryVariables = {
  userId?: Maybe<Scalars['ID']>,
  limit?: Maybe<Scalars['Int']>,
  resumeAfter?: Maybe<Scalars['String']>,
  orderStatuses?: Maybe<ReadonlyArray<RbiOrderStatus>>,
  createdAfter?: Maybe<Scalars['String']>,
  shouldFilterByRegion?: Maybe<Scalars['Boolean']>
};


export type IGetUserOrdersQuery = { readonly __typename?: 'Query', readonly userOrders: { readonly __typename?: 'OrderListResponse', readonly count: number, readonly resumeAfter: Maybe<string>, readonly orders: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Order' }
      & IUserOrderFragment
    )>>> } };

export type IPriceOrderMutationVariables = {
  input: IPriceOrderInput,
  delivery?: Maybe<IPriceDeliveryInput>
};


export type IPriceOrderMutation = { readonly __typename?: 'Mutation', readonly priceOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type ICommitOrderMutationVariables = {
  input: ICommitOrderInput,
  delivery?: Maybe<ICommitDeliveryInput>,
  skipCoolingPeriod?: Maybe<Scalars['Boolean']>
};


export type ICommitOrderMutation = { readonly __typename?: 'Mutation', readonly commitOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type ILoyaltyUserQueryVariables = {
  loyaltyId: Scalars['LoyaltyID']
};


export type ILoyaltyUserQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2: Maybe<(
    { readonly __typename?: 'LoyaltyUser' }
    & ILoyaltyUserFragment
  )> };

export type ILoyaltyUserTransactionsQueryVariables = {
  loyaltyId: Scalars['LoyaltyID']
};


export type ILoyaltyUserTransactionsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2: Maybe<{ readonly __typename?: 'LoyaltyUser', readonly id: any, readonly transactions: Maybe<ReadonlyArray<(
      { readonly __typename?: 'LoyaltyTransactionV2' }
      & ITransactionFragment
    )>> }> };

export type ILoyaltyUserRewardsQueryVariables = {
  loyaltyId: Scalars['LoyaltyID'],
  where?: Maybe<ILoyaltyRewardsInput>
};


export type ILoyaltyUserRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2: Maybe<{ readonly __typename?: 'LoyaltyUser', readonly id: any, readonly rewards: Maybe<ReadonlyArray<(
      { readonly __typename?: 'LoyaltyReward' }
      & IRewardFragment
    )>> }> };

export type ILoyaltyUserOffersQueryVariables = {
  loyaltyId: Scalars['LoyaltyID'],
  where?: Maybe<ILoyaltyOffersInput>
};


export type ILoyaltyUserOffersQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2: Maybe<{ readonly __typename?: 'LoyaltyUser', readonly id: any, readonly offerRedemptionAvailability: Maybe<{ readonly __typename?: 'LoyaltyOfferRedemptionAvailability', readonly availableAfter: Maybe<string> }>, readonly offers: Maybe<ReadonlyArray<(
      { readonly __typename?: 'LoyaltyOffer' }
      & IOffersFragment
    )>> }> };

export type ILoyaltyOffersQueryVariables = {
  ids?: Maybe<ReadonlyArray<Scalars['LoyaltyID']>>,
  loyaltyId?: Maybe<Scalars['LoyaltyID']>,
  omitInvalids?: Maybe<Scalars['Boolean']>,
  redemptionTypes?: Maybe<ReadonlyArray<LoyaltyOfferRedemptionType>>,
  serviceMode?: Maybe<LoyaltyServiceMode>,
  storeId?: Maybe<Scalars['String']>,
  subtotalAmount?: Maybe<Scalars['Int']>
};


export type ILoyaltyOffersQuery = { readonly __typename?: 'Query', readonly loyaltyOffersV2: Maybe<ReadonlyArray<(
    { readonly __typename?: 'LoyaltyOffer' }
    & IOffersFragment
  )>> };

export type ILoyaltyEngineRewardsQueryVariables = {
  loyaltyId: Scalars['LoyaltyID']
};


export type ILoyaltyEngineRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyRewardsV2: Maybe<ReadonlyArray<(
    { readonly __typename?: 'LoyaltyReward' }
    & IRewardFragment
  )>> };

export type ILoyaltyNotificationsRedeemableQueryVariables = {
  loyaltyId: Scalars['LoyaltyID'],
  rewardsInput?: Maybe<ILoyaltyRewardsInput>,
  offersInput?: Maybe<ILoyaltyOffersInput>
};


export type ILoyaltyNotificationsRedeemableQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2: Maybe<{ readonly __typename?: 'LoyaltyUser', readonly id: any, readonly rewards: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltyReward', readonly id: any }>>, readonly promotions: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltySystemWidePromotion', readonly id: any }>>, readonly offers: Maybe<ReadonlyArray<{ readonly __typename?: 'LoyaltyOffer', readonly id: any }>> }> };

export type ILoyaltyGenerateOtpMutationVariables = {
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>,
  loyaltyId: Scalars['LoyaltyID'],
  restaurantId?: Maybe<Scalars['LoyaltyID']>
};


export type ILoyaltyGenerateOtpMutation = { readonly __typename?: 'Mutation', readonly loyaltyGenerateOtp: { readonly __typename?: 'LoyaltyOtp', readonly password: string, readonly expirationTime: string } };

export type IProcessSmgCodeMutationVariables = {
  loyaltyId: Scalars['LoyaltyID'],
  smgCode: Scalars['String'],
  transactionDate?: Maybe<Scalars['String']>
};


export type IProcessSmgCodeMutation = { readonly __typename?: 'Mutation', readonly loyaltyProcessSmgCode: { readonly __typename?: 'LoyaltyProcessSmgCodeResponse', readonly pointsEarned: number, readonly status: LoyaltySmgCodeStatus } };

export type IOrderSelectionQueryVariables = {
  otp: Scalars['String']
};


export type IOrderSelectionQuery = { readonly __typename?: 'Query', readonly loyaltyOrderSelection: Maybe<{ readonly __typename?: 'LoyaltyOrderSelectionTransfer', readonly status: Maybe<OrderSelectionStatus>, readonly expiry: Maybe<number>, readonly _id: Maybe<string> }> };

export type ICreateOrderlessTransactionMutationVariables = {
  input: ILoyaltyOrderlessTransactionInput
};


export type ICreateOrderlessTransactionMutation = { readonly __typename?: 'Mutation', readonly loyaltyCreateOrderlessTransaction: { readonly __typename?: 'LoyaltyTransactionV2', readonly id: any } };

export type ILinkPhysicalCardToLoyaltyUserMutationVariables = {
  cardNumber: Scalars['String'],
  loyaltyUserId: Scalars['LoyaltyID']
};


export type ILinkPhysicalCardToLoyaltyUserMutation = { readonly __typename?: 'Mutation', readonly loyaltyAssociateGuestUser: Maybe<{ readonly __typename?: 'LoyaltyAssociateGuestUserResponse', readonly activationDateTime: string, readonly guestBalance: number, readonly totalBalance: number, readonly linkingDateTime: string }> };

export type IUnlinkPhysicalCardFromLoyaltyUserMutationVariables = {
  cardNumber: Scalars['String']
};


export type IUnlinkPhysicalCardFromLoyaltyUserMutation = { readonly __typename?: 'Mutation', readonly loyaltyRemoveSecondaryIdAssociation: Maybe<boolean> };

export type IOrderSelectionByTypeQueryVariables = {
  key: Scalars['String'],
  ostType: LoyaltyOstType
};


export type IOrderSelectionByTypeQuery = { readonly __typename?: 'Query', readonly loyaltyOrderSelectionByType: Maybe<{ readonly __typename?: 'LoyaltyOrderSelectionTransfer', readonly status: Maybe<OrderSelectionStatus>, readonly expiry: Maybe<number>, readonly _id: Maybe<string> }> };

export type ICreateOrderSelectionByTypeMutationVariables = {
  ostType: LoyaltyOstType,
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>,
  loyaltyId: Scalars['LoyaltyID'],
  restaurantId?: Maybe<Scalars['LoyaltyID']>
};


export type ICreateOrderSelectionByTypeMutation = { readonly __typename?: 'Mutation', readonly loyaltyCreateOrderSelectionByType: { readonly __typename?: 'LoyaltyOstCreationPayload', readonly expirationTime: string, readonly key: string } };

export type ILoyaltyRedeemPromoCodeMutationVariables = {
  input?: Maybe<ILoyaltyValidatePromoCodeInput>
};


export type ILoyaltyRedeemPromoCodeMutation = { readonly __typename?: 'Mutation', readonly loyaltyValidatePromoCode: Maybe<(
    { readonly __typename?: 'LoyaltyCouponResponse' }
    & ILoyaltyCouponFragment
  )> };

export type IPlusDataQueryVariables = {
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
};


export type IPlusDataQuery = { readonly __typename?: 'Query', readonly plus: Maybe<ReadonlyArray<{ readonly __typename?: 'MenuItem', readonly plu: string, readonly price: string }>> };

export type IStoreMenuQueryVariables = {
  region: Scalars['String'],
  channel: Channel,
  storeId: Scalars['ID'],
  serviceMode?: Maybe<PosDataServiceMode>
};


export type IStoreMenuQuery = { readonly __typename?: 'Query', readonly storeMenu: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Entity' }
    & IPricingAndAvailabilityFragment
    & ICaloriesFragment
  )>> };

export type IPromotionValidatePromoCodeMutationVariables = {
  code: Scalars['String'],
  cognitoId: Scalars['String'],
  shouldRedeem?: Maybe<Scalars['Boolean']>,
  offers: ReadonlyArray<Scalars['String']>
};


export type IPromotionValidatePromoCodeMutation = { readonly __typename?: 'Mutation', readonly validatePromoCode: Maybe<{ readonly __typename?: 'CBACouponResponse', readonly code: string, readonly reason: Maybe<string>, readonly message: string, readonly isValid: boolean, readonly isRedeemed: Maybe<boolean>, readonly offerId: Maybe<string> }> };

export type IPromotionRedeemPromoCodeMutationVariables = {
  code: Scalars['String'],
  cognitoId: Scalars['String']
};


export type IPromotionRedeemPromoCodeMutation = { readonly __typename?: 'Mutation', readonly redeemPromoCode: Maybe<{ readonly __typename?: 'CBARedeemCouponResponse', readonly code: string, readonly reason: Maybe<string>, readonly message: Maybe<string>, readonly isRedeemed: boolean, readonly offerId: Maybe<string> }> };

export const DayFragmentFragmentDoc = gql`
    fragment DayFragment on Day {
  close
  open
}
    `;
export const StoreHoursFragmentFragmentDoc = gql`
    fragment StoreHoursFragment on StoreHours {
  monday {
    ...DayFragment
  }
  tuesday {
    ...DayFragment
  }
  wednesday {
    ...DayFragment
  }
  thursday {
    ...DayFragment
  }
  friday {
    ...DayFragment
  }
  saturday {
    ...DayFragment
  }
  sunday {
    ...DayFragment
  }
}
    ${DayFragmentFragmentDoc}`;
export const VendorConfigFragmentFragmentDoc = gql`
    fragment VendorConfigFragment on VendorConfig {
  pluType
  parentSanityId
  pullUpLevels
  constantPlu
  quantityBasedPlu {
    quantity
    plu
    qualifier
  }
  multiConstantPlus {
    quantity
    plu
    qualifier
  }
  parentChildPlu {
    plu
    childPlu
  }
  sizeBasedPlu {
    comboPlu
    comboSize
  }
}
    `;
export const VendorConfigsFragmentFragmentDoc = gql`
    fragment VendorConfigsFragment on VendorConfigs {
  carrols {
    ...VendorConfigFragment
  }
  carrolsDelivery {
    ...VendorConfigFragment
  }
  ncr {
    ...VendorConfigFragment
  }
  ncrDelivery {
    ...VendorConfigFragment
  }
  oheics {
    ...VendorConfigFragment
  }
  oheicsDelivery {
    ...VendorConfigFragment
  }
  partner {
    ...VendorConfigFragment
  }
  partnerDelivery {
    ...VendorConfigFragment
  }
  productNumber {
    ...VendorConfigFragment
  }
  productNumberDelivery {
    ...VendorConfigFragment
  }
  sicom {
    ...VendorConfigFragment
  }
  sicomDelivery {
    ...VendorConfigFragment
  }
  qdi {
    ...VendorConfigFragment
  }
  qdiDelivery {
    ...VendorConfigFragment
  }
  qst {
    ...VendorConfigFragment
  }
  qstDelivery {
    ...VendorConfigFragment
  }
  rpos {
    ...VendorConfigFragment
  }
  rposDelivery {
    ...VendorConfigFragment
  }
  simplyDelivery {
    ...VendorConfigFragment
  }
  simplyDeliveryDelivery {
    ...VendorConfigFragment
  }
  tablet {
    ...VendorConfigFragment
  }
  tabletDelivery {
    ...VendorConfigFragment
  }
}
    ${VendorConfigFragmentFragmentDoc}`;
export const CartEntryFragmentFragmentDoc = gql`
    fragment CartEntryFragment on CartEntries {
  _id: lineId
  lineId
  image
  isDonation
  isExtra
  name
  pickerSelections
  price
  quantity
  sanityId
  type
  url
  redeemable
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${VendorConfigsFragmentFragmentDoc}`;
export const UserOrderFragmentFragmentDoc = gql`
    fragment UserOrderFragment on Order {
  _id: rbiOrderId
  rbiOrderId
  createdAt
  updatedAt
  fireOrderIn
  status
  orderNumberFormatted
  delivery {
    dropoff {
      state
    }
    feeCents
    tipCents
    feeDiscountCents
    status
    serviceFeeCents
    smallCartFeeCents
    geographicalFeeCents
  }
  cart {
    discounts {
      name
      value
    }
    fees {
      name
      priceCents
      quantity
      totalCents
    }
    ticketNumber
    storeId
    vatNumber
    serviceMode
    posVendor
    cartVersion
    donations {
      id
      name
      totalCents
    }
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    storeDetails {
      deliveryHours {
        ...StoreHoursFragment
      }
      diningRoomHours {
        ...StoreHoursFragment
      }
      driveThruHours {
        ...StoreHoursFragment
      }
      franchiseGroupName
      franchiseGroupId
      hasCatering
      hasDelivery
      hasDriveThru
      hasMobileOrdering
      lastActiveDateTime
      latitude
      longitude
      mobileOrderingStatus
      phoneNumber
      posVendor
      status
      storeNumber
    }
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    reorderCartEntries {
      ...CartEntryFragment
      isInMenu
      children {
        ...CartEntryFragment
        isInMenu
        children {
          ...CartEntryFragment
          isInMenu
          children {
            ...CartEntryFragment
            isInMenu
            children {
              ...CartEntryFragment
              isInMenu
              children {
                ...CartEntryFragment
                isInMenu
              }
            }
          }
        }
      }
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
  fulfillmentDetails {
    pickupType
    pickupPin
    pickupReady
  }
  order {
    refund {
      primaryReason
      refundedItems {
        refundAmount
        refundQuantity
        sanityId
        type
        name
        plu
      }
      secondaryReason
      subtotal
      tax
      transactionDateTime
    }
  }
}
    ${StoreHoursFragmentFragmentDoc}
${CartEntryFragmentFragmentDoc}`;
export const TransactionFragmentFragmentDoc = gql`
    fragment TransactionFragment on LoyaltyTransactionV2 {
  channel
  pointsEarned
  bonusPointsEarned
  pointsUsed
  pointsDeducted
  hasRewards
  transactionDetails {
    payments {
      amount
    }
  }
  createdAt
  additionalReferenceIds {
    id
    type
  }
}
    `;
export const RewardFragmentFragmentDoc = gql`
    fragment RewardFragment on LoyaltyReward {
  id
  rewardBenefitId
  name
  pointCost
  sanityId
  locked
  redemptionPercentage
  limitPerOrder
  remainingPointsNeededForRedemption
}
    `;
export const LoyaltyUserFragmentFragmentDoc = gql`
    fragment LoyaltyUserFragment on LoyaltyUser {
  id
  name
  points
  metadata {
    key
    value
  }
  bestPromotion {
    sanityId
  }
  pointsExpiryDateKey
  offerRedemptionAvailability {
    availableAfter
  }
  secondaryIdentifiers {
    identifier
    identifierType
  }
}
    `;
export const OffersFragmentFragmentDoc = gql`
    fragment OffersFragment on LoyaltyOffer {
  benefits {
    type
    ... on LoyaltyBenefitReference {
      reference: value
    }
    ... on LoyaltyBenefitSwap {
      value {
        ... on LoyaltySwap {
          type
          from
          to
        }
      }
    }
  }
  configId
  errors {
    code
    currentValue
    message
    ruleId
    targetValue
  }
  id
  isStackable
  metadata {
    key
    value
  }
  loyaltyId
  redemptionType
  sanityId
  templateId
  type
}
    `;
export const InvalidIncentiveFragmentFragmentDoc = gql`
    fragment InvalidIncentiveFragment on LoyaltyInvalidIncentives {
  errors {
    code
    currentValue
    message
    ruleId
    targetValue
  }
  id
}
    `;
export const LoyaltyCouponFragmentFragmentDoc = gql`
    fragment LoyaltyCouponFragment on LoyaltyCouponResponse {
  code
  isValid
  message
  reason
  isRedeemed
  shouldRedeem
  personalizedOfferId
  configId
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  order {
    refund {
      primaryReason
      refundedItems {
        refundAmount
        refundQuantity
        sanityId
        type
        name
        plu
      }
      secondaryReason
      subtotal
      tax
      transactionDateTime
    }
  }
  loyaltyTransaction {
    id
    pointsEarned
    bonusPointsEarned
    pointsUsed
    pointsBalance
    rewardsUsed
  }
  cart {
    customerName
    cartEntries {
      ...CartEntryFragment
      children {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
              }
            }
          }
        }
      }
    }
    cartVersion
    discounts {
      name
      value
    }
    donations {
      id
      name
      totalCents
    }
    fees {
      name
      priceCents
      quantity
      totalCents
    }
    offersFeedback {
      cartEntry {
        lineId
      }
      couponId
      redemptionEligibility {
        evaluationFeedback {
          code
          condition
          message
          redeemableForSeconds
          redeemableInSeconds
          ruleSetType
        }
        isRedeemable
        isValid
      }
    }
    payment {
      cardType
      ccLast4
      panToken
      paymentType
    }
    posVendor
    rewardsApplied {
      cartId
      rewardId
      timesApplied
    }
    serviceMode
    storeAddress {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    storeDetails {
      latitude
      longitude
      storeNumber
    }
    subTotalCents
    taxCents
    ticketNumber
    totalCents
    unavailableCartEntries {
      lineId
      sanityId
    }
    wasLoyaltyEarned
    vatNumber
  }
  delivery {
    pickup {
      latitude
      longitude
    }
    dropoff {
      arrivalTime
      beforeTime
      addressLine1
      addressLine2
      city
      state
      zip
      latitude
      longitude
      phoneNumber
    }
    driver {
      name
      profileImageUrl
      phoneNumber
    }
    feeCents
    feeDiscountCents
    instructions
    status
    tipCents
    serviceFeeCents
    smallCartFeeCents
    geographicalFeeCents
    quotedFeeCents
    baseDeliveryFeeCents
    deliverySurchargeFeeCents
  }
  catering {
    declineReason
    notes
    pickupTime
  }
  createdAt
  updatedAt
  posOrderId
  rbiOrderId
  status
  fireOrderIn
  orderNumberFormatted
}
    ${CartEntryFragmentFragmentDoc}`;
export const PricingAndAvailabilityFragmentDoc = gql`
    fragment PricingAndAvailability on Entity {
  id
  isAvailable
  price {
    default
    max
    min
    overrides {
      key
      price
    }
  }
}
    `;
export const CaloriesFragmentDoc = gql`
    fragment Calories on Entity {
  calories {
    default
    min
    max
  }
}
    `;
export const UpsellRecommendationsDocument = gql`
    query UpsellRecommendations($limit: Int, $products: [RecommendationProducts!]!, $storeId: String!, $serviceMode: String!, $type: RecommendationType!) @authRequired @gateway {
  upsellRecommendations(limit: $limit, products: $products, type: $type, storeId: $storeId, serviceMode: $serviceMode) {
    recommender
    recommendationToken
    results {
      id
    }
  }
}
    `;

/**
 * __useUpsellRecommendationsQuery__
 *
 * To run a query within a React component, call `useUpsellRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpsellRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpsellRecommendationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      products: // value for 'products'
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpsellRecommendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>) {
        return ApolloReactHooks.useQuery<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>(UpsellRecommendationsDocument, baseOptions);
      }
export function useUpsellRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>(UpsellRecommendationsDocument, baseOptions);
        }
export type UpsellRecommendationsQueryHookResult = ReturnType<typeof useUpsellRecommendationsQuery>;
export type UpsellRecommendationsLazyQueryHookResult = ReturnType<typeof useUpsellRecommendationsLazyQuery>;
export type UpsellRecommendationsQueryResult = ApolloReactCommon.QueryResult<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>;
export const GetOrderDocument = gql`
    query GetOrder($rbiOrderId: ID!) @gateway {
  order(rbiOrderId: $rbiOrderId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      rbiOrderId: // value for 'rbiOrderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetOrderQuery, IGetOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetOrderQuery, IGetOrderQueryVariables>(GetOrderDocument, baseOptions);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<IGetOrderQuery, IGetOrderQueryVariables>;
export const GetUserOrdersDocument = gql`
    query GetUserOrders($userId: ID, $limit: Int, $resumeAfter: String, $orderStatuses: [RbiOrderStatus!], $createdAfter: String, $shouldFilterByRegion: Boolean) @authRequired @gateway {
  userOrders(userId: $userId, limit: $limit, resumeAfter: $resumeAfter, orderStatuses: $orderStatuses, createdAfter: $createdAfter, shouldFilterByRegion: $shouldFilterByRegion) {
    count
    resumeAfter
    orders {
      ...UserOrderFragment
    }
  }
}
    ${UserOrderFragmentFragmentDoc}`;

/**
 * __useGetUserOrdersQuery__
 *
 * To run a query within a React component, call `useGetUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *      orderStatuses: // value for 'orderStatuses'
 *      createdAfter: // value for 'createdAfter'
 *      shouldFilterByRegion: // value for 'shouldFilterByRegion'
 *   },
 * });
 */
export function useGetUserOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
      }
export function useGetUserOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>(GetUserOrdersDocument, baseOptions);
        }
export type GetUserOrdersQueryHookResult = ReturnType<typeof useGetUserOrdersQuery>;
export type GetUserOrdersLazyQueryHookResult = ReturnType<typeof useGetUserOrdersLazyQuery>;
export type GetUserOrdersQueryResult = ApolloReactCommon.QueryResult<IGetUserOrdersQuery, IGetUserOrdersQueryVariables>;
export const PriceOrderDocument = gql`
    mutation PriceOrder($input: PriceOrderInput!, $delivery: PriceDeliveryInput) @authRequired @gateway {
  priceOrder(input: $input, delivery: $delivery) {
    rbiOrderId
    status
  }
}
    `;
export type IPriceOrderMutationFn = ApolloReactCommon.MutationFunction<IPriceOrderMutation, IPriceOrderMutationVariables>;

/**
 * __usePriceOrderMutation__
 *
 * To run a mutation, you first call `usePriceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceOrderMutation, { data, loading, error }] = usePriceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function usePriceOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPriceOrderMutation, IPriceOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<IPriceOrderMutation, IPriceOrderMutationVariables>(PriceOrderDocument, baseOptions);
      }
export type PriceOrderMutationHookResult = ReturnType<typeof usePriceOrderMutation>;
export type PriceOrderMutationResult = ApolloReactCommon.MutationResult<IPriceOrderMutation>;
export type PriceOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<IPriceOrderMutation, IPriceOrderMutationVariables>;
export const CommitOrderDocument = gql`
    mutation CommitOrder($input: CommitOrderInput!, $delivery: CommitDeliveryInput, $skipCoolingPeriod: Boolean) @authRequired @gateway {
  commitOrder(input: $input, delivery: $delivery, skipCoolingPeriod: $skipCoolingPeriod) {
    rbiOrderId
    status
  }
}
    `;
export type ICommitOrderMutationFn = ApolloReactCommon.MutationFunction<ICommitOrderMutation, ICommitOrderMutationVariables>;

/**
 * __useCommitOrderMutation__
 *
 * To run a mutation, you first call `useCommitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitOrderMutation, { data, loading, error }] = useCommitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *      skipCoolingPeriod: // value for 'skipCoolingPeriod'
 *   },
 * });
 */
export function useCommitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICommitOrderMutation, ICommitOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<ICommitOrderMutation, ICommitOrderMutationVariables>(CommitOrderDocument, baseOptions);
      }
export type CommitOrderMutationHookResult = ReturnType<typeof useCommitOrderMutation>;
export type CommitOrderMutationResult = ApolloReactCommon.MutationResult<ICommitOrderMutation>;
export type CommitOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ICommitOrderMutation, ICommitOrderMutationVariables>;
export const LoyaltyUserDocument = gql`
    query LoyaltyUser($loyaltyId: LoyaltyID!) @gateway {
  loyaltyUserV2(loyaltyId: $loyaltyId) {
    ...LoyaltyUserFragment
  }
}
    ${LoyaltyUserFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, baseOptions);
      }
export function useLoyaltyUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, baseOptions);
        }
export type LoyaltyUserQueryHookResult = ReturnType<typeof useLoyaltyUserQuery>;
export type LoyaltyUserLazyQueryHookResult = ReturnType<typeof useLoyaltyUserLazyQuery>;
export type LoyaltyUserQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>;
export const LoyaltyUserTransactionsDocument = gql`
    query LoyaltyUserTransactions($loyaltyId: LoyaltyID!) @gateway {
  loyaltyUserV2(loyaltyId: $loyaltyId) {
    id
    transactions(where: {statuses: [CLAIMED, PENDING], excludedChannels: [ORDERLESS]}) {
      ...TransactionFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserTransactionsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserTransactionsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, baseOptions);
      }
export function useLoyaltyUserTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, baseOptions);
        }
export type LoyaltyUserTransactionsQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsQuery>;
export type LoyaltyUserTransactionsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsLazyQuery>;
export type LoyaltyUserTransactionsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>;
export const LoyaltyUserRewardsDocument = gql`
    query LoyaltyUserRewards($loyaltyId: LoyaltyID!, $where: LoyaltyRewardsInput) @gateway {
  loyaltyUserV2(loyaltyId: $loyaltyId) {
    id
    rewards(where: $where) {
      ...RewardFragment
    }
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, baseOptions);
      }
export function useLoyaltyUserRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, baseOptions);
        }
export type LoyaltyUserRewardsQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsQuery>;
export type LoyaltyUserRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsLazyQuery>;
export type LoyaltyUserRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>;
export const LoyaltyUserOffersDocument = gql`
    query LoyaltyUserOffers($loyaltyId: LoyaltyID!, $where: LoyaltyOffersInput) @gateway {
  loyaltyUserV2(loyaltyId: $loyaltyId) {
    id
    offerRedemptionAvailability {
      availableAfter
    }
    offers(where: $where) {
      ...OffersFragment
    }
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserOffersQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, baseOptions);
      }
export function useLoyaltyUserOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, baseOptions);
        }
export type LoyaltyUserOffersQueryHookResult = ReturnType<typeof useLoyaltyUserOffersQuery>;
export type LoyaltyUserOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyUserOffersLazyQuery>;
export type LoyaltyUserOffersQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>;
export const LoyaltyOffersDocument = gql`
    query LoyaltyOffers($ids: [LoyaltyID!], $loyaltyId: LoyaltyID, $omitInvalids: Boolean, $redemptionTypes: [LoyaltyOfferRedemptionType!], $serviceMode: LoyaltyServiceMode, $storeId: String, $subtotalAmount: Int) @gateway {
  loyaltyOffersV2(ids: $ids, loyaltyId: $loyaltyId, omitInvalids: $omitInvalids, redemptionTypes: $redemptionTypes, serviceMode: $serviceMode, storeId: $storeId, subtotalAmount: $subtotalAmount) {
    ...OffersFragment
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      loyaltyId: // value for 'loyaltyId'
 *      omitInvalids: // value for 'omitInvalids'
 *      redemptionTypes: // value for 'redemptionTypes'
 *      serviceMode: // value for 'serviceMode'
 *      storeId: // value for 'storeId'
 *      subtotalAmount: // value for 'subtotalAmount'
 *   },
 * });
 */
export function useLoyaltyOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, baseOptions);
      }
export function useLoyaltyOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, baseOptions);
        }
export type LoyaltyOffersQueryHookResult = ReturnType<typeof useLoyaltyOffersQuery>;
export type LoyaltyOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersLazyQuery>;
export type LoyaltyOffersQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>;
export const LoyaltyEngineRewardsDocument = gql`
    query LoyaltyEngineRewards($loyaltyId: LoyaltyID!) @gateway {
  loyaltyRewardsV2(loyaltyId: $loyaltyId) {
    ...RewardFragment
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyEngineRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyEngineRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEngineRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyEngineRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyEngineRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, baseOptions);
      }
export function useLoyaltyEngineRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, baseOptions);
        }
export type LoyaltyEngineRewardsQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsQuery>;
export type LoyaltyEngineRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsLazyQuery>;
export type LoyaltyEngineRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>;
export const LoyaltyNotificationsRedeemableDocument = gql`
    query LoyaltyNotificationsRedeemable($loyaltyId: LoyaltyID!, $rewardsInput: LoyaltyRewardsInput, $offersInput: LoyaltyOffersInput) @gateway {
  loyaltyUserV2(loyaltyId: $loyaltyId) {
    id
    rewards(where: $rewardsInput) {
      id
    }
    promotions {
      id
    }
    offers(where: $offersInput) {
      id
    }
  }
}
    `;

/**
 * __useLoyaltyNotificationsRedeemableQuery__
 *
 * To run a query within a React component, call `useLoyaltyNotificationsRedeemableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyNotificationsRedeemableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyNotificationsRedeemableQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      rewardsInput: // value for 'rewardsInput'
 *      offersInput: // value for 'offersInput'
 *   },
 * });
 */
export function useLoyaltyNotificationsRedeemableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, baseOptions);
      }
export function useLoyaltyNotificationsRedeemableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, baseOptions);
        }
export type LoyaltyNotificationsRedeemableQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableQuery>;
export type LoyaltyNotificationsRedeemableLazyQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableLazyQuery>;
export type LoyaltyNotificationsRedeemableQueryResult = ApolloReactCommon.QueryResult<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>;
export const LoyaltyGenerateOtpDocument = gql`
    mutation LoyaltyGenerateOtp($inRestaurantOrder: [LoyaltyInRestaurantOrderLineItem!]!, $loyaltyId: LoyaltyID!, $restaurantId: LoyaltyID) @gateway {
  loyaltyGenerateOtp(inRestaurantOrder: $inRestaurantOrder, loyaltyId: $loyaltyId, restaurantId: $restaurantId) {
    password
    expirationTime
  }
}
    `;
export type ILoyaltyGenerateOtpMutationFn = ApolloReactCommon.MutationFunction<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;

/**
 * __useLoyaltyGenerateOtpMutation__
 *
 * To run a mutation, you first call `useLoyaltyGenerateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyGenerateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyGenerateOtpMutation, { data, loading, error }] = useLoyaltyGenerateOtpMutation({
 *   variables: {
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useLoyaltyGenerateOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>(LoyaltyGenerateOtpDocument, baseOptions);
      }
export type LoyaltyGenerateOtpMutationHookResult = ReturnType<typeof useLoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationResult = ApolloReactCommon.MutationResult<ILoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;
export const ProcessSmgCodeDocument = gql`
    mutation ProcessSmgCode($loyaltyId: LoyaltyID!, $smgCode: String!, $transactionDate: String) @gateway {
  loyaltyProcessSmgCode(loyaltyId: $loyaltyId, smgCode: $smgCode, transactionDate: $transactionDate) {
    pointsEarned
    status
  }
}
    `;
export type IProcessSmgCodeMutationFn = ApolloReactCommon.MutationFunction<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;

/**
 * __useProcessSmgCodeMutation__
 *
 * To run a mutation, you first call `useProcessSmgCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessSmgCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processSmgCodeMutation, { data, loading, error }] = useProcessSmgCodeMutation({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      smgCode: // value for 'smgCode'
 *      transactionDate: // value for 'transactionDate'
 *   },
 * });
 */
export function useProcessSmgCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>(ProcessSmgCodeDocument, baseOptions);
      }
export type ProcessSmgCodeMutationHookResult = ReturnType<typeof useProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationResult = ApolloReactCommon.MutationResult<IProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;
export const OrderSelectionDocument = gql`
    query orderSelection($otp: String!) @gateway {
  loyaltyOrderSelection(otp: $otp) {
    _id: loyaltyId
    status
    expiry
  }
}
    `;

/**
 * __useOrderSelectionQuery__
 *
 * To run a query within a React component, call `useOrderSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionQuery({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useOrderSelectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
        return ApolloReactHooks.useQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, baseOptions);
      }
export function useOrderSelectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, baseOptions);
        }
export type OrderSelectionQueryHookResult = ReturnType<typeof useOrderSelectionQuery>;
export type OrderSelectionLazyQueryHookResult = ReturnType<typeof useOrderSelectionLazyQuery>;
export type OrderSelectionQueryResult = ApolloReactCommon.QueryResult<IOrderSelectionQuery, IOrderSelectionQueryVariables>;
export const CreateOrderlessTransactionDocument = gql`
    mutation CreateOrderlessTransaction($input: LoyaltyOrderlessTransactionInput!) @gateway {
  loyaltyCreateOrderlessTransaction(input: $input) {
    id
  }
}
    `;
export type ICreateOrderlessTransactionMutationFn = ApolloReactCommon.MutationFunction<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>;

/**
 * __useCreateOrderlessTransactionMutation__
 *
 * To run a mutation, you first call `useCreateOrderlessTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderlessTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderlessTransactionMutation, { data, loading, error }] = useCreateOrderlessTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderlessTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>(CreateOrderlessTransactionDocument, baseOptions);
      }
export type CreateOrderlessTransactionMutationHookResult = ReturnType<typeof useCreateOrderlessTransactionMutation>;
export type CreateOrderlessTransactionMutationResult = ApolloReactCommon.MutationResult<ICreateOrderlessTransactionMutation>;
export type CreateOrderlessTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>;
export const LinkPhysicalCardToLoyaltyUserDocument = gql`
    mutation LinkPhysicalCardToLoyaltyUser($cardNumber: String!, $loyaltyUserId: LoyaltyID!) @gateway {
  loyaltyAssociateGuestUser(identifier: $cardNumber, loyaltyId: $loyaltyUserId) {
    activationDateTime
    guestBalance
    totalBalance
    linkingDateTime
  }
}
    `;
export type ILinkPhysicalCardToLoyaltyUserMutationFn = ApolloReactCommon.MutationFunction<ILinkPhysicalCardToLoyaltyUserMutation, ILinkPhysicalCardToLoyaltyUserMutationVariables>;

/**
 * __useLinkPhysicalCardToLoyaltyUserMutation__
 *
 * To run a mutation, you first call `useLinkPhysicalCardToLoyaltyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPhysicalCardToLoyaltyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPhysicalCardToLoyaltyUserMutation, { data, loading, error }] = useLinkPhysicalCardToLoyaltyUserMutation({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *      loyaltyUserId: // value for 'loyaltyUserId'
 *   },
 * });
 */
export function useLinkPhysicalCardToLoyaltyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ILinkPhysicalCardToLoyaltyUserMutation, ILinkPhysicalCardToLoyaltyUserMutationVariables>) {
        return ApolloReactHooks.useMutation<ILinkPhysicalCardToLoyaltyUserMutation, ILinkPhysicalCardToLoyaltyUserMutationVariables>(LinkPhysicalCardToLoyaltyUserDocument, baseOptions);
      }
export type LinkPhysicalCardToLoyaltyUserMutationHookResult = ReturnType<typeof useLinkPhysicalCardToLoyaltyUserMutation>;
export type LinkPhysicalCardToLoyaltyUserMutationResult = ApolloReactCommon.MutationResult<ILinkPhysicalCardToLoyaltyUserMutation>;
export type LinkPhysicalCardToLoyaltyUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ILinkPhysicalCardToLoyaltyUserMutation, ILinkPhysicalCardToLoyaltyUserMutationVariables>;
export const UnlinkPhysicalCardFromLoyaltyUserDocument = gql`
    mutation UnlinkPhysicalCardFromLoyaltyUser($cardNumber: String!) @gateway {
  loyaltyRemoveSecondaryIdAssociation(identifier: $cardNumber, identifierType: LOYALTY12DIGITSWIPECARD)
}
    `;
export type IUnlinkPhysicalCardFromLoyaltyUserMutationFn = ApolloReactCommon.MutationFunction<IUnlinkPhysicalCardFromLoyaltyUserMutation, IUnlinkPhysicalCardFromLoyaltyUserMutationVariables>;

/**
 * __useUnlinkPhysicalCardFromLoyaltyUserMutation__
 *
 * To run a mutation, you first call `useUnlinkPhysicalCardFromLoyaltyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkPhysicalCardFromLoyaltyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkPhysicalCardFromLoyaltyUserMutation, { data, loading, error }] = useUnlinkPhysicalCardFromLoyaltyUserMutation({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *   },
 * });
 */
export function useUnlinkPhysicalCardFromLoyaltyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IUnlinkPhysicalCardFromLoyaltyUserMutation, IUnlinkPhysicalCardFromLoyaltyUserMutationVariables>) {
        return ApolloReactHooks.useMutation<IUnlinkPhysicalCardFromLoyaltyUserMutation, IUnlinkPhysicalCardFromLoyaltyUserMutationVariables>(UnlinkPhysicalCardFromLoyaltyUserDocument, baseOptions);
      }
export type UnlinkPhysicalCardFromLoyaltyUserMutationHookResult = ReturnType<typeof useUnlinkPhysicalCardFromLoyaltyUserMutation>;
export type UnlinkPhysicalCardFromLoyaltyUserMutationResult = ApolloReactCommon.MutationResult<IUnlinkPhysicalCardFromLoyaltyUserMutation>;
export type UnlinkPhysicalCardFromLoyaltyUserMutationOptions = ApolloReactCommon.BaseMutationOptions<IUnlinkPhysicalCardFromLoyaltyUserMutation, IUnlinkPhysicalCardFromLoyaltyUserMutationVariables>;
export const OrderSelectionByTypeDocument = gql`
    query orderSelectionByType($key: String!, $ostType: LoyaltyOstType!) @gateway {
  loyaltyOrderSelectionByType(key: $key, ostType: $ostType) {
    _id: loyaltyId
    status
    expiry
  }
}
    `;

/**
 * __useOrderSelectionByTypeQuery__
 *
 * To run a query within a React component, call `useOrderSelectionByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionByTypeQuery({
 *   variables: {
 *      key: // value for 'key'
 *      ostType: // value for 'ostType'
 *   },
 * });
 */
export function useOrderSelectionByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>(OrderSelectionByTypeDocument, baseOptions);
      }
export function useOrderSelectionByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>(OrderSelectionByTypeDocument, baseOptions);
        }
export type OrderSelectionByTypeQueryHookResult = ReturnType<typeof useOrderSelectionByTypeQuery>;
export type OrderSelectionByTypeLazyQueryHookResult = ReturnType<typeof useOrderSelectionByTypeLazyQuery>;
export type OrderSelectionByTypeQueryResult = ApolloReactCommon.QueryResult<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>;
export const CreateOrderSelectionByTypeDocument = gql`
    mutation CreateOrderSelectionByType($ostType: LoyaltyOstType!, $inRestaurantOrder: [LoyaltyInRestaurantOrderLineItem!]!, $loyaltyId: LoyaltyID!, $restaurantId: LoyaltyID) @gateway {
  loyaltyCreateOrderSelectionByType(ostType: $ostType, inRestaurantOrder: $inRestaurantOrder, loyaltyId: $loyaltyId, restaurantId: $restaurantId) {
    expirationTime
    key
  }
}
    `;
export type ICreateOrderSelectionByTypeMutationFn = ApolloReactCommon.MutationFunction<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>;

/**
 * __useCreateOrderSelectionByTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrderSelectionByTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderSelectionByTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderSelectionByTypeMutation, { data, loading, error }] = useCreateOrderSelectionByTypeMutation({
 *   variables: {
 *      ostType: // value for 'ostType'
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateOrderSelectionByTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>(CreateOrderSelectionByTypeDocument, baseOptions);
      }
export type CreateOrderSelectionByTypeMutationHookResult = ReturnType<typeof useCreateOrderSelectionByTypeMutation>;
export type CreateOrderSelectionByTypeMutationResult = ApolloReactCommon.MutationResult<ICreateOrderSelectionByTypeMutation>;
export type CreateOrderSelectionByTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>;
export const LoyaltyRedeemPromoCodeDocument = gql`
    mutation LoyaltyRedeemPromoCode($input: LoyaltyValidatePromoCodeInput) @gateway {
  loyaltyValidatePromoCode(input: $input) {
    ...LoyaltyCouponFragment
  }
}
    ${LoyaltyCouponFragmentFragmentDoc}`;
export type ILoyaltyRedeemPromoCodeMutationFn = ApolloReactCommon.MutationFunction<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>;

/**
 * __useLoyaltyRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `useLoyaltyRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyRedeemPromoCodeMutation, { data, loading, error }] = useLoyaltyRedeemPromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyRedeemPromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>(LoyaltyRedeemPromoCodeDocument, baseOptions);
      }
export type LoyaltyRedeemPromoCodeMutationHookResult = ReturnType<typeof useLoyaltyRedeemPromoCodeMutation>;
export type LoyaltyRedeemPromoCodeMutationResult = ApolloReactCommon.MutationResult<ILoyaltyRedeemPromoCodeMutation>;
export type LoyaltyRedeemPromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>;
export const PlusDataDocument = gql`
    query plusData($storeId: ID!, $serviceMode: PosDataServiceMode) @gateway @useCache {
  plus(storeId: $storeId, serviceMode: $serviceMode) {
    plu
    price
  }
}
    `;

/**
 * __usePlusDataQuery__
 *
 * To run a query within a React component, call `usePlusDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlusDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlusDataQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *   },
 * });
 */
export function usePlusDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPlusDataQuery, IPlusDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IPlusDataQuery, IPlusDataQueryVariables>(PlusDataDocument, baseOptions);
      }
export function usePlusDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPlusDataQuery, IPlusDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPlusDataQuery, IPlusDataQueryVariables>(PlusDataDocument, baseOptions);
        }
export type PlusDataQueryHookResult = ReturnType<typeof usePlusDataQuery>;
export type PlusDataLazyQueryHookResult = ReturnType<typeof usePlusDataLazyQuery>;
export type PlusDataQueryResult = ApolloReactCommon.QueryResult<IPlusDataQuery, IPlusDataQueryVariables>;
export const StoreMenuDocument = gql`
    query storeMenu($region: String!, $channel: Channel!, $storeId: ID!, $serviceMode: PosDataServiceMode) @gateway @useCache {
  storeMenu(region: $region, channel: $channel, storeId: $storeId, serviceMode: $serviceMode) {
    ...PricingAndAvailability
    ...Calories
  }
}
    ${PricingAndAvailabilityFragmentDoc}
${CaloriesFragmentDoc}`;

/**
 * __useStoreMenuQuery__
 *
 * To run a query within a React component, call `useStoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreMenuQuery({
 *   variables: {
 *      region: // value for 'region'
 *      channel: // value for 'channel'
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *   },
 * });
 */
export function useStoreMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, baseOptions);
      }
export function useStoreMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, baseOptions);
        }
export type StoreMenuQueryHookResult = ReturnType<typeof useStoreMenuQuery>;
export type StoreMenuLazyQueryHookResult = ReturnType<typeof useStoreMenuLazyQuery>;
export type StoreMenuQueryResult = ApolloReactCommon.QueryResult<IStoreMenuQuery, IStoreMenuQueryVariables>;
export const PromotionValidatePromoCodeDocument = gql`
    mutation PromotionValidatePromoCode($code: String!, $cognitoId: String!, $shouldRedeem: Boolean, $offers: [String!]!) @gateway {
  validatePromoCode(code: $code, cognitoId: $cognitoId, shouldRedeem: $shouldRedeem, offers: $offers) {
    code
    reason
    message
    isValid
    isRedeemed
    offerId
  }
}
    `;
export type IPromotionValidatePromoCodeMutationFn = ApolloReactCommon.MutationFunction<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;

/**
 * __usePromotionValidatePromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionValidatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionValidatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionValidatePromoCodeMutation, { data, loading, error }] = usePromotionValidatePromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *      shouldRedeem: // value for 'shouldRedeem'
 *      offers: // value for 'offers'
 *   },
 * });
 */
export function usePromotionValidatePromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>(PromotionValidatePromoCodeDocument, baseOptions);
      }
export type PromotionValidatePromoCodeMutationHookResult = ReturnType<typeof usePromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationResult = ApolloReactCommon.MutationResult<IPromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;
export const PromotionRedeemPromoCodeDocument = gql`
    mutation PromotionRedeemPromoCode($code: String!, $cognitoId: String!) @gateway {
  redeemPromoCode(code: $code, cognitoId: $cognitoId) {
    code
    reason
    message
    isRedeemed
    offerId
  }
}
    `;
export type IPromotionRedeemPromoCodeMutationFn = ApolloReactCommon.MutationFunction<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;

/**
 * __usePromotionRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionRedeemPromoCodeMutation, { data, loading, error }] = usePromotionRedeemPromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *   },
 * });
 */
export function usePromotionRedeemPromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>(PromotionRedeemPromoCodeDocument, baseOptions);
      }
export type PromotionRedeemPromoCodeMutationHookResult = ReturnType<typeof usePromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationResult = ApolloReactCommon.MutationResult<IPromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;